import {
  Unit_instanceat14thlj150z as Unit_instance,
  compareTo3ankvs086tmwq as compareTo,
  coerceIn10f36k81le1mm as coerceIn,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  StringBuildermazzzhj6kkai as StringBuilder,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  Enum3alwj03lh1n41 as Enum,
  ArrayList3it5z8td81qkl as ArrayList,
  addAll1k27qatfgp3k5 as addAll,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  equals2au1ep9vhcato as equals,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  lazy2hsh8ze7j6ikd as lazy,
  binarySearchyyczvdessj07 as binarySearch,
  first58ocm7j58k3q as first,
  last1vo29oleiqj36 as last,
  getOrNull1go7ef9ldk0df as getOrNull,
  emptyList1g2z5xcrvp2zy as emptyList,
  listOfvhqybd2zx248 as listOf,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  primitiveArrayConcatwxgknw08pmlb as primitiveArrayConcat,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  protoOf180f3jzyo7rfj as protoOf,
  contentEquals5p44wfjhu6ta as contentEquals,
  contentHashCodem24x0wy7gjt7 as contentHashCode,
  contentToString28hodxfcotn0 as contentToString,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  until1jbpn0z3f8lbg as until,
  createThis2j2avj17cvnv2 as createThis,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  listOf1jh22dvmctj1r as listOf_0,
  last3s1sh0kl8j0vf as last_0,
  joinToString1cxrrlmo0chqs as joinToString,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  setPropertiesToThrowableInstance1w2jjvl9y77yc as setPropertiesToThrowableInstance,
  captureStack1fzi4aczwc4hg as captureStack,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  step18s9qzr5xwxat as step,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  numberToDouble210hrknaofnhf as numberToDouble,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trimEnd17pt8cbotbalj as trimEnd,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  uppercaseChar6lahngw3wvwg as uppercaseChar,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  toString30pk9tzaqopn as toString_0,
  Comparable198qfk8pnblz0 as Comparable,
  enumEntries20mr21zbe3az4 as enumEntries,
  replaceqbix900hl8kl as replace,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  KProperty02ce7r476m8633 as KProperty0,
  LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  IntArrayList3liuagbdnwmna as IntArrayList,
  _BSearchResult___init__impl__em6zam3kgjdixysmohf as _BSearchResult___init__impl__em6zam,
  _BSearchResult___get_found__impl__om04iz3bh6o9yjop0o as _BSearchResult___get_found__impl__om04iz,
  DoubleVectorArrayListq54dfthnqi2t as DoubleVectorArrayList,
  PointArrayList281mrsgyr6ua1 as PointArrayList,
  getCyclic28wvgqye98jqx as getCyclic,
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  sort23bpsawysis6n as sort,
  pointArrayListOf7rbgdbqf3x4b as pointArrayListOf,
  pointArrayListOf2s9je3njyg83l as pointArrayListOf_0,
  pointArrayListOf36sb9r6prgwk4 as pointArrayListOf_1,
  binarySearch1lxbagta5e4q4 as binarySearch_0,
  _BSearchResult___get_index__impl__b5kraz2d2rlh08ytgci as _BSearchResult___get_index__impl__b5kraz,
  _BSearchResult___get_nearIndex__impl__s8nq431w00iur5bsqs2 as _BSearchResult___get_nearIndex__impl__s8nq43,
  getCyclic18d9063nmuul as getCyclic_0,
  swap3upf401qn4fc8 as swap,
  rotateRight96vk8nw2c6nx as rotateRight,
  FastIntMapl0pzyavg6uw5 as FastIntMap,
  get_size3oaoh8cpamcqc as get_size,
  Pool1zbsw0zhvh8ca as Pool,
  SortOps3rp25tm4jbjru as SortOps,
  genericSort3vhmyxbppxo3h as genericSort,
  PointIntArrayList1s7gare9hr1oh as PointIntArrayList,
  ConcurrentPool3ky1e4r5za9ab as ConcurrentPool,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_0,
  _Angle___init__impl__g23q1m36yxttgnpy5tv as _Angle___init__impl__g23q1m,
  adjustFromUp1ak85cceintt4 as adjustFromUp,
  Angle__minus_impl_xeau7ko02ca30grn4a as Angle__minus_impl_xeau7k,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__plus_impl_26v37karx983dsduoy as Angle__plus_impl_26v37k,
  _Angle___get_absoluteValue__impl__4qoakv4cdwg294ssle as _Angle___get_absoluteValue__impl__4qoakv,
  Angle__umod_impl_4wilf71vq5gai237g1r as Angle__umod_impl_4wilf7,
  Angle__compareTo_impl_a0hfds24obl4qqhxk1t as Angle__compareTo_impl_a0hfds,
  _Angle___get_ratio__impl__ap3on435dv91f5cbp85 as _Angle___get_ratio__impl__ap3on4,
  interpolatewhd2sgxffql5 as interpolate,
  Angle_between72970e1vlen9 as Angle_between,
  Angle__cosine_impl_bgvzun1b2925dagclby as Angle__cosine_impl_bgvzun,
  Angle__sine_impl_3l11xv3pgl8zzgp52i0 as Angle__sine_impl_3l11xv,
  interpolateAngleDenormalized1hkwzk523mo1c as interpolateAngleDenormalized,
  transformY3ktoxhxwkzwk1 as transformY,
  transformX33nszy4vzqsfy as transformX,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_1,
  Line2D2pf35pcx71ncp as Line2D,
  Angle2itorpob18n08 as Angle,
  outerCircle30hn5vvbpz9gu as outerCircle,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_2,
  Angle__times_impl_v3s9y220yjbrxc13c3b as Angle__times_impl_v3s9y2,
  _Angle___get_normalized__impl__9s30ys1q15xt9x23bx as _Angle___get_normalized__impl__9s30ys,
  _Angle___get_radians__impl__n00yt518seywpfbf9fr as _Angle___get_radians__impl__n00yt5,
  Angle__times_impl_v3s9y21yznxo5bj1uj7 as Angle__times_impl_v3s9y2_0,
  Angle__div_impl_ut2btd1qmy7ftoy1opp as Angle__div_impl_ut2btd,
  _Angle___get_cosine__impl__vprvmu3ab5uwcliuboq as _Angle___get_cosine__impl__vprvmu,
  _Angle___get_sine__impl__15nmyi39oh4tio4auz1 as _Angle___get_sine__impl__15nmyi,
  _Angle___get_tangent__impl__vushdy2zy6w59e4l7qg as _Angle___get_tangent__impl__vushdy,
  Size2Dum5ayuyhhau7 as Size2D,
  Rectangle3q03woyn9k8x1 as Rectangle,
  Companion_getInstancenbeyvbsm21qs as Companion_getInstance_3,
  BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3 as BoundsBuilder__plus_impl_cz7f7x,
  Companion_getInstance2yu48324co92b as Companion_getInstance_4,
  _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i as _BoundsBuilder___get_bounds__impl__s1l1gx,
  Vector2I2k5512l4eeahb as Vector2I,
  toIntu0rc68akxu7a as toInt,
  Angle__unaryPlus_impl_eyi5plrfyn5fslhvdp as Angle__unaryPlus_impl_eyi5pl,
  Angle__unaryMinus_impl_7901fruk5m76f5kg06 as Angle__unaryMinus_impl_7901fr,
  minus35u9jfp5de3x as minus,
  BoundsBuilder162uwsje56mvu as BoundsBuilder,
  BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm as BoundsBuilder__plus_impl_cz7f7x_0,
  Matrix1p940sdz227jj as Matrix,
  Companion_getInstance3qti4zygy7usz as Companion_getInstance_5,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_6,
  _Ratio___get_absoluteValue__impl__92ozif2q8z2akxn3hd8 as _Ratio___get_absoluteValue__impl__92ozif,
  Ratio__times_impl_ucdh7y2x1w5kf040xma as Ratio__times_impl_ucdh7y,
  toRatioClampedeq87m2alw3kr as toRatioClamped,
  toRatioa3v13oich5q as toRatio,
  toRatio1hooqit5gulhr as toRatio_0,
  Ratio136tf4z2t0p2d as Ratio,
  clamp1qclpmpfxm7xb as clamp,
  _Ratio___init__impl__9mwvn2xyj9fjgana63 as _Ratio___init__impl__9mwvn2,
  Ratio__compareTo_impl_z2iencsp0le8uhwq33 as Ratio__compareTo_impl_z2ienc,
  convertRange139vj18oahy2c as convertRange,
  Ratio__minus_impl_s1uwyg39ebtqskl4ycn as Ratio__minus_impl_s1uwyg,
  Ratio__toDouble_impl_o7epze2ppsc3gplivz8 as Ratio__toDouble_impl_o7epze,
  Ratio__times_impl_ucdh7yuy2trpt4sqvt as Ratio__times_impl_ucdh7y_0,
  _Ratio___get_value__impl__57cli6w1n0arietzij as _Ratio___get_value__impl__57cli6,
  normalizeZero2ksfd6bzt4qwz as normalizeZero,
  isAlmostEquals18m8qk24p7w0q as isAlmostEquals,
  isAlmostEquals2e7wogp48cvmj as isAlmostEquals_0,
  isAlmostEquals$default2ib7nwup21mfy as isAlmostEquals$default,
  Ratio__toString_impl_mfgt3e2iqv27qr9i5ak as Ratio__toString_impl_mfgt3e,
  Ratio__hashCode_impl_quhc2v2f99yx2uv51mf as Ratio__hashCode_impl_quhc2v,
  IsAlmostEquals2vs54x7i426j2 as IsAlmostEquals,
  isAlmostZero7baqs51et9hm as isAlmostZero,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  convertRange1a6ancvyn151r as convertRange_0,
  interpolate2g7wzskc23f1q as interpolate_0,
  interpolate35pbs3ac913y4 as interpolate_1,
  _Ratio___init__impl__9mwvn224skkn3fz6cfs as _Ratio___init__impl__9mwvn2_0,
  umod164hvijxhfi8p as umod,
  extract2vhru1ihy4ogl as extract,
  insertm9bp9ll4cml3 as insert,
  insert2fz5125p2hdyd as insert_0,
  clamp31lhm66c28ic8 as clamp_0,
  Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_7,
  invoke3idfsdzzpzmqq as invoke,
  invoke1y68e7g1lbvl5 as invoke_0,
  Easing3266vfl8a4o75 as Easing,
  toRatiolga1a9coidva as toRatio_1,
  clampdicp8njiht45 as clamp_1,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  setExtra314k0z6q35eku as setExtra,
  Mixin3lmkm5hum2vdj as Mixin,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  hasExtra1969mplo13qgb as hasExtra,
  Property1m5vulkepgwzd as Property,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
//endregion
//region block: pre-declaration
class IntSegmentSet {
  constructor() {
    this.a38_1 = IntArrayList.x2j(16);
    this.b38_1 = IntArrayList.x2j(16);
  }
  d1() {
    return this.a38_1.d1();
  }
  g1() {
    return this.d1() === 0;
  }
  m28() {
    return this.d1() > 0;
  }
  xg() {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.clear.<anonymous>' call
    this.a38_1.y2();
    this.b38_1.y2();
    return this;
  }
  c38() {
    return this.m28() ? this.a38_1.s1i(0) : 0;
  }
  d38() {
    return this.m28() ? this.b38_1.s1i(this.b38_1.d1() - 1 | 0) : 0;
  }
  e38(x) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = 0;
      var high = this.d1() - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.findNearIndex.<anonymous>' call
        var min = this.a38_1.s1i(mid);
        var max = this.b38_1.s1i(mid);
        var mval = x < min ? 1 : x > max ? -1 : 0;
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$1 = mid;
          break $l$block;
        }
      }
      // Inline function 'korlibs.datastructure.genericBinarySearch.<anonymous>' call
      tmp$ret$1 = (-low | 0) - 1 | 0;
    }
    return _BSearchResult___init__impl__em6zam(tmp$ret$1);
  }
  f38(x) {
    // Inline function 'korlibs.math.segment.genericBinarySearchLeft' call
    var toIndex = this.d1();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = 0;
      var high = toIndex - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.findLeftBound.<anonymous>' call
        var mval = compareTo(this.a38_1.s1i(mid), x);
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$1 = mid;
          break $l$block;
        }
      }
      // Inline function 'korlibs.math.segment.genericBinarySearchLeft.<anonymous>' call
      var low_0 = low;
      // Inline function 'kotlin.math.min' call
      var b = high;
      var tmp$ret$2 = Math.min(low_0, b);
      tmp$ret$1 = coerceIn(tmp$ret$2, 0, toIndex - 1 | 0);
    }
    var tmp$ret$4 = tmp$ret$1;
    return coerceIn(tmp$ret$4, 0, this.d1() - 1 | 0);
  }
  g38(x) {
    // Inline function 'korlibs.math.segment.genericBinarySearchRight' call
    var toIndex = this.d1();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = 0;
      var high = toIndex - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.findRightBound.<anonymous>' call
        var mval = compareTo(this.b38_1.s1i(mid), x);
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$1 = mid;
          break $l$block;
        }
      }
      // Inline function 'korlibs.math.segment.genericBinarySearchRight.<anonymous>' call
      var low_0 = low;
      // Inline function 'kotlin.math.max' call
      var b = high;
      var tmp$ret$2 = Math.max(low_0, b);
      tmp$ret$1 = coerceIn(tmp$ret$2, 0, toIndex - 1 | 0);
    }
    var tmp$ret$4 = tmp$ret$1;
    return coerceIn(tmp$ret$4, 0, this.d1() - 1 | 0);
  }
  y2r(min, max) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    $l$block_0: {
      // Inline function 'korlibs.math.segment.IntSegmentSet.add.<anonymous>' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(min <= max)) {
        // Inline function 'kotlin.check.<anonymous>' call
        var message = 'Check failed.';
        throw IllegalStateException.s4(toString(message));
      }
      if (this.g1()) {
        insertAt(this, this.d1(), min, max);
      } else if (min === this.d38()) {
        this.b38_1.i2k(this.b38_1.d1() - 1 | 0, max);
      } else if (max === this.c38()) {
        this.a38_1.i2k(0, min);
      } else {
        var removeStart = -1;
        var removeCount = -1;
        $l$block: {
          // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEachInterestingRange' call
          if (this.g1()) {
            break $l$block;
          }
          var nmin = this.f38(min);
          var nmax = this.g38(max);
          var inductionVariable = nmin;
          if (inductionVariable <= nmax)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'korlibs.math.segment.IntSegmentSet.add.<anonymous>.<anonymous>' call
              var n_0 = n;
              var x1 = this.a38_1.s1i(n);
              var x2 = this.b38_1.s1i(n);
              if (this.h38(x1, x2, min, max)) {
                if (removeStart === -1)
                  removeStart = n_0;
                var tmp = removeStart;
                // Inline function 'kotlin.math.min' call
                var a = this.a38_1.s1i(removeStart);
                // Inline function 'kotlin.math.min' call
                var b = Math.min(x1, min);
                var tmp$ret$3 = Math.min(a, b);
                this.a38_1.i2k(tmp, tmp$ret$3);
                var tmp_0 = removeStart;
                // Inline function 'kotlin.math.max' call
                var a_0 = this.b38_1.s1i(removeStart);
                // Inline function 'kotlin.math.max' call
                var b_0 = Math.max(x2, max);
                var tmp$ret$5 = Math.max(a_0, b_0);
                this.b38_1.i2k(tmp_0, tmp$ret$5);
                removeCount = removeCount + 1 | 0;
              }
            }
             while (!(n === nmax));
        }
        if (removeCount !== 0)
          if (removeCount > 0) {
            removeAt(this, removeStart + 1 | 0, removeCount);
          } else if (max < this.c38()) {
            insertAt(this, 0, min, max);
          } else if (min > this.d38()) {
            insertAt(this, this.d1(), min, max);
          } else {
            var inductionVariable_0 = coerceAtLeast(this.f38(min), 1);
            var last = this.g38(max);
            if (inductionVariable_0 <= last)
              do {
                var m = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var prevMax = this.b38_1.s1i(m - 1 | 0);
                var currMin = this.a38_1.s1i(m);
                if (min > prevMax && max < currMin) {
                  insertAt(this, m, min, max);
                  break $l$block_0;
                }
              }
               while (!(m === last));
            // Inline function 'kotlin.error' call
            var message_0 = 'Unexpected';
            throw IllegalStateException.s4(toString(message_0));
          }
      }
    }
    return this;
  }
  wo(v) {
    return _BSearchResult___get_found__impl__om04iz(this.e38(v));
  }
  i38(a, b) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.setToIntersect.<anonymous>' call
    var aSmaller = a.d1() < b.d1();
    var av = aSmaller ? a : b;
    var bv = aSmaller ? b : a;
    // Inline function 'kotlin.also' call
    this.xg();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.setToIntersect.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
    var inductionVariable = 0;
    var last = av.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.setToIntersect.<anonymous>.<anonymous>.<anonymous>' call
        var x1 = av.a38_1.s1i(n);
        // Inline function 'korlibs.math.segment.IntSegmentSet.intersection' call
        var max = av.b38_1.s1i(n);
        var count = 0;
        $l$block: {
          // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEachInterestingRange' call
          if (bv.g1()) {
            break $l$block;
          }
          var nmin = bv.f38(x1);
          var nmax = bv.g38(max);
          var inductionVariable_0 = nmin;
          if (inductionVariable_0 <= nmax)
            do {
              var n_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              // Inline function 'korlibs.math.segment.IntSegmentSet.intersection.<anonymous>' call
              var x1_0 = bv.a38_1.s1i(n_0);
              var x2 = bv.b38_1.s1i(n_0);
              if (bv.h38(x1_0, x2, x1, max)) {
                // Inline function 'korlibs.math.segment.IntSegmentSet.setToIntersect.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.math.max' call
                var min = Math.max(x1_0, x1);
                // Inline function 'kotlin.math.min' call
                var max_0 = Math.min(x2, max);
                this.y2r(min, max_0);
                count = count + 1 | 0;
              }
            }
             while (!(n_0 === nmax));
        }
      }
       while (inductionVariable < last);
    return this;
  }
  h38(x1, x2, y1, y2) {
    return x2 >= y1 && y2 >= x1;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.toString.<anonymous>' call
    this_0.nb('[');
    // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
    var inductionVariable = 0;
    var last = this.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.toString.<anonymous>.<anonymous>' call
        var min = this.a38_1.s1i(n);
        var max = this.b38_1.s1i(n);
        var first = n === 0;
        if (!first) {
          this_0.nb(', ');
        }
        this_0.nb('' + min + '-' + max);
      }
       while (inductionVariable < last);
    this_0.nb(']');
    return this_0.toString();
  }
}
class StrokePointsMode extends Enum {}
class StrokePointsBuilder {
  constructor(width, mode, generateDebug) {
    mode = mode === VOID ? StrokePointsMode_NON_SCALABLE_POS_getInstance() : mode;
    generateDebug = generateDebug === VOID ? false : generateDebug;
    this.t38_1 = width;
    this.u38_1 = mode;
    this.v38_1 = generateDebug;
    this.w38_1 = 20;
    var tmp = this;
    var tmp_0;
    switch (this.u38_1.k3_1) {
      case 0:
        tmp_0 = 6;
        break;
      case 1:
        tmp_0 = 2;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.x38_1 = new DoubleVectorArrayList(tmp_0);
    this.y38_1 = new PointArrayList();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_1.z38_1 = ArrayList.i1();
  }
  b39() {
    return this.x38_1;
  }
  toString() {
    return 'StrokePointsBuilder(' + this.t38_1 + ', ' + this.x38_1.toString() + ')';
  }
  c39(pos, normal, width, maxWidth) {
    switch (this.u38_1.k3_1) {
      case 0:
        // Inline function 'kotlin.math.absoluteValue' call

        var tmp$ret$0 = Math.abs(maxWidth);
        this.x38_1.y2k(pos.c26_1, pos.d26_1, normal.c26_1, normal.d26_1, width, tmp$ret$0);
        break;
      case 1:
        this.x38_1.w2k(pos.c26_1 + normal.c26_1 * width, pos.d26_1 + normal.d26_1 * width);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  d39(pos, normal, width, maxWidth, $super) {
    maxWidth = maxWidth === VOID ? width : maxWidth;
    var tmp;
    if ($super === VOID) {
      this.c39(pos, normal, width, maxWidth);
      tmp = Unit_instance;
    } else {
      tmp = $super.c39.call(this, pos, normal, width, maxWidth);
    }
    return tmp;
  }
  e39(center, pos, sign) {
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var dist = Vector2D.l28(pos.c26_1 - center.c26_1, pos.d26_1 - center.d26_1);
    var tmp;
    if (sign < 0.0) {
      // Inline function 'korlibs.math.geom.Vector2D.unaryMinus' call
      tmp = Vector2D.l28(-dist.c26_1, -dist.d26_1);
    } else {
      tmp = dist;
    }
    var normal = tmp;
    this.d39(center, normal.u2h(), dist.a() * sign);
  }
  f39(center, pos, sign, $super) {
    sign = sign === VOID ? 1.0 : sign;
    var tmp;
    if ($super === VOID) {
      this.e39(center, pos, sign);
      tmp = Unit_instance;
    } else {
      tmp = $super.e39.call(this, center, pos, sign);
    }
    return tmp;
  }
  g39(pos, normal, width) {
    this.d39(pos, normal, width);
    this.d39(pos, normal, -width);
  }
  h39(curr, next, kind, miterLimitRatio) {
    var commonPoint = curr.i39(Companion_getInstance_6().p1i_1);
    var currTangent = curr.j39(Companion_getInstance_6().p1i_1);
    var currNormal = curr.k39(Companion_getInstance_6().p1i_1);
    var nextTangent = next.j39(Companion_getInstance_6().m1i_1);
    var nextNormal = next.k39(Companion_getInstance_6().m1i_1);
    var tmp = Companion_instance_15;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale = this.t38_1;
    var that = Vector2D.l28(currNormal.c26_1 * scale, currNormal.d26_1 * scale);
    var tmp$ret$1 = Vector2D.l28(commonPoint.c26_1 + that.c26_1, commonPoint.d26_1 + that.d26_1);
    var currLine0 = tmp.l39(tmp$ret$1, currTangent);
    var tmp_0 = Companion_instance_15;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale_0 = -this.t38_1;
    var that_0 = Vector2D.l28(currNormal.c26_1 * scale_0, currNormal.d26_1 * scale_0);
    var tmp$ret$3 = Vector2D.l28(commonPoint.c26_1 + that_0.c26_1, commonPoint.d26_1 + that_0.d26_1);
    var currLine1 = tmp_0.l39(tmp$ret$3, currTangent);
    var tmp_1 = Companion_instance_15;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale_1 = this.t38_1;
    var that_1 = Vector2D.l28(nextNormal.c26_1 * scale_1, nextNormal.d26_1 * scale_1);
    var tmp$ret$5 = Vector2D.l28(commonPoint.c26_1 + that_1.c26_1, commonPoint.d26_1 + that_1.d26_1);
    var nextLine0 = tmp_1.l39(tmp$ret$5, nextTangent);
    var tmp_2 = Companion_instance_15;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale_2 = -this.t38_1;
    var that_2 = Vector2D.l28(nextNormal.c26_1 * scale_2, nextNormal.d26_1 * scale_2);
    var tmp$ret$7 = Vector2D.l28(commonPoint.c26_1 + that_2.c26_1, commonPoint.d26_1 + that_2.d26_1);
    var nextLine1 = tmp_2.l39(tmp$ret$7, nextTangent);
    var intersection0 = lineIntersectionPoint(Companion_instance_15, currLine0, nextLine0);
    var intersection1 = lineIntersectionPoint(Companion_instance_15, currLine1, nextLine1);
    if (intersection0 == null || intersection1 == null) {
      this.g39(commonPoint, currNormal, this.t38_1);
      return Unit_instance;
    }
    var direction = Companion_getInstance().p2h(currTangent, nextTangent);
    var miterLength = Companion_getInstance().m2h(intersection0, intersection1);
    var miterLimit = miterLimitRatio * this.t38_1;
    // Inline function 'korlibs.math.geom.Companion.atan2' call
    Companion_getInstance_0();
    var up = Companion_getInstance().i26_1;
    // Inline function 'korlibs.math.geom.Companion.atan2' call
    var x = nextTangent.c26_1;
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    // Inline function 'kotlin.math.atan2' call
    var x_0 = nextTangent.d26_1;
    var radians = Math.atan2(x, x_0);
    var tmp$ret$9 = _Angle___init__impl__g23q1m(radians);
    var tmp_3 = adjustFromUp(tmp$ret$9, up);
    // Inline function 'korlibs.math.geom.Companion.atan2' call
    Companion_getInstance_0();
    var up_0 = Companion_getInstance().i26_1;
    // Inline function 'korlibs.math.geom.Companion.atan2' call
    var x_1 = currTangent.c26_1;
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    // Inline function 'kotlin.math.atan2' call
    var x_2 = currTangent.d26_1;
    var radians_0 = Math.atan2(x_1, x_2);
    var tmp$ret$13 = _Angle___init__impl__g23q1m(radians_0);
    var tmp$ret$15 = adjustFromUp(tmp$ret$13, up_0);
    var angle = Angle__minus_impl_xeau7k(tmp_3, tmp$ret$15);
    if (!kind.equals(LineJoin_MITER_getInstance()) || miterLength > miterLimit) {
      var p1 = direction <= 0.0 ? projectedPoint(currLine0, commonPoint) : projectedPoint(nextLine1, commonPoint);
      var p2 = direction <= 0.0 ? projectedPoint(nextLine0, commonPoint) : projectedPoint(currLine1, commonPoint);
      var p3 = direction <= 0.0 ? lineIntersectionPoint(Companion_instance_15, currLine1, nextLine1) : lineIntersectionPoint(Companion_instance_15, currLine0, nextLine0);
      var p4Line = direction < 0.0 ? nextLine1 : nextLine0;
      var p4 = projectedPoint(p4Line, commonPoint);
      if (p3 == null) {
        p3 = p4;
      }
      var angleB = _Angle___get_absoluteValue__impl__4qoakv(Angle__plus_impl_26v37k(angle, get_degrees(180)));
      var angle2 = _Angle___get_absoluteValue__impl__4qoakv(Angle__umod_impl_4wilf7(angle, get_degrees(180)));
      var angle3 = Angle__compareTo_impl_a0hfds(angle2, get_degrees(90)) >= 0 ? Angle__minus_impl_xeau7k(get_degrees(180), angle2) : angle2;
      var ratio = toRatioClamped(Ratio__times_impl_ucdh7y(_Ratio___get_absoluteValue__impl__92ozif(_Angle___get_ratio__impl__ap3on4(angle3)), 4.0));
      var p5 = interpolate(toRatio(ratio), p4, ensureNotNull(p3));
      if (this.v38_1) {
        this.z38_1.h(nextLine1.o39(1000.0).u1i());
        this.z38_1.h(currLine1.o39(1000.0).u1i());
        this.z38_1.h(nextLine0.o39(1000.0).u1i());
        this.z38_1.h(currLine0.o39(1000.0).u1i());
        this.z38_1.h(Companion_instance_15.l39(commonPoint, currTangent).o39(1000.0).u1i());
        this.z38_1.h(Companion_instance_15.l39(commonPoint, nextTangent).o39(1000.0).u1i());
        this.y38_1.j2r(p3);
        this.y38_1.j2r(p4);
        this.y38_1.j2r(p5);
      }
      var p6 = p5;
      if (direction < 0.0) {
        this.f39(commonPoint, p1);
        this.e39(commonPoint, p6, -1.0);
        this.f39(commonPoint, p2);
        this.e39(commonPoint, p6, -1.0);
      } else {
        this.f39(commonPoint, p6);
        this.e39(commonPoint, p2, -1.0);
        this.f39(commonPoint, p6);
        this.e39(commonPoint, p1, -1.0);
      }
      return Unit_instance;
    }
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var d0 = Vector2D.l28(intersection0.c26_1 - commonPoint.c26_1, intersection0.d26_1 - commonPoint.d26_1);
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var d1 = Vector2D.l28(commonPoint.c26_1 - intersection1.c26_1, commonPoint.d26_1 - intersection1.d26_1);
    var tmp_4 = d0.u2h();
    var tmp_5 = d0.a();
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = d0.a();
    var tmp$ret$18 = Math.abs(this_0);
    this.c39(commonPoint, tmp_4, tmp_5, tmp$ret$18);
    var tmp_6 = d1.u2h();
    var tmp_7 = -d1.a();
    // Inline function 'kotlin.math.absoluteValue' call
    var this_1 = d1.a();
    var tmp$ret$19 = Math.abs(this_1);
    this.c39(commonPoint, tmp_6, tmp_7, tmp$ret$19);
  }
  p39(curr, ratio, kind) {
    switch (kind.k3_1) {
      case 1:
      case 2:
        // Inline function 'kotlin.let' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.math.geom.bezier.StrokePointsBuilder.addCap.<anonymous>' call

        var it = curr.k39(ratio).w2h();
        var tmp;
        if (equals(ratio, Companion_getInstance_6().p1i_1)) {
          // Inline function 'korlibs.math.geom.Vector2D.unaryMinus' call
          tmp = Vector2D.l28(-it.c26_1, -it.d26_1);
        } else {
          tmp = it;
        }

        var derivate = tmp;
        switch (kind.k3_1) {
          case 1:
            // Inline function 'korlibs.math.geom.Vector2D.plus' call

            var this_0 = curr.i39(ratio);
            // Inline function 'korlibs.math.geom.Vector2D.times' call

            var scale = this.t38_1;
            var that = Vector2D.l28(derivate.c26_1 * scale, derivate.d26_1 * scale);
            var tmp$ret$4 = Vector2D.l28(this_0.c26_1 + that.c26_1, this_0.d26_1 + that.d26_1);
            this.g39(tmp$ret$4, curr.k39(ratio), this.t38_1);
            break;
          case 2:
            var mid = curr.i39(ratio);
            var normal = curr.k39(ratio);
            // Inline function 'korlibs.math.geom.Vector2D.plus' call

            // Inline function 'korlibs.math.geom.Vector2D.times' call

            var scale_0 = this.t38_1;
            var that_0 = Vector2D.l28(normal.c26_1 * scale_0, normal.d26_1 * scale_0);
            var p0 = Vector2D.l28(mid.c26_1 + that_0.c26_1, mid.d26_1 + that_0.d26_1);
            // Inline function 'korlibs.math.geom.Vector2D.plus' call

            // Inline function 'korlibs.math.geom.Vector2D.times' call

            var scale_1 = -this.t38_1;
            var that_1 = Vector2D.l28(normal.c26_1 * scale_1, normal.d26_1 * scale_1);
            var p3 = Vector2D.l28(mid.c26_1 + that_1.c26_1, mid.d26_1 + that_1.d26_1);
            var a = equals(ratio, Companion_getInstance_6().m1i_1) ? p0 : p3;
            var b = equals(ratio, Companion_getInstance_6().m1i_1) ? p3 : p0;
            this.q39(a, b, ratio, mid);
            break;
          default:
            // Inline function 'kotlin.error' call

            var message = "Can't happen";
            throw IllegalStateException.s4(toString(message));
        }

        break;
      case 0:
        this.g39(curr.i39(ratio), curr.k39(ratio), this.t38_1);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  r39(p0, p3, ratio, mid, nsteps) {
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var up = Companion_getInstance().i26_1;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var x0 = mid.c26_1;
    var y0 = mid.d26_1;
    var x1 = p0.c26_1;
    var y1 = p0.d26_1;
    var angleStart = Angle_between(x0, y0, x1, y1, up);
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var up_0 = Companion_getInstance().i26_1;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var x0_0 = mid.c26_1;
    var y0_0 = mid.d26_1;
    var x1_0 = p3.c26_1;
    var y1_0 = p3.d26_1;
    var angleEnd = Angle_between(x0_0, y0_0, x1_0, y1_0, up_0);
    if (equals(ratio, Companion_getInstance_6().p1i_1)) {
      // Inline function 'korlibs.math.geom.Companion.polar' call
      // Inline function 'korlibs.math.geom.Companion.polar' call
      var up_1 = Companion_getInstance().i26_1;
      var tmp$ret$8 = Vector2D.l28(0.0 + Angle__cosine_impl_bgvzun(angleEnd, up_1) * 1.0, 0.0 + Angle__sine_impl_3l11xv(angleEnd, up_1) * 1.0);
      this.g39(mid, tmp$ret$8, this.t38_1);
    }
    var addAngle = Companion_getInstance().p2h(p0, p3) <= 0.0 ? Companion_getInstance_0().t25_1 : Companion_getInstance_0().v25_1;
    // Inline function 'korlibs.math.interpolation.Companion.forEachRatio' call
    Companion_getInstance_6();
    var NS = nsteps - 1 | 0;
    var NSd = NS;
    var start = true ? 0 : 1;
    var end = true ? NS : NS - 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ratio_0 = n / NSd;
        // Inline function 'korlibs.math.geom.bezier.StrokePointsBuilder.addCurvePointsCap.<anonymous>' call
        var it = toRatio_0(ratio_0);
        var angle = interpolateAngleDenormalized(it, angleStart, angleEnd);
        // Inline function 'korlibs.math.geom.Companion.polar' call
        var this_0 = Companion_getInstance();
        var angle_0 = Angle__plus_impl_26v37k(angle, addAngle);
        // Inline function 'korlibs.math.geom.Companion.polar' call
        var up_2 = this_0.i26_1;
        var dir = Vector2D.l28(0.0 + Angle__cosine_impl_bgvzun(angle_0, up_2) * 1.0, 0.0 + Angle__sine_impl_3l11xv(angle_0, up_2) * 1.0);
        this.c39(mid, dir, 0.0, this.t38_1);
        this.c39(mid, dir, this.t38_1, this.t38_1);
      }
       while (!(n === end));
    if (equals(ratio, Companion_getInstance_6().m1i_1)) {
      // Inline function 'korlibs.math.geom.Companion.polar' call
      // Inline function 'korlibs.math.geom.Companion.polar' call
      var up_3 = Companion_getInstance().i26_1;
      var tmp$ret$12 = Vector2D.l28(0.0 + Angle__cosine_impl_bgvzun(angleStart, up_3) * 1.0, 0.0 + Angle__sine_impl_3l11xv(angleStart, up_3) * 1.0);
      this.g39(mid, tmp$ret$12, this.t38_1);
    }
  }
  q39(p0, p3, ratio, mid, nsteps, $super) {
    var tmp;
    if (mid === VOID) {
      // Inline function 'korlibs.math.geom.Companion.middle' call
      Companion_getInstance();
      // Inline function 'korlibs.math.geom.Vector2D.times' call
      // Inline function 'korlibs.math.geom.Vector2D.plus' call
      var this_0 = Vector2D.l28(p0.c26_1 + p3.c26_1, p0.d26_1 + p3.d26_1);
      tmp = Vector2D.l28(this_0.c26_1 * 0.5, this_0.d26_1 * 0.5);
    } else {
      tmp = mid;
    }
    mid = tmp;
    nsteps = nsteps === VOID ? this.w38_1 : nsteps;
    var tmp_0;
    if ($super === VOID) {
      this.r39(p0, p3, ratio, mid, nsteps);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.r39.call(this, p0, p3, new Ratio(ratio), mid, nsteps);
    }
    return tmp_0;
  }
  s39(curr, nsteps) {
    // Inline function 'korlibs.math.interpolation.Companion.forEachRatio' call
    Companion_getInstance_6();
    var NS = nsteps - 1 | 0;
    var NSd = NS;
    var start = false ? 0 : 1;
    var end = false ? NS : NS - 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ratio = n / NSd;
        // Inline function 'korlibs.math.geom.bezier.StrokePointsBuilder.addCurvePoints.<anonymous>' call
        var it = toRatio_0(ratio);
        this.g39(curr.i39(it), curr.k39(it), this.t38_1);
      }
       while (!(n === end));
  }
  t39(curr, nsteps, $super) {
    nsteps = nsteps === VOID ? numberToInt(clamp(curr.a() / 10.0, 10.0, 100.0)) : nsteps;
    var tmp;
    if ($super === VOID) {
      this.s39(curr, nsteps);
      tmp = Unit_instance;
    } else {
      tmp = $super.s39.call(this, curr, nsteps);
    }
    return tmp;
  }
  a39(curves, join, startCap, endCap, miterLimit, forceClosed) {
    var closed = forceClosed == null ? curves.w39_1 : forceClosed;
    var curves_0 = curves.v39_1;
    var inductionVariable = 0;
    var last = curves_0.d1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var curr = getCyclic(curves_0, n + 0 | 0);
        var next = getCyclic(curves_0, n + 1 | 0);
        if (n === 0) {
          if (closed) {
            this.h39(getCyclic(curves_0, n - 1 | 0), curr, join, miterLimit);
          } else {
            this.p39(curr, Companion_getInstance_6().m1i_1, startCap);
          }
        }
        if (!(curr.m3a() === 1)) {
          this.t39(curr);
        }
        if (n < (curves_0.d1() - 1 | 0)) {
          this.h39(curr, next, join, miterLimit);
        } else {
          if (closed) {
            this.h39(curr, next, join, miterLimit);
          } else {
            this.p39(curr, Companion_getInstance_6().p1i_1, endCap);
          }
        }
      }
       while (inductionVariable <= last);
  }
}
class CurveInfo {
  constructor(index, curve, startLength, endLength, bounds) {
    this.n3a_1 = index;
    this.o3a_1 = curve;
    this.p3a_1 = startLength;
    this.q3a_1 = endLength;
    this.r3a_1 = bounds;
  }
  v1i(length) {
    var containsLower = this.p3a_1;
    return length <= this.q3a_1 ? containsLower <= length : false;
  }
  a() {
    return this.q3a_1 - this.p3a_1;
  }
  toString() {
    return 'CurveInfo(index=' + this.n3a_1 + ', curve=' + this.o3a_1.toString() + ', startLength=' + this.p3a_1 + ', endLength=' + this.q3a_1 + ', bounds=' + this.r3a_1.toString() + ')';
  }
  hashCode() {
    var result = this.n3a_1;
    result = imul(result, 31) + this.o3a_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.p3a_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q3a_1) | 0;
    result = imul(result, 31) + this.r3a_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CurveInfo))
      return false;
    var tmp0_other_with_cast = other instanceof CurveInfo ? other : THROW_CCE();
    if (!(this.n3a_1 === tmp0_other_with_cast.n3a_1))
      return false;
    if (!this.o3a_1.equals(tmp0_other_with_cast.o3a_1))
      return false;
    if (!equals(this.p3a_1, tmp0_other_with_cast.p3a_1))
      return false;
    if (!equals(this.q3a_1, tmp0_other_with_cast.q3a_1))
      return false;
    if (!this.r3a_1.equals(tmp0_other_with_cast.r3a_1))
      return false;
    return true;
  }
}
class Curves {
  constructor(beziers, closed) {
    this.u39_1 = new Mixin();
    this.v39_1 = beziers;
    this.w39_1 = closed;
    this.x39_1 = false;
    var tmp = this;
    tmp.y39_1 = lazy(Curves$contiguous$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.z39_1 = lazy(Curves$infos$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.a3a_1 = lazy(Curves$length$delegate$lambda(this));
  }
  y1i(_set____db54di) {
    this.u39_1.y1i(_set____db54di);
  }
  z1i() {
    return this.u39_1.z1i();
  }
  t3a() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z39_1;
    infos$factory();
    return this_0.o1();
  }
  a() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.a3a_1;
    length$factory();
    return this_0.o1();
  }
  u3a(_this__u8e3s4) {
    return _Ratio___init__impl__9mwvn2(_this__u8e3s4.p3a_1 / this.a());
  }
  v3a(_this__u8e3s4) {
    return _Ratio___init__impl__9mwvn2(_this__u8e3s4.q3a_1 / this.a());
  }
  w3a(t) {
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var tmp = this.t3a();
    var index = binarySearch(tmp, VOID, VOID, Curves$findInfo$lambda(pos));
    if (Ratio__compareTo_impl_z2ienc(t, Companion_getInstance_6().m1i_1) < 0)
      return first(this.t3a());
    if (Ratio__compareTo_impl_z2ienc(t, Companion_getInstance_6().p1i_1) > 0)
      return last(this.t3a());
    var tmp0_elvis_lhs = getOrNull(this.t3a(), index);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException.s4(toString('OUTSIDE'));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
  i39(t) {
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var info = this.w3a(t);
    var posInCurve = pos - info.p3a_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.calc.<anonymous>' call
    return info.o3a_1.i39(toRatio(ratioInCurve));
  }
  k39(t) {
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var info = this.w3a(t);
    var posInCurve = pos - info.p3a_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.normal.<anonymous>' call
    return info.o3a_1.k39(ratioInCurve);
  }
  j39(t) {
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var info = this.w3a(t);
    var posInCurve = pos - info.p3a_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.tangent.<anonymous>' call
    return info.o3a_1.j39(ratioInCurve);
  }
  x3a(length) {
    if (length <= 0.0)
      return Companion_getInstance_6().m1i_1;
    if (length >= this.a())
      return Companion_getInstance_6().p1i_1;
    var tmp = this.t3a();
    var curveIndex = binarySearch(tmp, VOID, VOID, Curves$ratioFromLength$lambda(length));
    var index = curveIndex < 0 ? (-curveIndex | 0) + 1 | 0 : curveIndex;
    if (curveIndex < 0) {
      return Companion_getInstance_6().q1i_1;
    }
    var info = this.t3a().f1(index);
    var lengthInCurve = length - info.p3a_1;
    var ratioInCurve = info.o3a_1.x3a(lengthInCurve);
    return convertRange(ratioInCurve, Companion_getInstance_6().m1i_1, Companion_getInstance_6().p1i_1, this.u3a(info), this.v3a(info));
  }
  y3a(len0, len1) {
    return this.z3a(this.x3a(len0), this.x3a(len1));
  }
  z3a(t0, t1) {
    if (Ratio__compareTo_impl_z2ienc(t0, t1) > 0)
      return this.z3a(t1, t0);
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(Ratio__compareTo_impl_z2ienc(t0, t1) <= 0)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.s4(toString(message));
    }
    if (equals(t0, t1))
      return new Curves(emptyList(), false);
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t0, this.a());
    var info = this.w3a(t0);
    var posInCurve = pos - info.p3a_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.split.<anonymous>' call
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos_0 = Ratio__times_impl_ucdh7y(t1, this.a());
    var info_0 = this.w3a(t1);
    var posInCurve_0 = pos_0 - info_0.p3a_1;
    var ratioInCurve_0 = _Ratio___init__impl__9mwvn2(posInCurve_0 / info_0.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.split.<anonymous>.<anonymous>' call
    var tmp;
    if (info.n3a_1 === info_0.n3a_1) {
      tmp = listOf(info.o3a_1.z3a(ratioInCurve, ratioInCurve_0).a3b_1);
    } else {
      // Inline function 'kotlin.collections.buildList' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildListInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = ArrayList.i1();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.bezier.Curves.split.<anonymous>.<anonymous>.<anonymous>' call
      if (!equals(ratioInCurve, Companion_getInstance_6().p1i_1)) {
        this_0.h(info.o3a_1.e3b(ratioInCurve).a3b_1);
      }
      var inductionVariable = info.n3a_1 + 1 | 0;
      var last = info_0.n3a_1;
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.h(this.t3a().f1(index).o3a_1);
        }
         while (inductionVariable < last);
      if (!equals(ratioInCurve_0, Companion_getInstance_6().m1i_1)) {
        this_0.h(info_0.o3a_1.f3b(ratioInCurve_0).a3b_1);
      }
      tmp = this_0.s7();
    }
    var tmp$ret$7 = tmp;
    return new Curves(tmp$ret$7, false);
  }
  toString() {
    return 'Curves(beziers=' + toString(this.v39_1) + ', closed=' + this.w39_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.v39_1);
    result = imul(result, 31) + getBooleanHashCode(this.w39_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Curves))
      return false;
    var tmp0_other_with_cast = other instanceof Curves ? other : THROW_CCE();
    if (!equals(this.v39_1, tmp0_other_with_cast.v39_1))
      return false;
    if (!(this.w39_1 === tmp0_other_with_cast.w39_1))
      return false;
    return true;
  }
}
class ProjectedPoint {
  constructor(p, t, dSq) {
    p = p === VOID ? Vector2D.w28() : p;
    t = t === VOID ? Companion_getInstance_6().m1i_1 : t;
    dSq = dSq === VOID ? 0.0 : dSq;
    this.t3b_1 = p;
    this.u3b_1 = t;
    this.v3b_1 = dSq;
  }
  x3b(other, epsilon) {
    return this.t3b_1.x2h(other.t3b_1, epsilon) && isAlmostEquals(this.u3b_1, other.u3b_1, toRatio_0(epsilon)) && isAlmostEquals_0(this.v3b_1, other.v3b_1, epsilon);
  }
  c1i(other, epsilon) {
    return this.x3b(other instanceof ProjectedPoint ? other : THROW_CCE(), epsilon);
  }
  toString() {
    return 'ProjectedPoint(p=' + this.t3b_1.toString() + ', t=' + Ratio__toString_impl_mfgt3e(this.u3b_1) + ', dSq=' + this.v3b_1 + ')';
  }
  hashCode() {
    var result = this.t3b_1.hashCode();
    result = imul(result, 31) + Ratio__hashCode_impl_quhc2v(this.u3b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v3b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ProjectedPoint))
      return false;
    var tmp0_other_with_cast = other instanceof ProjectedPoint ? other : THROW_CCE();
    if (!this.t3b_1.equals(tmp0_other_with_cast.t3b_1))
      return false;
    if (!equals(this.u3b_1, tmp0_other_with_cast.u3b_1))
      return false;
    if (!equals(this.v3b_1, tmp0_other_with_cast.v3b_1))
      return false;
    return true;
  }
}
class Extrema {
  constructor(xt, yt) {
    this.g3b_1 = xt;
    this.h3b_1 = yt;
    var tmp = this;
    tmp.i3b_1 = lazy(Bezier$Extrema$allt$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.j3b_1 = lazy(Bezier$Extrema$xt01$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.k3b_1 = lazy(Bezier$Extrema$yt01$delegate$lambda(this));
  }
  y3b() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.j3b_1;
    xt01$factory();
    return this_0.o1();
  }
  z3b() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.k3b_1;
    yt01$factory();
    return this_0.o1();
  }
  r3b(index) {
    return index === 0 ? this.y3b() : this.z3b();
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Extrema) {
      tmp_0 = contentEquals(this.g3b_1, other.g3b_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.h3b_1, other.h3b_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode(this.g3b_1) + imul(contentHashCode(this.h3b_1), 7) | 0;
  }
  toString() {
    return 'Extrema(x=' + contentToString(this.g3b_1) + ', y=' + contentToString(this.h3b_1) + ')';
  }
}
class Companion {
  constructor() {
    Companion_instance = this;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.l3b_1 = new Float64Array([-0.06405689286260563, 0.06405689286260563, -0.1911188674736163, 0.1911188674736163, -0.3150426796961634, 0.3150426796961634, -0.4337935076260451, 0.4337935076260451, -0.5454214713888396, 0.5454214713888396, -0.6480936519369755, 0.6480936519369755, -0.7401241915785544, 0.7401241915785544, -0.820001985973903, 0.820001985973903, -0.8864155270044011, 0.8864155270044011, -0.9382745520027328, 0.9382745520027328, -0.9747285559713095, 0.9747285559713095, -0.9951872199970213, 0.9951872199970213]);
    var tmp_0 = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp_0.m3b_1 = new Float64Array([0.12793819534675216, 0.12793819534675216, 0.1258374563468283, 0.1258374563468283, 0.12167047292780339, 0.12167047292780339, 0.1155056680537256, 0.1155056680537256, 0.10744427011596563, 0.10744427011596563, 0.09761865210411388, 0.09761865210411388, 0.08619016153195327, 0.08619016153195327, 0.0733464814110803, 0.0733464814110803, 0.05929858491543678, 0.05929858491543678, 0.04427743881741981, 0.04427743881741981, 0.028531388628933663, 0.028531388628933663, 0.0123412297999872, 0.0123412297999872]);
    this.n3b_1 = 6.283185307179586;
    this.o3b_1 = Line2D.x28(0, 0, 1, 0);
    this.p3b_1 = new Float64Array(0);
  }
  a3c(p0, p1, p2, p3, t) {
    var out;
    // Inline function 'korlibs.math.geom.bezier.Companion.cubicCalc' call
    var x0 = p0.c26_1;
    var y0 = p0.d26_1;
    var x1 = p1.c26_1;
    var y1 = p1.d26_1;
    var x2 = p2.c26_1;
    var y2 = p2.d26_1;
    var cx = 3.0 * (x1 - x0);
    var bx = 3.0 * (x2 - x1) - cx;
    var ax = p3.c26_1 - x0 - cx - bx;
    var cy = 3.0 * (y1 - y0);
    var by = 3.0 * (y2 - y1) - cy;
    var ay = p3.d26_1 - y0 - cy - by;
    var tSquared = Ratio__times_impl_ucdh7y_0(t, t);
    var tCubed = Ratio__times_impl_ucdh7y_0(tSquared, t);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp = ax * _Ratio___get_value__impl__57cli6(tCubed);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_0 = tmp + bx * _Ratio___get_value__impl__57cli6(tSquared);
    // Inline function 'korlibs.math.interpolation.times' call
    var x = tmp_0 + cx * _Ratio___get_value__impl__57cli6(t) + x0;
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_1 = ay * _Ratio___get_value__impl__57cli6(tCubed);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_2 = tmp_1 + by * _Ratio___get_value__impl__57cli6(tSquared);
    // Inline function 'korlibs.math.interpolation.times' call
    var y = tmp_2 + cy * _Ratio___get_value__impl__57cli6(t) + y0;
    out = Vector2D.l28(x, y);
    return out;
  }
  b3c(p, c, a, t) {
    var out;
    // Inline function 'korlibs.math.geom.bezier.Companion.quadCalc' call
    var x0 = p.c26_1;
    var y0 = p.d26_1;
    var xc = c.c26_1;
    var yc = c.d26_1;
    var x1 = a.c26_1;
    var y1 = a.d26_1;
    var t1 = 1 - Ratio__toDouble_impl_o7epze(t);
    var a_0 = t1 * t1;
    var c_0 = Ratio__times_impl_ucdh7y_0(t, t);
    // Inline function 'korlibs.math.interpolation.times' call
    var b = 2 * t1 * _Ratio___get_value__impl__57cli6(t);
    var x = a_0 * x0 + b * xc + Ratio__times_impl_ucdh7y(c_0, x1);
    var y = a_0 * y0 + b * yc + Ratio__times_impl_ucdh7y(c_0, y1);
    out = Vector2D.l28(x, y);
    return out;
  }
  c3c(a, b) {
    return a + (b - a) * (2.0 / 3.0);
  }
  d3c(a, b) {
    return b + (a - b) * (2.0 / 3.0);
  }
}
class Bezier {
  static j3c(points, dummy) {
    Companion_getInstance_8();
    var $this = createThis(this);
    $this.b3a_1 = points;
    if ($this.b3a_1.d1() > 4) {
      // Inline function 'kotlin.error' call
      var message = 'Only supports quad and cubic beziers';
      throw IllegalStateException.s4(toString(message));
    }
    var tmp = $this;
    tmp.c3a_1 = lazy(Bezier$aligned$delegate$lambda($this));
    var tmp_0 = $this;
    tmp_0.d3a_1 = lazy(Bezier$dpoints$delegate$lambda($this));
    var tmp_1 = $this;
    tmp_1.e3a_1 = lazy(Bezier$direction$delegate$lambda($this));
    var tmp_2 = $this;
    tmp_2.f3a_1 = lazy(Bezier$extrema$delegate$lambda($this));
    var tmp_3 = $this;
    tmp_3.g3a_1 = lazy(Bezier$outerCircle$delegate$lambda($this));
    var tmp_4 = $this;
    tmp_4.h3a_1 = lazy(Bezier$boundingBox$delegate$lambda($this));
    var tmp_5 = $this;
    tmp_5.i3a_1 = lazy(Bezier$length$delegate$lambda($this));
    var tmp_6 = $this;
    tmp_6.j3a_1 = lazy(Bezier$lut$delegate$lambda($this));
    var tmp_7 = $this;
    tmp_7.k3a_1 = lazy(Bezier$isLinear$delegate$lambda($this));
    var tmp_8 = $this;
    tmp_8.l3a_1 = lazy(Bezier$isSimple$delegate$lambda($this));
    return $this;
  }
  static k3c() {
    Companion_getInstance_8();
    return this.l3c(Vector2D.y2a(0.0, 0.0), Vector2D.y2a(0.0, 0.0));
  }
  static l3c(p0, p1) {
    Companion_getInstance_8();
    return this.j3c(pointArrayListOf(p0, p1), Unit_instance);
  }
  static m3c(p0, p1, p2) {
    Companion_getInstance_8();
    return this.j3c(pointArrayListOf_0(p0, p1, p2), Unit_instance);
  }
  static n3c(p0, p1, p2, p3) {
    Companion_getInstance_8();
    return this.j3c(pointArrayListOf_1(p0, p1, p2, p3), Unit_instance);
  }
  static o3c(points) {
    Companion_getInstance_8();
    return this.j3c(points.h2r(), Unit_instance);
  }
  p3c(other, epsilon) {
    if (!(this.b3a_1.d1() === other.b3a_1.d1()))
      return false;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = until(0, this.b3a_1.d1());
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var inductionVariable = this_0.y1_1;
      var last = this_0.z1_1;
      if (inductionVariable <= last)
        do {
          var element = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.math.geom.bezier.Bezier.isAlmostEquals.<anonymous>' call
          var it = element;
          if (!this.b3a_1.f1(it).x2h(other.b3a_1.f1(it), epsilon)) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
        }
         while (!(element === last));
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  c1i(other, epsilon) {
    return this.p3c(other instanceof Bezier ? other : THROW_CCE(), epsilon);
  }
  s3b(t) {
    return this.q3c(t);
  }
  s3a() {
    return this.g3c();
  }
  r3c(m) {
    return _getBoundingBox(this, m);
  }
  i39(t) {
    return this.q3c(t);
  }
  equals(other) {
    var tmp;
    if (other instanceof Bezier) {
      tmp = equals(this.b3a_1, other.b3a_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.b3a_1);
  }
  toString() {
    return 'Bezier(' + toString(this.b3a_1) + ')';
  }
  e3c() {
    return 2;
  }
  m3a() {
    return this.b3a_1.d1() - 1 | 0;
  }
  f3c() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d3a_1;
    dpoints$factory();
    return this_0.o1();
  }
  q3b() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f3a_1;
    extrema$factory();
    return this_0.o1();
  }
  s3c() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.g3a_1;
    outerCircle$factory();
    return this_0.o1();
  }
  g3c() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.h3a_1;
    boundingBox$factory();
    return this_0.o1();
  }
  a() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.i3a_1;
    length$factory_0();
    return this_0.o1();
  }
  t3c() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.j3a_1;
    lut$factory();
    return this_0.o1();
  }
  x3a(length) {
    return this.t3c().b3d(length).v3c_1;
  }
  c3d(steps, out) {
    out.y2();
    // Inline function 'korlibs.math.interpolation.Companion.forEachRatio' call
    Companion_getInstance_6();
    var NS = (steps + 1 | 0) - 1 | 0;
    var NSd = NS;
    var start = true ? 0 : 1;
    var end = true ? NS : NS - 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ratio = n / NSd;
        // Inline function 'korlibs.math.geom.bezier.Bezier.getLUT.<anonymous>' call
        var t = toRatio_0(ratio);
        out.d3d(t, this.q3c(t));
      }
       while (!(n === end));
    return out;
  }
  i3c(steps, out, $super) {
    steps = steps === VOID ? 100 : steps;
    out = out === VOID ? CurveLUT.e3d(this, steps + 1 | 0) : out;
    return $super === VOID ? this.c3d(steps, out) : $super.c3d.call(this, steps, out);
  }
  f3d(point, out) {
    out.w3b_1 = this;
    if (this.b3a_1.d1() === 2) {
      var p0 = this.b3a_1.f1(0);
      var p1 = this.b3a_1.f1(1);
      return findNearestLine(this, point.c26_1, point.d26_1, p0.c26_1, p0.d26_1, p1.c26_1, p1.d26_1, out);
    }
    var LUT = this.t3c();
    var l = LUT.g3d();
    var closest = LUT.h3d(point);
    var mpos = closest.j3d_1;
    var t1 = (mpos - 1 | 0) / l;
    var t2 = (mpos + 1 | 0) / l;
    var step = 0.1 / l;
    var mdistSq = closest.i3d_1;
    var t = t1;
    var ft = t;
    mdistSq = mdistSq + 1;
    while (t < t2 + step) {
      var p = this.q3c(toRatio_0(t));
      var d = Companion_getInstance().u27(point, p);
      if (d < mdistSq) {
        mdistSq = d;
        ft = t;
        out.t3b_1 = p;
      }
      t = t + step;
    }
    out.t3b_1 = this.q3c(toRatio_0(ft));
    out.u3b_1 = ft < 0 ? Companion_getInstance_6().m1i_1 : ft > 1 ? Companion_getInstance_6().p1i_1 : toRatio_0(ft);
    out.v3b_1 = mdistSq;
    return out;
  }
  k3d() {
    if (this.b3a_1.d1() < 4)
      return Companion_getInstance_8().p3b_1;
    var p = _get_aligned__7fjidv(this);
    var p1 = p.f1(1);
    var p2 = p.f1(2);
    var p3 = p.f1(3);
    var a = p2.c26_1 * p1.d26_1;
    var b = p3.c26_1 * p1.d26_1;
    var c = p1.c26_1 * p2.d26_1;
    var d = p3.c26_1 * p2.d26_1;
    var v1 = 18.0 * (-3.0 * a + 2.0 * b + 3.0 * c - d);
    var v2 = 18.0 * (3.0 * a - b - 3.0 * c);
    var v3 = 18.0 * (c - a);
    if (isAlmostZero(v1)) {
      if (!isAlmostZero(v2)) {
        var t = -v3 / v2;
        if (0.0 <= t ? t <= 1.0 : false) {
          // Inline function 'kotlin.doubleArrayOf' call
          return new Float64Array([t]);
        }
      }
      return Companion_getInstance_8().p3b_1;
    }
    var d2 = 2.0 * v1;
    if (isAlmostEquals_0(d2, 0.0))
      return Companion_getInstance_8().p3b_1;
    var trm = v2 * v2 - 4.0 * v1 * v3;
    if (trm < 0)
      return Companion_getInstance_8().p3b_1;
    // Inline function 'kotlin.math.sqrt' call
    var sq = Math.sqrt(trm);
    var out0 = (sq - v2) / d2;
    var out1 = -(v2 + sq) / d2;
    var out = DoubleArrayList.r2k(2);
    if (0.0 <= out0 ? out0 <= 1.0 : false) {
      out.t1k(out0);
    }
    if (0.0 <= out1 ? out1 <= 1.0 : false) {
      out.t1k(out1);
    }
    return out.t1i();
  }
  q3c(t) {
    return compute(Companion_getInstance_8(), t, this.b3a_1);
  }
  l3d(t, normalize) {
    var out = compute(Companion_getInstance_8(), t, this.f3c().f1(0));
    if ((equals(t, Companion_getInstance_6().m1i_1) || equals(t, Companion_getInstance_6().p1i_1)) && isAlmostZero(out.s2h())) {
      var inductionVariable = 0;
      if (inductionVariable < 10)
        $l$loop: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.math.pow' call
          var n_0 = -(10 - n | 0) | 0;
          var newT = Math.pow(10.0, n_0);
          var nt = equals(t, Companion_getInstance_6().p1i_1) ? 1.0 - newT : newT;
          out = compute(Companion_getInstance_8(), _Ratio___init__impl__9mwvn2(nt), this.f3c().f1(0));
          if (!isAlmostZero(out.s2h()))
            break $l$loop;
        }
         while (inductionVariable < 10);
    }
    if (normalize)
      out = out.u2h();
    return out;
  }
  h3c(t, normalize, $super) {
    normalize = normalize === VOID ? false : normalize;
    return $super === VOID ? this.l3d(t, normalize) : $super.l3d.call(this, new Ratio(t), normalize);
  }
  m3d(t, normalize) {
    return this.l3d(t, normalize).w2h();
  }
  k39(t) {
    return this.m3d(t, true);
  }
  j39(t) {
    return this.l3d(t, true);
  }
  n3d(t, out) {
    if (this.m3a() < 2)
      return null;
    var p = this.b3a_1;
    out.m2r(p, 0);
    out.m2r(p, 1);
    out.m2r(p, 2);
    if (this.m3a() === 3) {
      out.m2r(p, 3);
    }
    while (p.d1() > 1) {
      var next = new PointArrayList();
      var inductionVariable = 0;
      var last = p.d1() - 1 | 0;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var p_0 = interpolate(toRatio(t), p.f1(i), p.f1(i + 1 | 0));
          out.j2r(p_0);
          next.j2r(p_0);
        }
         while (inductionVariable < last);
      p = next;
    }
    return out;
  }
  o3d(t, out, $super) {
    out = out === VOID ? new PointArrayList() : out;
    return $super === VOID ? this.n3d(t, out) : $super.n3d.call(this, new Ratio(t), out);
  }
  z3a(t0, t1) {
    return SubBezier.p3d(this.e3b(t0).f3b(map(Companion_getInstance_8(), t1, t0, Companion_getInstance_6().p1i_1, Companion_getInstance_6().m1i_1, Companion_getInstance_6().p1i_1)).a3b_1, t0, t1, this);
  }
  f3b(t) {
    return SubBezier.q3d(this).f3b(t);
  }
  e3b(t) {
    return SubBezier.q3d(this).e3b(t);
  }
  r3d() {
    return Line2D.u28(this.b3a_1.f1(0), this.b3a_1.f1(this.m3a()));
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    var tmp_0 = new Int32Array([0, 3, 5]);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$1 = new Int32Array([0, 4, 7, 9]);
    tmp.s3d_1 = listOf_0([null, null, tmp_0, tmp$ret$1]);
    var tmp_1 = this;
    // Inline function 'kotlin.intArrayOf' call
    var tmp_2 = new Int32Array([5, 4, 2]);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$3 = new Int32Array([9, 8, 6, 3]);
    tmp_1.t3d_1 = listOf_0([null, null, tmp_2, tmp$ret$3]);
  }
}
class SubBezier {
  static p3d(curve, t1, t2, parent) {
    Companion_getInstance_9();
    var $this = createThis(this);
    $this.a3b_1 = curve;
    $this.b3b_1 = t1;
    $this.c3b_1 = t2;
    $this.d3b_1 = parent;
    return $this;
  }
  static q3d(curve) {
    Companion_getInstance_9();
    return this.p3d(curve, Companion_getInstance_6().m1i_1, Companion_getInstance_6().p1i_1, null);
  }
  i39(t) {
    return this.a3b_1.i39(convertRange(t, this.b3b_1, this.c3b_1, Companion_getInstance_6().m1i_1, Companion_getInstance_6().p1i_1));
  }
  f3b(t) {
    return _splitLeft$default(this, t);
  }
  e3b(t) {
    return _splitRight$default(this, t);
  }
  toString() {
    return 'SubBezier[' + get_niceStr(Ratio__toDouble_impl_o7epze(this.b3b_1)) + '..' + get_niceStr(Ratio__toDouble_impl_o7epze(this.c3b_1)) + '](' + this.a3b_1.toString() + ')';
  }
}
class ClosestResult {
  constructor(mdistSq, mpos) {
    this.i3d_1 = mdistSq;
    this.j3d_1 = mpos;
  }
}
class Estimation {
  constructor(point, ratio, length) {
    point = point === VOID ? Vector2D.w28() : point;
    ratio = ratio === VOID ? Companion_getInstance_6().m1i_1 : ratio;
    length = length === VOID ? 0.0 : length;
    this.u3c_1 = point;
    this.v3c_1 = ratio;
    this.w3c_1 = length;
  }
  toString() {
    return 'Estimation(point=' + this.u3c_1.y2h() + ', ratio=' + get_niceStr_0(this.v3c_1) + ', length=' + get_niceStr(this.w3c_1) + ')';
  }
  hashCode() {
    var result = this.u3c_1.hashCode();
    result = imul(result, 31) + Ratio__hashCode_impl_quhc2v(this.v3c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w3c_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Estimation))
      return false;
    var tmp0_other_with_cast = other instanceof Estimation ? other : THROW_CCE();
    if (!this.u3c_1.equals(tmp0_other_with_cast.u3c_1))
      return false;
    if (!equals(this.v3c_1, tmp0_other_with_cast.v3c_1))
      return false;
    if (!equals(this.w3c_1, tmp0_other_with_cast.w3c_1))
      return false;
    return true;
  }
}
class CurveLUT {
  static w3d(curve, points, ts, _estimatedLengths) {
    var $this = createThis(this);
    $this.x3c_1 = curve;
    $this.y3c_1 = points;
    $this.z3c_1 = ts;
    $this.a3d_1 = _estimatedLengths;
    return $this;
  }
  static e3d(curve, capacity) {
    return this.w3d(curve, new PointArrayList(capacity), DoubleArrayList.r2k(capacity), DoubleArrayList.r2k(capacity));
  }
  v3d() {
    if (this.a3d_1.g1()) {
      this.a3d_1.t1k(0.0);
    }
    while (this.a3d_1.d1() < this.d1()) {
      var pos = this.a3d_1.d1();
      var prev = last_0(this.a3d_1);
      this.a3d_1.t1k(prev + Companion_getInstance().m2h(this.y3c_1.f1(pos - 1 | 0), this.y3c_1.f1(pos)));
    }
    return this.a3d_1;
  }
  g3d() {
    return this.y3c_1.d1() - 1 | 0;
  }
  d1() {
    return this.y3c_1.d1();
  }
  y2() {
    this.y3c_1.xg();
    this.z3c_1.y2();
    this.a3d_1.y2();
  }
  d3d(t, p) {
    this.y3c_1.j2r(p);
    this.z3c_1.t1k(Ratio__toDouble_impl_o7epze(t));
  }
  h3d(point) {
    var mdistSq = Infinity;
    var mpos = 0;
    var inductionVariable = 0;
    var last = this.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var d = Companion_getInstance().u27(this.y3c_1.f1(n), point);
        if (d < mdistSq) {
          mdistSq = d;
          mpos = n;
        }
      }
       while (inductionVariable < last);
    return new ClosestResult(mdistSq, mpos);
  }
  u3d(_this__u8e3s4, index, ratio) {
    var ratio0 = toRatio_0(this.z3c_1.f1(index));
    var length0 = this.v3d().f1(index);
    var point0 = this.y3c_1.f1(index);
    if (ratio === 0.0) {
      _this__u8e3s4.v3c_1 = ratio0;
      _this__u8e3s4.w3c_1 = length0;
      _this__u8e3s4.u3c_1 = point0;
    } else {
      var ratio1 = toRatio_0(this.z3c_1.f1(index + 1 | 0));
      var length1 = this.v3d().f1(index + 1 | 0);
      var point1 = this.y3c_1.f1(index + 1 | 0);
      _this__u8e3s4.v3c_1 = interpolate_0(toRatio_0(ratio), ratio0, ratio1);
      _this__u8e3s4.w3c_1 = interpolate_1(toRatio_0(ratio), length0, length1);
      _this__u8e3s4.u3c_1 = interpolate(toRatio_0(ratio), point0, point1);
    }
    return _this__u8e3s4;
  }
  x3d(length, out) {
    return estimateAt(this, this.v3d(), length, out);
  }
  b3d(length, out, $super) {
    out = out === VOID ? new Estimation() : out;
    return $super === VOID ? this.x3d(length, out) : $super.x3d.call(this, length, out);
  }
  toString() {
    var tmp = toString(this.x3c_1);
    var tmp_0 = until(0, this.d1());
    return 'CurveLUT[' + tmp + '](' + joinToString(tmp_0, ', ', VOID, VOID, VOID, VOID, CurveLUT$toString$lambda(this)) + ')';
  }
  hashCode() {
    var result = hashCode(this.x3c_1);
    result = imul(result, 31) + this.y3c_1.hashCode() | 0;
    result = imul(result, 31) + this.z3c_1.hashCode() | 0;
    result = imul(result, 31) + this.a3d_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CurveLUT))
      return false;
    var tmp0_other_with_cast = other instanceof CurveLUT ? other : THROW_CCE();
    if (!equals(this.x3c_1, tmp0_other_with_cast.x3c_1))
      return false;
    if (!this.y3c_1.equals(tmp0_other_with_cast.y3c_1))
      return false;
    if (!this.z3c_1.equals(tmp0_other_with_cast.z3c_1))
      return false;
    if (!this.a3d_1.equals(tmp0_other_with_cast.a3d_1))
      return false;
    return true;
  }
}
class Arc {
  constructor() {
    this.y3d_1 = 0.5522847498307933;
    this.z3d_1 = 6.283185307179586;
  }
  a3e(out, a, c, r) {
    if (out.g1()) {
      out.b3e(a);
    }
    var b = out.c3e();
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var AB = Vector2D.l28(b.c26_1 - a.c26_1, b.d26_1 - a.d26_1);
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var AC = Vector2D.l28(c.c26_1 - a.c26_1, c.d26_1 - a.d26_1);
    var angle = Angle__times_impl_v3s9y2(Companion_getInstance().j2h(AB, AC), 0.5);
    // Inline function 'korlibs.math.geom.sin' call
    var angle_0 = Angle__minus_impl_xeau7k(Companion_getInstance_0().u25_1, angle);
    var up = Companion_getInstance().i26_1;
    var tmp = r * Angle__sine_impl_3l11xv(angle_0, up);
    // Inline function 'korlibs.math.geom.sin' call
    var up_0 = Companion_getInstance().i26_1;
    var x = tmp / Angle__sine_impl_3l11xv(angle, up_0);
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_0 = AB.v2h();
    var that = Vector2D.l28(this_0.c26_1 * x, this_0.d26_1 * x);
    var A = Vector2D.l28(a.c26_1 + that.c26_1, a.d26_1 + that.d26_1);
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_1 = AC.v2h();
    var that_0 = Vector2D.l28(this_1.c26_1 * x, this_1.d26_1 * x);
    var B = Vector2D.l28(a.c26_1 + that_0.c26_1, a.d26_1 + that_0.d26_1);
    out.d3e(A);
    out.e3e(a, B);
  }
  f3e(out, p, rsize) {
    var x = p.bl();
    var y = p.cl();
    var rw = rsize.bl();
    var rh = rsize.cl();
    var k = 0.5522847498307933;
    var ox = rw / 2 * k;
    var oy = rh / 2 * k;
    var xe = x + rw;
    var ye = y + rh;
    var xm = x + rw / 2;
    var ym = y + rh / 2;
    out.b3e(Vector2D.l28(x, ym));
    out.g3e(Vector2D.l28(x, ym - oy), Vector2D.l28(xm - ox, y), Vector2D.l28(xm, y));
    out.g3e(Vector2D.l28(xm + ox, y), Vector2D.l28(xe, ym - oy), Vector2D.l28(xe, ym));
    out.g3e(Vector2D.l28(xe, ym + oy), Vector2D.l28(xm + ox, ye), Vector2D.l28(xm, ye));
    out.g3e(Vector2D.l28(xm - ox, ye), Vector2D.l28(x, ym + oy), Vector2D.l28(x, ym));
    out.y5();
  }
  h3e(out, center, r, start, end, counterclockwise) {
    var x = center.bl();
    var y = center.cl();
    var startAngle = _Angle___get_normalized__impl__9s30ys(start);
    var endAngle1 = _Angle___get_normalized__impl__9s30ys(end);
    var endAngle = Angle__compareTo_impl_a0hfds(endAngle1, startAngle) < 0 ? Angle__plus_impl_26v37k(endAngle1, Companion_getInstance_0().x25_1) : endAngle1;
    // Inline function 'korlibs.math.geom.min' call
    var a = Companion_getInstance_0().x25_1;
    // Inline function 'korlibs.math.geom.abs' call
    var angle = Angle__minus_impl_xeau7k(endAngle, startAngle);
    var b = _Angle___get_absoluteValue__impl__4qoakv(angle);
    // Inline function 'kotlin.math.min' call
    // Inline function 'korlibs.math.geom.Angle.internal' call
    var a_0 = _Angle___get_radians__impl__n00yt5(a);
    // Inline function 'korlibs.math.geom.Angle.internal' call
    var b_0 = _Angle___get_radians__impl__n00yt5(b);
    var tmp$ret$3 = Math.min(a_0, b_0);
    var remainingAngle = _Angle___init__impl__g23q1m(tmp$ret$3);
    if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(remainingAngle), Companion_getInstance_0().s25_1) < 0 && !equals(start, end))
      remainingAngle = Companion_getInstance_0().x25_1;
    var sgn1 = Angle__compareTo_impl_a0hfds(startAngle, endAngle) < 0 ? 1 : -1;
    var sgn = counterclockwise ? -sgn1 | 0 : sgn1;
    if (counterclockwise) {
      remainingAngle = Angle__minus_impl_xeau7k(Companion_getInstance_0().x25_1, remainingAngle);
      if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(remainingAngle), Companion_getInstance_0().s25_1) < 0 && !equals(start, end))
        remainingAngle = Companion_getInstance_0().x25_1;
    }
    var a1 = startAngle;
    var index = 0;
    while (Angle__compareTo_impl_a0hfds(remainingAngle, Companion_getInstance_0().s25_1) > 0) {
      var tmp = a1;
      // Inline function 'korlibs.math.geom.min' call
      var a_1 = remainingAngle;
      var b_1 = Companion_getInstance_0().u25_1;
      // Inline function 'kotlin.math.min' call
      // Inline function 'korlibs.math.geom.Angle.internal' call
      var a_2 = _Angle___get_radians__impl__n00yt5(a_1);
      // Inline function 'korlibs.math.geom.Angle.internal' call
      var b_2 = _Angle___get_radians__impl__n00yt5(b_1);
      var tmp$ret$7 = Math.min(a_2, b_2);
      var tmp$ret$8 = _Angle___init__impl__g23q1m(tmp$ret$7);
      var a2 = Angle__plus_impl_26v37k(tmp, Angle__times_impl_v3s9y2_0(tmp$ret$8, sgn));
      var a_3 = Angle__div_impl_ut2btd(Angle__minus_impl_xeau7k(a2, a1), 2.0);
      var x4 = r * _Angle___get_cosine__impl__vprvmu(a_3);
      var y4 = r * _Angle___get_sine__impl__15nmyi(a_3);
      var x1 = x4;
      var y1 = -y4;
      var f = 0.5522847498307933 * _Angle___get_tangent__impl__vushdy(a_3);
      var x2 = x1 + f * y4;
      var y2 = y1 + f * x4;
      var x3 = x2;
      var y3 = -y2;
      var ar = Angle__plus_impl_26v37k(a_3, a1);
      var cos_ar = _Angle___get_cosine__impl__vprvmu(ar);
      var sin_ar = _Angle___get_sine__impl__15nmyi(ar);
      if (index === 0) {
        out.b3e(Vector2D.l28(x + r * _Angle___get_cosine__impl__vprvmu(a1), y + r * _Angle___get_sine__impl__15nmyi(a1)));
      }
      out.g3e(Vector2D.l28(x + x2 * cos_ar - y2 * sin_ar, y + x2 * sin_ar + y2 * cos_ar), Vector2D.l28(x + x3 * cos_ar - y3 * sin_ar, y + x3 * sin_ar + y3 * cos_ar), Vector2D.l28(x + r * _Angle___get_cosine__impl__vprvmu(a2), y + r * _Angle___get_sine__impl__15nmyi(a2)));
      index = index + 1 | 0;
      var tmp_0 = remainingAngle;
      // Inline function 'korlibs.math.geom.abs' call
      var angle_0 = Angle__minus_impl_xeau7k(a2, a1);
      var tmp$ret$9 = _Angle___get_absoluteValue__impl__4qoakv(angle_0);
      remainingAngle = Angle__minus_impl_xeau7k(tmp_0, tmp$ret$9);
      a1 = a2;
    }
    if (equals(startAngle, endAngle) && !(index === 0)) {
      out.y5();
    }
  }
}
class Companion_1 {
  u3e(width, height, algo) {
    return new BinPacker(Size2D.s2e(width, height), algo);
  }
  v3e(width, height, algo) {
    return Companion_instance_1.u3e(width, height, algo);
  }
  w3e(width, height, algo, $super) {
    algo = algo === VOID ? MaxRects.y3e(width, height) : algo;
    return $super === VOID ? this.v3e(width, height, algo) : $super.v3e.call(this, width, height, algo);
  }
}
class ImageDoNotFitException extends Error {
  static d3f(width, height, packer) {
    var $this = createThis(this);
    setPropertiesToThrowableInstance($this, "Size '" + width + 'x' + height + "' doesn't fit in '" + packer.w2i() + 'x' + packer.x2i() + "'");
    captureStack($this, $this.c3f_1);
    $this.z3e_1 = width;
    $this.a3f_1 = height;
    $this.b3f_1 = packer;
    return $this;
  }
}
class BinPacker {
  constructor(size, algo) {
    algo = algo === VOID ? MaxRects.h3f(size) : algo;
    this.e3f_1 = size;
    this.f3f_1 = algo;
    this.g3f_1 = FastArrayList.r1j();
  }
  w2i() {
    return this.e3f_1.h27_1;
  }
  x2i() {
    return this.e3f_1.i27_1;
  }
  i2r(width, height) {
    var tmp0_elvis_lhs = this.i3f(width, height);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw ImageDoNotFitException.d3f(width, height, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  i3f(width, height) {
    var tmp0_elvis_lhs = this.f3f_1.j3f(Size2D.s2e(width, height));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var rect = tmp;
    // Inline function 'kotlin.collections.plusAssign' call
    this.g3f_1.h(rect);
    return rect;
  }
}
class MaxRects {
  static h3f(maxSize) {
    var $this = createThis(this);
    $this.x3e_1 = fastArrayListOf([Companion_getInstance_1().k27(Companion_getInstance().e26_1, maxSize)]);
    return $this;
  }
  static y3e(width, height) {
    return this.h3f(Size2D.s2e(width, height));
  }
  j3f(size) {
    return this.k3f(size);
  }
  k3f(size) {
    var width = size.bl();
    var height = size.cl();
    if (width <= 0.0 && height <= 0.0)
      return Companion_getInstance_1().m2e(0, 0, 0, 0);
    var newNode = quickFindPositionForNewNodeBestAreaFit(this, width, height);
    if (newNode.p26_1 === 0.0)
      return null;
    var numRectanglesToProcess = this.x3e_1.d1();
    var i = 0;
    while (i < numRectanglesToProcess) {
      if (splitFreeNode(this, this.x3e_1.f1(i), newNode)) {
        this.x3e_1.a3(i);
        numRectanglesToProcess = numRectanglesToProcess - 1 | 0;
        i = i - 1 | 0;
      }
      i = i + 1 | 0;
    }
    pruneFreeList(this);
    return newNode;
  }
}
class Companion_2 {}
class HitTestDirection extends Enum {}
class Convex {
  t3e(curves) {
    var tmp0_elvis_lhs = toNonCurveSimplePointList(curves);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var points = tmp;
    return this.l3f(points);
  }
  l3f(vertices) {
    var base = 0;
    var n = vertices.d1();
    var TWO_PI = 3.141592653589793 * 2;
    if (n <= 3)
      return true;
    if (vertices.j28(base) === vertices.j28(n - 1 | 0) && vertices.k28(base) === vertices.k28(n - 1 | 0)) {
      n = n - 1 | 0;
    }
    var old_x = vertices.j28(n - 2 | 0);
    var old_y = vertices.k28(n - 2 | 0);
    var new_x = vertices.j28(n - 1 | 0);
    var new_y = vertices.k28(n - 1 | 0);
    // Inline function 'kotlin.math.atan2' call
    var y = new_y - old_y;
    var x = new_x - old_x;
    var new_direction = Math.atan2(y, x);
    var old_direction;
    var angle_sum = Companion_getInstance_0().t25_1;
    var orientation = 0.0;
    var inductionVariable = 0;
    var last = n;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        old_x = new_x;
        old_y = new_y;
        old_direction = new_direction;
        var _unary__edvuaz = base;
        base = _unary__edvuaz + 1 | 0;
        var p = _unary__edvuaz;
        new_x = vertices.j28(p);
        new_y = vertices.k28(p);
        // Inline function 'kotlin.math.atan2' call
        var y_0 = new_y - old_y;
        var x_0 = new_x - old_x;
        new_direction = Math.atan2(y_0, x_0);
        if (old_x === new_x && old_y === new_y) {
          return false;
        }
        var angle = new_direction - old_direction;
        if (angle <= -3.141592653589793)
          angle = angle + TWO_PI;
        else if (angle > 3.141592653589793)
          angle = angle - TWO_PI;
        if (i === 0) {
          if (angle === 0.0) {
            return false;
          }
          orientation = angle > 0 ? 1.0 : -1.0;
        } else if (orientation * angle < 0.0) {
          return false;
        }
        var tmp = angle_sum;
        // Inline function 'korlibs.math.geom.Companion.fromRadians' call
        Companion_getInstance_0();
        var radians = angle;
        var tmp$ret$2 = _Angle___init__impl__g23q1m(radians);
        angle_sum = Angle__plus_impl_26v37k(tmp, tmp$ret$2);
      }
       while (inductionVariable < last);
    return isAlmostEquals(Companion_getInstance_6().p1i_1, _Ratio___get_absoluteValue__impl__92ozif(_Angle___get_ratio__impl__ap3on4(angle_sum)));
  }
}
class AbstractShape2D {}
class BaseShape2D {
  constructor(base, genVector) {
    this.q3f_1 = base;
    this.r3f_1 = genVector;
    var tmp = this;
    tmp.s3f_1 = lazy(BaseShape2D$cachedPath$delegate$lambda(this));
  }
  toString() {
    return 'Shape2D(' + toString(this.q3f_1) + ')';
  }
}
class CircleShape2D extends BaseShape2D {
  constructor(circle) {
    super(circle, CircleShape2D$_init_$lambda_c1uoso);
    this.p3f_1 = circle;
  }
  toString() {
    return 'Shape2D(' + this.q3f_1.toString() + ')';
  }
  hashCode() {
    return this.p3f_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CircleShape2D))
      return false;
    var tmp0_other_with_cast = other instanceof CircleShape2D ? other : THROW_CCE();
    if (!this.p3f_1.equals(tmp0_other_with_cast.p3f_1))
      return false;
    return true;
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_3 = this;
    this.t3f_1 = values();
  }
  f1(index) {
    return this.t3f_1[umod(index, 4)];
  }
}
class SliceRotation extends Enum {
  constructor(name, ordinal) {
    super(name, ordinal);
    this.w3f_1 = imul(this.k3_1, 90);
  }
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(8), null);
    while (tmp_0 < 8) {
      var tmp_2 = tmp_0;
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.intArrayOf' call
      var this_0 = new Int32Array([0, 1, 2, 3]);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.slice.Companion.INDICES.<anonymous>' call
      var orientation = _SliceOrientation___init__impl__ewylib(tmp_2);
      if (_SliceOrientation___get_flipX__impl__lgb7bx(orientation)) {
        swap(this_0, 0, 1);
        swap(this_0, 3, 2);
      }
      rotateRight(this_0, _SliceOrientation___get_rotation__impl__m65r0o(orientation).k3_1);
      tmp_1[tmp_2] = this_0;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.x3f_1 = tmp_1;
    var tmp_3 = this;
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = fillArrayVal(Array(8), null);
    while (tmp_4 < 8) {
      var tmp_6 = tmp_4;
      var orientation_0 = _SliceOrientation___init__impl__ewylib(tmp_6);
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.apply' call
      var this_1 = StringBuilder.f();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.slice.Companion.NAMES.<anonymous>' call
      this_1.nb(_SliceOrientation___get_flipX__impl__lgb7bx(orientation_0) ? 'MIRROR_HORIZONTAL_ROTATE_' : 'ROTATE_');
      this_1.qg(_SliceOrientation___get_rotation__impl__m65r0o(orientation_0).w3f_1);
      tmp_5[tmp_6] = this_1.toString();
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.y3f_1 = tmp_5;
    var tmp_7 = this;
    var tmp39_rotation = SliceRotation_R0_getInstance();
    tmp_7.z3f_1 = _SliceOrientation___init__impl__ewylib_0(tmp39_rotation, false);
    var tmp_8 = this;
    var tmp40_rotation = SliceRotation_R90_getInstance();
    tmp_8.a3g_1 = _SliceOrientation___init__impl__ewylib_0(tmp40_rotation, false);
    var tmp_9 = this;
    var tmp41_rotation = SliceRotation_R180_getInstance();
    tmp_9.b3g_1 = _SliceOrientation___init__impl__ewylib_0(tmp41_rotation, false);
    var tmp_10 = this;
    var tmp42_rotation = SliceRotation_R270_getInstance();
    tmp_10.c3g_1 = _SliceOrientation___init__impl__ewylib_0(tmp42_rotation, false);
    this.d3g_1 = _SliceOrientation___init__impl__ewylib_0(VOID, true);
    var tmp_11 = this;
    var tmp43_rotation = SliceRotation_R90_getInstance();
    tmp_11.e3g_1 = _SliceOrientation___init__impl__ewylib_0(tmp43_rotation, true);
    var tmp_12 = this;
    var tmp44_rotation = SliceRotation_R180_getInstance();
    tmp_12.f3g_1 = _SliceOrientation___init__impl__ewylib_0(tmp44_rotation, true);
    var tmp_13 = this;
    var tmp45_rotation = SliceRotation_R270_getInstance();
    tmp_13.g3g_1 = _SliceOrientation___init__impl__ewylib_0(tmp45_rotation, true);
    this.h3g_1 = listOf_0([new SliceOrientation(this.z3f_1), new SliceOrientation(this.a3g_1), new SliceOrientation(this.b3g_1), new SliceOrientation(this.c3g_1), new SliceOrientation(this.d3g_1), new SliceOrientation(this.e3g_1), new SliceOrientation(this.f3g_1), new SliceOrientation(this.g3g_1)]);
  }
}
class SliceOrientation {
  constructor(raw) {
    Companion_getInstance_13();
    this.i3g_1 = raw;
  }
  toString() {
    return SliceOrientation__toString_impl_tdph6r(this.i3g_1);
  }
  hashCode() {
    return SliceOrientation__hashCode_impl_7mjkdw(this.i3g_1);
  }
  equals(other) {
    return SliceOrientation__equals_impl_h4gywg(this.i3g_1, other);
  }
}
class SliceCoords {}
function x(index) {
  switch (index) {
    case 0:
      return this.d3i();
    case 1:
      return this.f3i();
    case 2:
      return this.h3i();
    case 3:
      return this.j3i();
    default:
      return NaN;
  }
}
function y(index) {
  switch (index) {
    case 0:
      return this.e3i();
    case 1:
      return this.g3i();
    case 2:
      return this.i3i();
    case 3:
      return this.k3i();
    default:
      return NaN;
  }
}
class SliceCoordsWithBase {}
function get_frameOffsetX() {
  return this.u3h().h29_1;
}
function get_frameOffsetY() {
  return this.u3h().e29_1;
}
function get_frameWidth() {
  return this.w2i() + this.u3h().l29() | 0;
}
function get_frameHeight() {
  return this.x2i() + this.u3h().m29() | 0;
}
class SliceCoordsWithBaseAndRect {}
function get_left() {
  return this.t3h().t26();
}
function get_top() {
  return this.t3h().v26();
}
function get_right() {
  return this.t3h().u26();
}
function get_bottom() {
  return this.t3h().w26();
}
function get_area() {
  return this.t3h().y2f();
}
class RectSlice {
  constructor(base, rect, orientation, padding, name) {
    orientation = orientation === VOID ? Companion_getInstance_13().z3f_1 : orientation;
    padding = padding === VOID ? Companion_getInstance_3().d29_1 : padding;
    name = name === VOID ? null : name;
    this.j3g_1 = base;
    this.k3g_1 = rect;
    this.l3g_1 = orientation;
    this.m3g_1 = padding;
    this.n3g_1 = name;
    this.o3g_1 = this.j3g_1.d1().b2h_1;
    this.p3g_1 = this.j3g_1.d1().c2h_1;
    this.q3g_1 = this.k3g_1.i2f_1;
    this.r3g_1 = this.k3g_1.j2f_1;
    this.s3g_1 = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(this.l3g_1) ? this.k3g_1.i2f_1 : this.k3g_1.j2f_1;
    this.t3g_1 = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(this.l3g_1) ? this.k3g_1.j2f_1 : this.k3g_1.i2f_1;
    this.u3g_1 = this.s3g_1 + this.m3g_1.l29() | 0;
    this.v3g_1 = this.t3g_1 + this.m3g_1.m29() | 0;
    this.w3g_1 = this.k3g_1.t26() / this.o3g_1;
    this.x3g_1 = this.k3g_1.u26() / this.o3g_1;
    this.y3g_1 = this.k3g_1.v26() / this.p3g_1;
    this.z3g_1 = this.k3g_1.w26() / this.p3g_1;
    this.a3h_1 = new RectCoords(this.w3g_1, this.y3g_1, this.x3g_1, this.y3g_1, this.x3g_1, this.z3g_1, this.w3g_1, this.z3g_1);
    this.b3h_1 = transformed_1(this.a3h_1, this.l3g_1);
    this.c3h_1 = this.b3h_1.k3h_1;
    this.d3h_1 = this.b3h_1.l3h_1;
    this.e3h_1 = this.b3h_1.m3h_1;
    this.f3h_1 = this.b3h_1.n3h_1;
    this.g3h_1 = this.b3h_1.o3h_1;
    this.h3h_1 = this.b3h_1.p3h_1;
    this.i3h_1 = this.b3h_1.q3h_1;
    this.j3h_1 = this.b3h_1.r3h_1;
  }
  s3h() {
    return this.j3g_1;
  }
  t3h() {
    return this.k3g_1;
  }
  u3h() {
    return this.m3g_1;
  }
  w2i() {
    return this.s3g_1;
  }
  x2i() {
    return this.t3g_1;
  }
  v3h() {
    return this.u3g_1;
  }
  w3h() {
    return this.v3g_1;
  }
  x3h(left, top, right, bottom, name, clamped, orientation) {
    var tmp = this.k3g_1.z2f(left, top, right, bottom, clamped);
    return new RectSlice(this.j3g_1, tmp, orientation, this.m3g_1, name == null ? this.n3g_1 : name);
  }
  y3h(left, top, right, bottom, name, clamped, orientation, $super) {
    name = name === VOID ? null : name;
    clamped = clamped === VOID ? true : clamped;
    orientation = orientation === VOID ? this.l3g_1 : orientation;
    return $super === VOID ? this.x3h(left, top, right, bottom, name, clamped, orientation) : $super.x3h.call(this, left, top, right, bottom, name, clamped, new SliceOrientation(orientation));
  }
  z3h(x, y, width, height, name, clamped, orientation) {
    return this.x3h(x, y, x + width | 0, y + height | 0, name, clamped, orientation);
  }
  a3i(x, y, width, height, name, clamped, orientation, $super) {
    name = name === VOID ? null : name;
    clamped = clamped === VOID ? true : clamped;
    orientation = orientation === VOID ? this.l3g_1 : orientation;
    return $super === VOID ? this.z3h(x, y, width, height, name, clamped, orientation) : $super.z3h.call(this, x, y, width, height, name, clamped, new SliceOrientation(orientation));
  }
  b3i(rect, name, clamped, orientation) {
    return this.x3h(rect.t26(), rect.v26(), rect.u26(), rect.w26(), name, clamped, orientation);
  }
  c3i(rect, name, clamped, orientation, $super) {
    name = name === VOID ? null : name;
    clamped = clamped === VOID ? true : clamped;
    orientation = orientation === VOID ? this.l3g_1 : orientation;
    return $super === VOID ? this.b3i(rect, name, clamped, orientation) : $super.b3i.call(this, rect, name, clamped, new SliceOrientation(orientation));
  }
  d3i() {
    return this.c3h_1;
  }
  e3i() {
    return this.d3h_1;
  }
  f3i() {
    return this.e3h_1;
  }
  g3i() {
    return this.f3h_1;
  }
  h3i() {
    return this.g3h_1;
  }
  i3i() {
    return this.h3h_1;
  }
  j3i() {
    return this.i3h_1;
  }
  k3i() {
    return this.j3h_1;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.slice.RectSlice.toString.<anonymous>' call
    this_0.nb('RectSlice(');
    this_0.nb(this.n3g_1);
    this_0.nb(':');
    this_0.mb(this.k3g_1);
    if (!(this.l3g_1 === Companion_getInstance_13().z3f_1)) {
      this_0.nb(':');
      this_0.mb(new SliceOrientation(this.l3g_1));
    }
    if (this.m3g_1.k29()) {
      this_0.nb(':');
      this_0.mb(this.m3g_1);
    }
    this_0.nb(')');
    return this_0.toString();
  }
  hashCode() {
    var result = hashCode(this.j3g_1);
    result = imul(result, 31) + this.k3g_1.hashCode() | 0;
    result = imul(result, 31) + SliceOrientation__hashCode_impl_7mjkdw(this.l3g_1) | 0;
    result = imul(result, 31) + this.m3g_1.hashCode() | 0;
    result = imul(result, 31) + (this.n3g_1 == null ? 0 : getStringHashCode(this.n3g_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectSlice))
      return false;
    var tmp0_other_with_cast = other instanceof RectSlice ? other : THROW_CCE();
    if (!equals(this.j3g_1, tmp0_other_with_cast.j3g_1))
      return false;
    if (!this.k3g_1.equals(tmp0_other_with_cast.k3g_1))
      return false;
    if (!(this.l3g_1 === tmp0_other_with_cast.l3g_1))
      return false;
    if (!this.m3g_1.equals(tmp0_other_with_cast.m3g_1))
      return false;
    if (!(this.n3g_1 == tmp0_other_with_cast.n3g_1))
      return false;
    return true;
  }
}
class Companion_5 {
  p3i(base, coords, name, flippedWidthHeight) {
    return new SliceCoordsImpl(base, coords, name, flippedWidthHeight);
  }
  q3i(base, coords, name, flippedWidthHeight, $super) {
    name = name === VOID ? null : name;
    flippedWidthHeight = flippedWidthHeight === VOID ? false : flippedWidthHeight;
    return $super === VOID ? this.p3i(base, coords, name, flippedWidthHeight) : $super.p3i.call(this, base, coords, name, flippedWidthHeight);
  }
}
class SliceCoordsImpl {
  constructor(base, coords, name, flippedWidthHeight) {
    name = name === VOID ? null : name;
    flippedWidthHeight = flippedWidthHeight === VOID ? false : flippedWidthHeight;
    this.r3i_1 = base;
    this.s3i_1 = coords;
    this.t3i_1 = name;
    this.u3i_1 = flippedWidthHeight;
    this.v3i_1 = Companion_getInstance_3().d29_1;
    this.w3i_1 = !this.u3i_1 ? this.r3i_1.d1().b2h_1 : this.r3i_1.d1().c2h_1;
    this.x3i_1 = !this.u3i_1 ? this.r3i_1.d1().c2h_1 : this.r3i_1.d1().b2h_1;
    this.y3i_1 = numberToInt(Companion_getInstance().k2h(this.s3i_1.d3i(), this.s3i_1.e3i(), this.s3i_1.f3i(), this.s3i_1.g3i()) * this.w3i_1);
    this.z3i_1 = numberToInt(Companion_getInstance().k2h(this.s3i_1.d3i(), this.s3i_1.e3i(), this.s3i_1.j3i(), this.s3i_1.k3i()) * this.x3i_1);
    this.a3j_1 = this.y3i_1 + this.v3i_1.l29() | 0;
    this.b3j_1 = this.z3i_1 + this.v3i_1.m29() | 0;
  }
  s3h() {
    return this.r3i_1;
  }
  u3h() {
    return this.v3i_1;
  }
  w2i() {
    return this.y3i_1;
  }
  x2i() {
    return this.z3i_1;
  }
  v3h() {
    return this.a3j_1;
  }
  w3h() {
    return this.b3j_1;
  }
  d3i() {
    return this.s3i_1.d3i();
  }
  e3i() {
    return this.s3i_1.e3i();
  }
  f3i() {
    return this.s3i_1.f3i();
  }
  g3i() {
    return this.s3i_1.g3i();
  }
  h3i() {
    return this.s3i_1.h3i();
  }
  i3i() {
    return this.s3i_1.i3i();
  }
  j3i() {
    return this.s3i_1.j3i();
  }
  k3i() {
    return this.s3i_1.k3i();
  }
  toString() {
    return 'SliceCoordsImpl(base=' + toString(this.r3i_1) + ', coords=' + toString(this.s3i_1) + ', name=' + this.t3i_1 + ', flippedWidthHeight=' + this.u3i_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.r3i_1);
    result = imul(result, 31) + hashCode(this.s3i_1) | 0;
    result = imul(result, 31) + (this.t3i_1 == null ? 0 : getStringHashCode(this.t3i_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.u3i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SliceCoordsImpl))
      return false;
    var tmp0_other_with_cast = other instanceof SliceCoordsImpl ? other : THROW_CCE();
    if (!equals(this.r3i_1, tmp0_other_with_cast.r3i_1))
      return false;
    if (!equals(this.s3i_1, tmp0_other_with_cast.s3i_1))
      return false;
    if (!(this.t3i_1 == tmp0_other_with_cast.t3i_1))
      return false;
    if (!(this.u3i_1 === tmp0_other_with_cast.u3i_1))
      return false;
    return true;
  }
}
class RectCoords {
  constructor(tlX, tlY, trX, trY, brX, brY, blX, blY) {
    this.k3h_1 = tlX;
    this.l3h_1 = tlY;
    this.m3h_1 = trX;
    this.n3h_1 = trY;
    this.o3h_1 = brX;
    this.p3h_1 = brY;
    this.q3h_1 = blX;
    this.r3h_1 = blY;
  }
  d3i() {
    return this.k3h_1;
  }
  e3i() {
    return this.l3h_1;
  }
  f3i() {
    return this.m3h_1;
  }
  g3i() {
    return this.n3h_1;
  }
  h3i() {
    return this.o3h_1;
  }
  i3i() {
    return this.p3h_1;
  }
  j3i() {
    return this.q3h_1;
  }
  k3i() {
    return this.r3h_1;
  }
  toString() {
    return 'RectCoords(tlX=' + this.k3h_1 + ', tlY=' + this.l3h_1 + ', trX=' + this.m3h_1 + ', trY=' + this.n3h_1 + ', brX=' + this.o3h_1 + ', brY=' + this.p3h_1 + ', blX=' + this.q3h_1 + ', blY=' + this.r3h_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.k3h_1);
    result = imul(result, 31) + getNumberHashCode(this.l3h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.m3h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n3h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o3h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p3h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q3h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r3h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectCoords))
      return false;
    var tmp0_other_with_cast = other instanceof RectCoords ? other : THROW_CCE();
    if (!equals(this.k3h_1, tmp0_other_with_cast.k3h_1))
      return false;
    if (!equals(this.l3h_1, tmp0_other_with_cast.l3h_1))
      return false;
    if (!equals(this.m3h_1, tmp0_other_with_cast.m3h_1))
      return false;
    if (!equals(this.n3h_1, tmp0_other_with_cast.n3h_1))
      return false;
    if (!equals(this.o3h_1, tmp0_other_with_cast.o3h_1))
      return false;
    if (!equals(this.p3h_1, tmp0_other_with_cast.p3h_1))
      return false;
    if (!equals(this.q3h_1, tmp0_other_with_cast.q3h_1))
      return false;
    if (!equals(this.r3h_1, tmp0_other_with_cast.r3h_1))
      return false;
    return true;
  }
}
class Bucket {
  constructor() {
    this.c3j_1 = FastArrayList.r1j();
  }
  xg() {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.Bucket.clear.<anonymous>' call
    this.c3j_1.y2();
    return this;
  }
}
class Buckets {
  constructor(pool, ySize) {
    this.d3j_1 = pool;
    this.e3j_1 = ySize;
    this.f3j_1 = FastIntMap();
  }
  d1() {
    return get_size(this.f3j_1);
  }
  g3j(y) {
    return y / this.e3j_1 | 0;
  }
  h3j(index) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.f3j_1;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = this_0.get(index);
      if (!(res == null)) {
        tmp$ret$2 = res;
        break $l$block;
      }
      // Inline function 'korlibs.math.geom.vector.Buckets.getForIndex.<anonymous>' call
      var out = this.d3j_1.n2p();
      // Inline function 'korlibs.datastructure.set' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.set(index, out);
      tmp$ret$2 = out;
    }
    return tmp$ret$2;
  }
  i3j(y) {
    // Inline function 'korlibs.datastructure.get' call
    var this_0 = this.f3j_1;
    var key = this.g3j(y);
    // Inline function 'kotlin.js.asDynamic' call
    return this_0.get(key);
  }
  y2() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.f3j_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.math.geom.vector.Buckets.clear.<anonymous>' call
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = this_0.get(it);
      var value = ensureNotNull(tmp$ret$2);
      this.d3j_1.o2p(value.xg());
    }
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.f3j_1.clear();
  }
  j3j(edge, threshold) {
    var min = this.g3j(edge.u3j());
    var max = this.g3j(edge.v3j());
    if ((max - min | 0) < threshold) {
      var inductionVariable = min;
      if (inductionVariable <= max)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.h3j(n).c3j_1.h(edge);
        }
         while (!(n === max));
      return true;
    }
    return false;
  }
  w3j(edge, threshold, $super) {
    threshold = threshold === VOID ? 2147483647 : threshold;
    return $super === VOID ? this.j3j(edge, threshold) : $super.j3j.call(this, edge, threshold);
  }
}
class AllBuckets {
  constructor() {
    var tmp = this;
    var tmp_0 = PolygonScanline$AllBuckets$pool$lambda;
    tmp.x3j_1 = Pool.k2p(tmp_0, VOID, PolygonScanline$AllBuckets$pool$lambda_0);
    this.y3j_1 = new Buckets(this.x3j_1, 80);
    this.z3j_1 = new Buckets(this.x3j_1, 320);
    this.a3k_1 = new Buckets(this.x3j_1, 1280);
  }
  b3k(edge) {
    if (this.y3j_1.j3j(edge, 4))
      return Unit_instance;
    if (this.z3j_1.j3j(edge, 4))
      return Unit_instance;
    this.a3k_1.w3j(edge);
  }
  y2() {
    this.y3j_1.y2();
    this.z3j_1.y2();
    this.a3k_1.y2();
  }
}
class XWithWind {
  constructor() {
    this.w3k_1 = IntArrayList.x2j(1024);
    this.x3k_1 = IntArrayList.x2j(1024);
  }
  d1() {
    return this.w3k_1.d1();
  }
  y3k(x, wind) {
    this.w3k_1.d2k(x);
    this.x3k_1.d2k(wind);
  }
  y2() {
    this.w3k_1.y2();
    this.x3k_1.y2();
  }
  toString() {
    return 'XWithWind(' + this.w3k_1.toString() + ', ' + this.x3k_1.toString() + ')';
  }
}
class IntArrayListSort extends SortOps {
  constructor() {
    IntArrayListSort_instance = null;
    super();
    IntArrayListSort_instance = this;
  }
  z3k(subject, l, r) {
    return compareTo(subject.w3k_1.s1i(l), subject.w3k_1.s1i(r));
  }
  g2l(subject, l, r) {
    return this.z3k(subject instanceof XWithWind ? subject : THROW_CCE(), l, r);
  }
  a3l(subject, indexL, indexR) {
    subject.w3k_1.m2k(indexL, indexR);
    subject.x3k_1.m2k(indexL, indexR);
  }
  i2l(subject, indexL, indexR) {
    return this.a3l(subject instanceof XWithWind ? subject : THROW_CCE(), indexL, indexR);
  }
}
class RastScale {
  m3l() {
    return 20;
  }
  n3l() {
    return 0;
  }
  u3k(_this__u8e3s4) {
    return numberToInt(_this__u8e3s4 * this.m3l()) + this.n3l() | 0;
  }
}
class PolygonScanline extends RastScale {
  constructor() {
    super();
    this.c3k_1 = -1;
    this.d3k_1 = Winding_NON_ZERO_getInstance();
    this.e3k_1 = Companion_getInstance_4().c27();
    var tmp = this;
    tmp.f3k_1 = Pool.l2p(VOID, PolygonScanline$edgesPool$lambda);
    this.g3k_1 = FastArrayList.r1j();
    this.h3k_1 = FastArrayList.r1j();
    this.i3k_1 = FastArrayList.r1j();
    this.j3k_1 = new AllBuckets();
    this.k3k_1 = true;
    this.l3k_1 = new PointArrayList();
    this.m3k_1 = 0.0;
    this.n3k_1 = 0.0;
    this.o3k_1 = 0.0;
    this.p3k_1 = 0.0;
    this.q3k_1 = false;
    this.r3k_1 = new XWithWind();
    this.s3k_1 = 0;
    this.t3k_1 = new IntSegmentSet();
  }
  s3a() {
    return _BoundsBuilder___get_bounds__impl__s1l1gx(this.e3k_1);
  }
  d2q() {
    this.k3k_1 = true;
    this.e3k_1 = Companion_getInstance_4().x26_1;
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.g3k_1.p1j_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.math.geom.vector.PolygonScanline.reset.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[_unary__edvuaz];
      this.f3k_1.o2p(it);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = this.h3k_1.p1j_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.math.geom.vector.PolygonScanline.reset.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it_0 = array_0[_unary__edvuaz_0];
      this.f3k_1.o2p(it_0);
    }
    this.g3k_1.y2();
    this.h3k_1.y2();
    this.i3k_1.y2();
    this.l3k_1.xg();
    this.j3k_1.y2();
    this.m3k_1 = 0.0;
    this.n3k_1 = 0.0;
    this.o3k_1 = 0.0;
    this.p3k_1 = 0.0;
    this.q3k_1 = false;
  }
  b3l() {
    return this.g3k_1.d1();
  }
  m28() {
    return this.b3l() > 0;
  }
  c3l(x, y) {
    this.o3k_1 = x;
    this.p3k_1 = y;
    this.m3k_1 = x;
    this.n3k_1 = y;
    this.q3k_1 = true;
  }
  d3l(x, y) {
    if (this.q3k_1) {
      addPoint(this, this.o3k_1, this.p3k_1);
    }
    addEdge(this, this.o3k_1, this.p3k_1, x, y);
    addPoint(this, x, y);
    this.o3k_1 = x;
    this.p3k_1 = y;
    this.q3k_1 = false;
  }
  b3e(p) {
    return this.c3l(p.c26_1, p.d26_1);
  }
  d3e(p) {
    return this.d3l(p.c26_1, p.d26_1);
  }
  e3l(path) {
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D.w28();
    var l = Vector2D.w28();
    // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call
    if (false) {
      this.y5();
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.j3e_1;
    var n_0 = 0;
    while (n_0 < this_0.d1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.s1i(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.k3e_1.f1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.l28(tmp, path.k3e_1.f1(_unary__edvuaz_1));
          i = it;
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call

          this.f3l(it, true);
          l = it;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.k3e_1.f1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.l28(tmp_0, path.k3e_1.f1(_unary__edvuaz_3));
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call

          this.f3l(it_0, false);
          l = it_0;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.k3e_1.f1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var c = Vector2D.l28(tmp_1, path.k3e_1.f1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.k3e_1.f1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var a = Vector2D.l28(tmp_2, path.k3e_1.f1(_unary__edvuaz_7));
          var sum = Companion_getInstance().m2h(l, c) + Companion_getInstance().m2h(c, a);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_0 = numberToInt(sum);
          var rcurveSteps = Math.max(a_0, 20);
          var dt = 1.0 / rcurveSteps;
          var lastPos = {_v: Vector2D.w28()};
          var prevPos = {_v: Vector2D.w28()};
          var emittedCount = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio = Companion_getInstance_6().m1i_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos._v = Companion_getInstance_8().b3c(l, c, a, ratio);
          var nStart = false ? 0 : 1;
          var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
          var inductionVariable = nStart;
          if (inductionVariable <= nEnd)
            do {
              var n_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_1 = Companion_getInstance_8().b3c(l, c, a, ratio_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call
              this.f3l(it_1, false);
              emittedCount._v = emittedCount._v + 1 | 0;
              lastPos._v = prevPos._v;
              prevPos._v = it_1;
            }
             while (!(n_1 === nEnd));
          l = a;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.k3e_1.f1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var c0 = Vector2D.l28(tmp_3, path.k3e_1.f1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.k3e_1.f1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var c1 = Vector2D.l28(tmp_4, path.k3e_1.f1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.k3e_1.f1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var a_1 = Vector2D.l28(tmp_5, path.k3e_1.f1(_unary__edvuaz_13));
          var sum_0 = Companion_getInstance().m2h(l, c0) + Companion_getInstance().m2h(c0, c1) + Companion_getInstance().m2h(c1, a_1);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_2 = numberToInt(sum_0);
          var rcurveSteps_0 = Math.max(a_2, 20);
          var dt_0 = 1.0 / rcurveSteps_0;
          var lastPos_0 = {_v: Vector2D.w28()};
          var prevPos_0 = {_v: Vector2D.w28()};
          var emittedCount_0 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_1 = Companion_getInstance_6().m1i_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_0._v = Companion_getInstance_8().a3c(l, c0, c1, a_1, ratio_1);
          var nStart_0 = false ? 0 : 1;
          var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
          var inductionVariable_0 = nStart_0;
          if (inductionVariable_0 <= nEnd_0)
            do {
              var n_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_2 = Companion_getInstance_8().a3c(l, c0, c1, a_1, ratio_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call
              this.f3l(it_2, false);
              emittedCount_0._v = emittedCount_0._v + 1 | 0;
              lastPos_0._v = prevPos_0._v;
              prevPos_0._v = it_2;
            }
             while (!(n_2 === nEnd_0));
          l = a_1;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call

          var p = i;
          this.f3l(p, false);
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call

          if (true) {
            this.y5();
          }

          break;
      }
    }
    // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call
    if (false) {
      this.y5();
    }
  }
  f3l(p, move) {
    var tmp;
    if (move) {
      this.b3e(p);
      tmp = Unit_instance;
    } else {
      this.d3e(p);
      tmp = Unit_instance;
    }
    return tmp;
  }
  g3l(x, y, move) {
    var tmp;
    if (move) {
      this.c3l(x, y);
      tmp = Unit_instance;
    } else {
      this.d3l(x, y);
      tmp = Unit_instance;
    }
    return tmp;
  }
  y5() {
    this.d3l(this.m3k_1, this.n3k_1);
  }
  h3l(y, winding, out) {
    this.s3k_1 = 0;
    this.r3k_1.y2();
    out.xg();
    var tmp = this;
    var tmp_0 = this.s3k_1;
    // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY' call
    var edgesChecked = 0;
    // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY' call
    var this_0 = this.j3k_1;
    // Inline function 'korlibs.math.geom.vector.Buckets.fastForEachY' call
    var this_1 = this_0.y3j_1;
    if (this_1.d1() > 0) {
      var tmp47_safe_receiver = this_1.i3j(y);
      if (tmp47_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.math.geom.vector.Bucket.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array = tmp47_safe_receiver.c3j_1.p1j_1;
        var n = 0;
        while (n < array.length) {
          // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY.<anonymous>' call
          var edge = array[_unary__edvuaz];
          edgesChecked = edgesChecked + 1 | 0;
          if (edge.j3l(y)) {
            // Inline function 'korlibs.math.geom.vector.PolygonScanline.scanline.<anonymous>' call
            if (!edge.r3j_1) {
              this.r3k_1.y3k(edge.i3l(y), edge.o3j_1);
            }
          }
        }
      }
    }
    // Inline function 'korlibs.math.geom.vector.Buckets.fastForEachY' call
    var this_2 = this_0.z3j_1;
    if (this_2.d1() > 0) {
      var tmp47_safe_receiver_0 = this_2.i3j(y);
      if (tmp47_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'korlibs.math.geom.vector.Bucket.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_0 = tmp47_safe_receiver_0.c3j_1.p1j_1;
        var n_0 = 0;
        while (n_0 < array_0.length) {
          // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz_0 = n_0;
          n_0 = _unary__edvuaz_0 + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY.<anonymous>' call
          var edge_0 = array_0[_unary__edvuaz_0];
          edgesChecked = edgesChecked + 1 | 0;
          if (edge_0.j3l(y)) {
            // Inline function 'korlibs.math.geom.vector.PolygonScanline.scanline.<anonymous>' call
            if (!edge_0.r3j_1) {
              this.r3k_1.y3k(edge_0.i3l(y), edge_0.o3j_1);
            }
          }
        }
      }
    }
    // Inline function 'korlibs.math.geom.vector.Buckets.fastForEachY' call
    var this_3 = this_0.a3k_1;
    if (this_3.d1() > 0) {
      var tmp47_safe_receiver_1 = this_3.i3j(y);
      if (tmp47_safe_receiver_1 == null)
        null;
      else {
        // Inline function 'korlibs.math.geom.vector.Bucket.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_1 = tmp47_safe_receiver_1.c3j_1.p1j_1;
        var n_1 = 0;
        while (n_1 < array_1.length) {
          // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz_1 = n_1;
          n_1 = _unary__edvuaz_1 + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY.<anonymous>' call
          var edge_1 = array_1[_unary__edvuaz_1];
          edgesChecked = edgesChecked + 1 | 0;
          if (edge_1.j3l(y)) {
            // Inline function 'korlibs.math.geom.vector.PolygonScanline.scanline.<anonymous>' call
            if (!edge_1.r3j_1) {
              this.r3k_1.y3k(edge_1.i3l(y), edge_1.o3j_1);
            }
          }
        }
      }
    }
    tmp.s3k_1 = tmp_0 + edgesChecked | 0;
    genericSort(this.r3k_1, 0, this.r3k_1.d1() - 1 | 0, IntArrayListSort_getInstance());
    var tempX = this.r3k_1.w3k_1;
    var tempW = this.r3k_1.x3k_1;
    if (this.r3k_1.d1() >= 2) {
      switch (winding.k3_1) {
        case 0:
          var progression = step(until(0, tempX.d1() - 1 | 0), 2);
          var inductionVariable = progression.y1_1;
          var last = progression.z1_1;
          var step_0 = progression.a2_1;
          if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + step_0 | 0;
              var a = tempX.s1i(i);
              var b = tempX.s1i(i + 1 | 0);
              out.y2r(a, b);
            }
             while (!(i === last));
          break;
        case 1:
          var count = 0;
          var startX = 0;
          var endX = 0;
          var pending = false;
          var inductionVariable_0 = 0;
          var last_0 = tempX.d1() - 1 | 0;
          if (inductionVariable_0 < last_0)
            do {
              var i_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var a_0 = tempX.s1i(i_0);
              count = count + tempW.s1i(i_0) | 0;
              var b_0 = tempX.s1i(i_0 + 1 | 0);
              if (!(count === 0)) {
                if (pending && !(a_0 === endX)) {
                  out.y2r(startX, endX);
                  startX = a_0;
                  endX = b_0;
                } else {
                  if (!pending) {
                    startX = a_0;
                  }
                  endX = b_0;
                }
                pending = true;
              }
            }
             while (inductionVariable_0 < last_0);
          if (pending) {
            out.y2r(startX, endX);
          }

          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
    }
    return out;
  }
  k3l(x, y, winding) {
    return this.l3l(this.u3k(x), this.u3k(y), winding);
  }
  l3l(x, y, winding) {
    var ss = this.t3k_1;
    this.h3l(y, winding, ss.xg());
    return ss.wo(x);
  }
}
class Companion_6 {
  constructor() {
    this.o3l_1 = 20;
    this.p3l_1 = 0;
    this.q3l_1 = 80;
    this.r3l_1 = 320;
    this.s3l_1 = 1280;
  }
}
class Companion_7 {
  t3l(a, b) {
    // Inline function 'korlibs.math.geom.vector.Companion._getIntersectXY' call
    var Ax = a.k3j_1;
    var Ay = a.l3j_1;
    var Bx = a.m3j_1;
    var By = a.n3j_1;
    var Cx = b.k3j_1;
    var Cy = b.l3j_1;
    var Dx = b.m3j_1;
    var Dy = b.n3j_1;
    var tmp52_safe_receiver = this.u3l(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy);
    var tmp;
    if (tmp52_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.vector.Companion._getIntersectXY.<anonymous>' call
      tmp = Vector2I.w2f(numberToInt(floorCeil(tmp52_safe_receiver.c26_1)), numberToInt(floorCeil(tmp52_safe_receiver.d26_1)));
    }
    var tmp51_safe_receiver = tmp;
    var tmp_0;
    if (tmp51_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.vector.Companion.getIntersectXY.<anonymous>' call
      tmp_0 = Vector2D.y28(tmp51_safe_receiver.t2f_1, tmp51_safe_receiver.u2f_1);
    }
    return tmp_0;
  }
  v3l(a, b) {
    return Angle__minus_impl_xeau7k(b.w3l(), a.w3l());
  }
  u3l(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy) {
    return Companion_instance_15.u3l(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy);
  }
}
class MEdge {
  constructor() {
    this.k3j_1 = 0;
    this.l3j_1 = 0;
    this.m3j_1 = 0;
    this.n3j_1 = 0;
    this.o3j_1 = 0;
    this.p3j_1 = 0;
    this.q3j_1 = 0;
    this.r3j_1 = false;
    this.s3j_1 = false;
    this.t3j_1 = 0;
  }
  j28(n) {
    return n === 0 ? this.k3j_1 : this.m3j_1;
  }
  k28(n) {
    return n === 0 ? this.l3j_1 : this.n3j_1;
  }
  x3l(other) {
    return this.v3k(other.k3j_1, other.l3j_1, other.m3j_1, other.n3j_1, other.o3j_1);
  }
  v3k(ax, ay, bx, by, wind) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.MEdge.setTo.<anonymous>' call
    this.k3j_1 = ax;
    this.l3j_1 = ay;
    this.m3j_1 = bx;
    this.n3j_1 = by;
    this.q3j_1 = bx - ax | 0;
    this.p3j_1 = by - ay | 0;
    this.r3j_1 = ay === by;
    this.s3j_1 = ax === bx;
    this.o3j_1 = wind;
    this.t3j_1 = this.s3j_1 ? 0 : ay - (imul(ax, this.p3j_1) / this.q3j_1 | 0) | 0;
    return this;
  }
  u3j() {
    // Inline function 'kotlin.math.min' call
    var a = this.l3j_1;
    var b = this.n3j_1;
    return Math.min(a, b);
  }
  v3j() {
    // Inline function 'kotlin.math.max' call
    var a = this.l3j_1;
    var b = this.n3j_1;
    return Math.max(a, b);
  }
  j3l(y) {
    return y >= this.l3j_1 && y < this.n3j_1;
  }
  i3l(y) {
    return this.s3j_1 || this.p3j_1 === 0 ? this.k3j_1 : imul(y - this.t3j_1 | 0, this.q3j_1) / this.p3j_1 | 0;
  }
  w3l() {
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var x0 = this.k3j_1;
    var y0 = this.l3j_1;
    var x1 = this.m3j_1;
    var y1 = this.n3j_1;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var up = Companion_getInstance().i26_1;
    return Angle_between(x0, y0, x1, y1, up);
  }
  toString() {
    return 'Edge([' + this.k3j_1 + ',' + this.l3j_1 + ']-[' + this.m3j_1 + ',' + this.n3j_1 + '])';
  }
}
class EdgePoint extends Enum {
  constructor(name, ordinal, n) {
    super(name, ordinal);
    this.r3m_1 = n;
  }
}
class StrokeToFill {
  constructor() {
    this.y3l_1 = 1;
    this.a3m_1 = LineCap_BUTT_getInstance();
    this.b3m_1 = LineCap_BUTT_getInstance();
    this.c3m_1 = LineJoin_BEVEL_getInstance();
    this.d3m_1 = 4.0;
    this.e3m_1 = new PointIntArrayList(1024);
    this.f3m_1 = IntArrayList.x2j(1024);
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(2), null);
    while (tmp_0 < 2) {
      tmp_1[tmp_0] = new PointIntArrayList(1024);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.g3m_1 = tmp_1;
    this.h3m_1 = this.g3m_1[0];
    this.i3m_1 = this.g3m_1[1];
    this.j3m_1 = new MEdge();
    this.k3m_1 = new MEdge();
    this.l3m_1 = new MEdge();
    this.m3m_1 = new MEdge();
    this.n3m_1 = new MEdge();
    this.o3m_1 = new MEdge();
  }
  s3m(_this__u8e3s4, edge, width, angle) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.StrokeToFill.setEdgeDisplaced.<anonymous>' call
    var ldx = width * _Angle___get_cosine__impl__vprvmu(angle);
    var ldy = width * _Angle___get_sine__impl__15nmyi(angle);
    _this__u8e3s4.v3k(numberToInt(edge.k3j_1 + ldx), numberToInt(edge.l3j_1 + ldy), numberToInt(edge.m3j_1 + ldx), numberToInt(edge.n3j_1 + ldy), edge.o3j_1);
    return _this__u8e3s4;
  }
  t3m(_this__u8e3s4, e) {
    return _this__u8e3s4.y2r(e.k3j_1, e.l3j_1);
  }
  u3m(_this__u8e3s4, e) {
    return _this__u8e3s4.y2r(e.m3j_1, e.n3j_1);
  }
  v3m(_this__u8e3s4, e) {
    _this__u8e3s4.y2r(numberToInt(e.c26_1), numberToInt(e.d26_1));
  }
  w3m(out, mainPrev, mainCurr, prev, curr, join, miterLimit, scale, forcedMiter) {
    var rjoin = forcedMiter ? LineJoin_MITER_getInstance() : join;
    switch (rjoin.k3_1) {
      case 2:
        var intersection2 = Vector2D.y28(mainPrev.m3j_1, mainPrev.n3j_1);
        var intersection = Companion_instance_7.t3l(prev, curr);
        if (!(intersection == null)) {
          var dist = Companion_getInstance().m2h(intersection, intersection2);
          if (forcedMiter || dist <= miterLimit) {
            out.z2r(toInt(intersection));
          } else {
            this.u3m(out, prev);
            this.t3m(out, curr);
          }
        }

        break;
      case 0:
        this.u3m(out, prev);
        this.t3m(out, curr);
        break;
      case 1:
        var i = Companion_instance_7.t3l(prev, curr);
        if (!(i == null)) {
          var count = clamp_0(numberToInt(Companion_getInstance().l2h(prev.m3j_1, prev.n3j_1, curr.k3j_1, curr.l3j_1) * scale), 4, 64);
          var inductionVariable = 0;
          if (inductionVariable <= count)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              this.v3m(out, Companion_getInstance_8().b3c(Vector2D.l28(prev.m3j_1, prev.n3j_1), Vector2D.l28(i.c26_1, i.d26_1), Vector2D.l28(curr.k3j_1, curr.l3j_1), _Ratio___init__impl__9mwvn2(n / count)));
            }
             while (!(n === count));
        } else {
          this.u3m(out, prev);
          this.t3m(out, curr);
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  x3m(l, r, left, right, epoint, cap, scale) {
    var angle = epoint.equals(EdgePoint_A_getInstance()) ? Angle__unaryMinus_impl_7901fr(left.w3l()) : Angle__unaryPlus_impl_eyi5pl(left.w3l());
    var lx = left.j28(epoint.r3m_1);
    var ly = left.k28(epoint.r3m_1);
    var rx = right.j28(epoint.r3m_1);
    var ry = right.k28(epoint.r3m_1);
    switch (cap.k3_1) {
      case 0:
        l.y2r(lx, ly);
        r.y2r(rx, ry);
        break;
      case 2:
      case 1:
        var ax = numberToInt(_Angle___get_cosine__impl__vprvmu(angle) * this.y3l_1 / 2);
        var ay = numberToInt(_Angle___get_sine__impl__15nmyi(angle) * this.y3l_1 / 2);
        var lx2 = lx + ax | 0;
        var ly2 = ly + ay | 0;
        var rx2 = rx + ax | 0;
        var ry2 = ry + ay | 0;
        if (cap.equals(LineCap_SQUARE_getInstance())) {
          l.y2r(lx2, ly2);
          r.y2r(rx2, ry2);
        } else {
          var count = clamp_0(numberToInt(Companion_getInstance_22().l2h(lx, ly, rx, ry) * scale), 4, 64);
          l.y2r(lx, ly);
          var inductionVariable = 0;
          if (inductionVariable <= count)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var m = epoint.equals(EdgePoint_A_getInstance()) ? n : count - n | 0;
              var ratio = _Ratio___init__impl__9mwvn2(m / count);
              this.v3m(r, Companion_getInstance_8().a3c(Vector2D.l28(lx, ly), Vector2D.l28(lx2, ly2), Vector2D.l28(rx2, ry2), Vector2D.l28(rx, ry), ratio));
            }
             while (!(n === count));
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  f3n(scale, closed) {
    if (this.e3m_1.g1())
      return Unit_instance;
    var weightD2 = this.y3l_1 / 2 | 0;
    this.h3m_1.y2();
    this.i3m_1.y2();
    var sp = this.e3m_1;
    var nstrokePoints = sp.d1();
    var inductionVariable = 0;
    if (inductionVariable < nstrokePoints)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var isFirst = n === 0;
        var isLast = n === (nstrokePoints - 1 | 0);
        var isMiddle = !isFirst && (!isLast || closed);
        var n1 = isLast ? closed ? 1 : n : n + 1 | 0;
        this.j3m_1.x3l(this.m3m_1);
        this.k3m_1.x3l(this.n3m_1);
        this.l3m_1.x3l(this.o3m_1);
        var doJoin = !(this.f3m_1.s1i(n) === 0);
        this.m3m_1.v3k(sp.j28(n), sp.k28(n), sp.j28(n1), sp.k28(n1), 1);
        this.s3m(this.n3m_1, this.m3m_1, weightD2, Angle__minus_impl_xeau7k(this.m3m_1.w3l(), get_degrees(90)));
        this.s3m(this.o3m_1, this.m3m_1, weightD2, Angle__plus_impl_26v37k(this.m3m_1.w3l(), get_degrees(90)));
        if (isFirst) {
          this.x3m(this.h3m_1, this.i3m_1, this.n3m_1, this.o3m_1, EdgePoint_A_getInstance(), closed ? LineCap_BUTT_getInstance() : this.a3m_1, scale);
        } else if (isMiddle) {
          var angle = Companion_instance_7.v3l(this.j3m_1, this.m3m_1);
          var leftAngle = Angle__compareTo_impl_a0hfds(angle, get_degrees(0)) > 0;
          if (doJoin) {
            this.w3m(this.h3m_1, this.j3m_1, this.m3m_1, this.k3m_1, this.n3m_1, this.c3m_1, this.d3m_1, scale, leftAngle);
            this.w3m(this.i3m_1, this.j3m_1, this.m3m_1, this.l3m_1, this.o3m_1, this.c3m_1, this.d3m_1, scale, !leftAngle);
          } else {
            this.t3m(this.h3m_1, this.n3m_1);
            this.t3m(this.i3m_1, this.o3m_1);
          }
        } else if (isLast) {
          if (closed) {
            this.x3m(this.h3m_1, this.i3m_1, this.n3m_1, this.o3m_1, EdgePoint_B_getInstance(), LineCap_BUTT_getInstance(), scale);
          } else {
            this.x3m(this.h3m_1, this.i3m_1, this.k3m_1, this.l3m_1, EdgePoint_B_getInstance(), this.b3m_1, scale);
          }
        }
      }
       while (inductionVariable < nstrokePoints);
    var inductionVariable_0 = 0;
    var last = this.h3m_1.d1();
    if (inductionVariable_0 < last)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var x = this.h3m_1.j28(n_0);
        var y = this.h3m_1.k28(n_0);
        if (n_0 === 0) {
          _get_outFill__zcv64g(this).b3e(Vector2D.l28(x * scale, y * scale));
        } else {
          _get_outFill__zcv64g(this).d3e(Vector2D.l28(x * scale, y * scale));
        }
      }
       while (inductionVariable_0 < last);
    var inductionVariable_1 = 0;
    var last_0 = this.i3m_1.d1();
    if (inductionVariable_1 < last_0)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var m = (this.i3m_1.d1() - n_1 | 0) - 1 | 0;
        _get_outFill__zcv64g(this).d3e(Vector2D.l28(this.i3m_1.j28(m) * scale, this.i3m_1.k28(m) * scale));
      }
       while (inductionVariable_1 < last_0);
    _get_outFill__zcv64g(this).y5();
    _get_outFill__zcv64g(this).l3e_1 = Winding_NON_ZERO_getInstance();
    this.e3m_1.y2();
    this.f3m_1.y2();
  }
  g3n(outFill, weight, startCap, endCap, joins, miterLimit) {
    this.z3l_1 = outFill;
    this.y3l_1 = weight;
    this.a3m_1 = startCap;
    this.b3m_1 = endCap;
    this.c3m_1 = joins;
    this.d3m_1 = miterLimit * weight;
  }
  h3n(stroke, lineWidth, joins, startCap, endCap, miterLimit, outFill) {
    var scale = 20;
    var iscale = 1.0 / 20;
    this.g3n(outFill, numberToInt(lineWidth * scale), startCap, endCap, joins, miterLimit);
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D.w28();
    var l = Vector2D.w28();
    // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call
    if (false) {
      this.f3n(iscale, true);
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = stroke.j3e_1;
    var n_0 = 0;
    while (n_0 < this_0.d1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.s1i(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = stroke.k3e_1.f1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.l28(tmp, stroke.k3e_1.f1(_unary__edvuaz_1));
          i = it;
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          if (true) {
            this.f3n(iscale, false);
          }

          this.e3m_1.y2r(numberToInt(it.c26_1 * scale), numberToInt(it.d26_1 * scale));
          this.f3m_1.d2k(0);
          l = it;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = stroke.k3e_1.f1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.l28(tmp_0, stroke.k3e_1.f1(_unary__edvuaz_3));
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          if (false) {
            this.f3n(iscale, false);
          }

          this.e3m_1.y2r(numberToInt(it_0.c26_1 * scale), numberToInt(it_0.d26_1 * scale));
          this.f3m_1.d2k(0);
          l = it_0;
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          this.f3m_1.i2k(this.f3m_1.d1() - 1 | 0, 1);
          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = stroke.k3e_1.f1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var c = Vector2D.l28(tmp_1, stroke.k3e_1.f1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = stroke.k3e_1.f1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var a = Vector2D.l28(tmp_2, stroke.k3e_1.f1(_unary__edvuaz_7));
          var sum = Companion_getInstance().m2h(l, c) + Companion_getInstance().m2h(c, a);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_0 = numberToInt(sum);
          var rcurveSteps = Math.max(a_0, 20);
          var dt = 1.0 / rcurveSteps;
          var lastPos = {_v: Vector2D.w28()};
          var prevPos = {_v: Vector2D.w28()};
          var emittedCount = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio = Companion_getInstance_6().m1i_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos._v = Companion_getInstance_8().b3c(l, c, a, ratio);
          var nStart = false ? 0 : 1;
          var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
          var inductionVariable = nStart;
          if (inductionVariable <= nEnd)
            do {
              var n_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_1 = Companion_getInstance_8().b3c(l, c, a, ratio_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call
              if (false) {
                this.f3n(iscale, false);
              }
              this.e3m_1.y2r(numberToInt(it_1.c26_1 * scale), numberToInt(it_1.d26_1 * scale));
              this.f3m_1.d2k(0);
              emittedCount._v = emittedCount._v + 1 | 0;
              lastPos._v = prevPos._v;
              prevPos._v = it_1;
            }
             while (!(n_1 === nEnd));
          l = a;
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          this.f3m_1.i2k(this.f3m_1.d1() - 1 | 0, 1);
          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = stroke.k3e_1.f1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var c0 = Vector2D.l28(tmp_3, stroke.k3e_1.f1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = stroke.k3e_1.f1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var c1 = Vector2D.l28(tmp_4, stroke.k3e_1.f1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = stroke.k3e_1.f1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var a_1 = Vector2D.l28(tmp_5, stroke.k3e_1.f1(_unary__edvuaz_13));
          var sum_0 = Companion_getInstance().m2h(l, c0) + Companion_getInstance().m2h(c0, c1) + Companion_getInstance().m2h(c1, a_1);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_2 = numberToInt(sum_0);
          var rcurveSteps_0 = Math.max(a_2, 20);
          var dt_0 = 1.0 / rcurveSteps_0;
          var lastPos_0 = {_v: Vector2D.w28()};
          var prevPos_0 = {_v: Vector2D.w28()};
          var emittedCount_0 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_1 = Companion_getInstance_6().m1i_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_0._v = Companion_getInstance_8().a3c(l, c0, c1, a_1, ratio_1);
          var nStart_0 = false ? 0 : 1;
          var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
          var inductionVariable_0 = nStart_0;
          if (inductionVariable_0 <= nEnd_0)
            do {
              var n_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_2 = Companion_getInstance_8().a3c(l, c0, c1, a_1, ratio_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call
              if (false) {
                this.f3n(iscale, false);
              }
              this.e3m_1.y2r(numberToInt(it_2.c26_1 * scale), numberToInt(it_2.d26_1 * scale));
              this.f3m_1.d2k(0);
              emittedCount_0._v = emittedCount_0._v + 1 | 0;
              lastPos_0._v = prevPos_0._v;
              prevPos_0._v = it_2;
            }
             while (!(n_2 === nEnd_0));
          l = a_1;
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          this.f3m_1.i2k(this.f3m_1.d1() - 1 | 0, 1);
          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          var p = i;
          if (false) {
            this.f3n(iscale, false);
          }

          this.e3m_1.y2r(numberToInt(p.c26_1 * scale), numberToInt(p.d26_1 * scale));
          this.f3m_1.d2k(0);
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          this.f3m_1.i2k(this.f3m_1.d1() - 1 | 0, 1);
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          if (true) {
            this.f3n(iscale, true);
          }

          break;
      }
    }
    // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call
    if (false) {
      this.f3n(iscale, true);
    }
    this.f3n(iscale, false);
  }
}
class VectorBuilder {}
function quadTo(c, a) {
  // Inline function 'korlibs.math.geom.bezier.Companion.quadToCubic' call
  var this_0 = Companion_getInstance_8();
  var x0 = this.c3e().c26_1;
  var y0 = this.c3e().d26_1;
  var xc = c.c26_1;
  var yc = c.d26_1;
  var x1 = a.c26_1;
  var y1 = a.d26_1;
  var cx1 = this_0.c3c(x0, xc);
  var cy1 = this_0.c3c(y0, yc);
  var cx2 = this_0.d3c(xc, x1);
  var cy2 = this_0.d3c(yc, y1);
  this.g3e(Vector2D.l28(cx1, cy1), Vector2D.l28(cx2, cy2), Vector2D.l28(x1, y1));
}
function line(p0, p1) {
  this.b3e(p0);
  this.d3e(p1);
}
function arcTo(a, c, r) {
  return Arc_instance.a3e(this, a, c, r);
}
function isEmpty() {
  return this.m3n() === 0;
}
function isNotEmpty() {
  return !(this.m3n() === 0);
}
function rect(rect) {
  return this.r3n(rect.m26_1, rect.n26_1, rect.o26_1, rect.p26_1);
}
function rect_0(pos, size) {
  this.r3n(pos.c26_1, pos.d26_1, size.h27_1, size.i27_1);
}
function rect_1(x, y, width, height) {
  this.b3e(Vector2D.l28(x, y));
  this.d3e(Vector2D.l28(x + width, y));
  this.d3e(Vector2D.l28(x + width, y + height));
  this.d3e(Vector2D.l28(x, y + height));
  this.y5();
}
function roundRect(x, y, w, h, rtl, rtr, rbr, rbl) {
  if (rtl === 0.0 && rtr === 0.0 && rbr === 0.0 && rbl === 0.0) {
    this.r3n(x, y, w, h);
  } else {
    this.b3e(Vector2D.l28(x + rtl, y));
    this.o3n(Vector2D.l28(x + w, y), Vector2D.l28(x + w, y + h), rtr);
    this.o3n(Vector2D.l28(x + w, y + h), Vector2D.l28(x, y + h), rbr);
    this.o3n(Vector2D.l28(x, y + h), Vector2D.l28(x, y), rbl);
    this.o3n(Vector2D.l28(x, y), Vector2D.l28(x + w, y), rtl);
    this.y5();
  }
}
function roundRect_0(rect) {
  var r = rect.b2g_1;
  var c = rect.c2g_1;
  this.s3n(r.m26_1, r.n26_1, r.o26_1, r.p26_1, c.i2e_1, c.j2e_1, c.l2e_1, c.k2e_1);
}
function roundRect_1(x, y, w, h, rx, ry) {
  var r = w < 2 * rx ? w / 2.0 : h < 2 * rx ? h / 2.0 : rx;
  this.s3n(x, y, w, h, r, r, r, r);
}
function arc(center, r, start, end, counterclockwise) {
  return Arc_instance.h3e(this, center, numberToDouble(r), start, end, counterclockwise);
}
function arc$default(center, r, start, end, counterclockwise, $super) {
  counterclockwise = counterclockwise === VOID ? false : counterclockwise;
  var tmp;
  if ($super === VOID) {
    this.t3n(center, r, start, end, counterclockwise);
    tmp = Unit_instance;
  } else {
    arc(center, r, start, end, counterclockwise);
    tmp = Unit_instance;
  }
  return tmp;
}
function circle(center, radius) {
  return this.u3n(center, radius, Companion_getInstance_0().t25_1, Companion_getInstance_0().x25_1);
}
function ellipse(center, radius) {
  return Arc_instance.f3e(this, minus(center, radius), radius.y2g(2));
}
function lineToH(x) {
  return this.d3e(Vector2D.l28(x, this.c3e().d26_1));
}
function lineToV(y) {
  return this.d3e(Vector2D.l28(this.c3e().c26_1, y));
}
function rLineToH(x) {
  return this.a3o(Vector2D.l28(x, 0.0));
}
function rLineToV(y) {
  return this.a3o(Vector2D.l28(0.0, y));
}
function rMoveTo(delta) {
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var this_0 = this.c3e();
  var tmp$ret$0 = Vector2D.l28(this_0.c26_1 + delta.c26_1, this_0.d26_1 + delta.d26_1);
  return this.b3e(tmp$ret$0);
}
function rLineTo(delta) {
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var this_0 = this.c3e();
  var tmp$ret$0 = Vector2D.l28(this_0.c26_1 + delta.c26_1, this_0.d26_1 + delta.d26_1);
  return this.d3e(tmp$ret$0);
}
function rLineTo_0(a, relative) {
  var tmp;
  if (relative) {
    this.a3o(a);
    tmp = Unit_instance;
  } else {
    this.d3e(a);
    tmp = Unit_instance;
  }
  return tmp;
}
function rMoveTo_0(a, relative) {
  var tmp;
  if (relative) {
    this.z3n(a);
    tmp = Unit_instance;
  } else {
    this.b3e(a);
    tmp = Unit_instance;
  }
  return tmp;
}
function rLineToH_0(x, relative) {
  var tmp;
  if (relative) {
    this.x3n(x);
    tmp = Unit_instance;
  } else {
    this.v3n(x);
    tmp = Unit_instance;
  }
  return tmp;
}
function rLineToV_0(y, relative) {
  var tmp;
  if (relative) {
    this.y3n(y);
    tmp = Unit_instance;
  } else {
    this.w3n(y);
    tmp = Unit_instance;
  }
  return tmp;
}
function transformed(m) {
  var im = m.c2b();
  var parent = this;
  return new VectorBuilder$transformed$1(parent, im, m);
}
function transformed_0(m, block) {
  return block(this.n2f(m));
}
class VectorBuilder$transformed$1 {
  constructor($parent, $im, $m) {
    this.j3n_1 = $parent;
    this.k3n_1 = $im;
    this.l3n_1 = $m;
    this.i3n_1 = $parent.m3n();
  }
  c3e() {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.k3n_1;
      var p = this.j3n_1.c3e();
      if (this_0.r26()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.l28(this_0.i2a(p.c26_1, p.d26_1), this_0.l2a(p.c26_1, p.d26_1));
    }
    return tmp$ret$0;
  }
  m3n() {
    return this.i3n_1;
  }
  y5() {
    return this.j3n_1.y5();
  }
  d3e(p) {
    return this.j3n_1.d3e(t(this, p));
  }
  b3e(p) {
    return this.j3n_1.d3e(t(this, p));
  }
  e3e(c, a) {
    return this.j3n_1.e3e(t(this, c), t(this, a));
  }
  g3e(c1, c2, a) {
    return this.j3n_1.g3e(t(this, c1), t(this, c2), t(this, a));
  }
}
class Companion_8 {}
class Visitor {}
function close() {
  return Unit_instance;
}
function moveTo(p) {
  return Unit_instance;
}
function lineTo(p) {
  return Unit_instance;
}
function quadTo_0(c, a) {
  return Unit_instance;
}
function cubicTo(c1, c2, a) {
  return Unit_instance;
}
class VectorPath extends AbstractShape2D {
  constructor(commands, data, winding, optimize) {
    commands = commands === VOID ? IntArrayList.x2j() : commands;
    data = data === VOID ? DoubleArrayList.r2k() : data;
    winding = winding === VOID ? Companion_instance_9.j3o() : winding;
    optimize = optimize === VOID ? true : optimize;
    super();
    this.i3e_1 = new Mixin();
    this.j3e_1 = commands;
    this.k3e_1 = data;
    this.l3e_1 = winding;
    this.m3e_1 = optimize;
    this.n3e_1 = false;
    this.o3e_1 = 0;
    this.p3e_1 = Vector2D.w28();
    this.q3e_1 = Vector2D.w28();
    this.r3e_1 = null;
    this.s3e_1 = null;
  }
  y1i(_set____db54di) {
    this.i3e_1.y1i(_set____db54di);
  }
  z1i() {
    return this.i3e_1.z1i();
  }
  u1i() {
    return new VectorPath(IntArrayList.z2j(this.j3e_1), DoubleArrayList.s2k(this.k3e_1), this.l3e_1);
  }
  equals(other) {
    if (this === other)
      return true;
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof VectorPath) {
      tmp_1 = this.j3e_1.equals(other.j3e_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.k3e_1.equals(other.k3e_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.l3e_1.equals(other.l3e_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return (this.j3e_1.hashCode() + imul(this.k3e_1.hashCode(), 13) | 0) + imul(this.l3e_1.k3_1, 111) | 0;
  }
  k3o(visitor) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.j3e_1;
    var n_0 = 0;
    while (n_0 < this_0.d1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.s1i(_unary__edvuaz)) {
        case 0:
          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = this.k3e_1.f1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var p0 = Vector2D.l28(tmp, this.k3e_1.f1(_unary__edvuaz_1));
          visitor.b3e(p0);
          break;
        case 1:
          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = this.k3e_1.f1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var p0_0 = Vector2D.l28(tmp_0, this.k3e_1.f1(_unary__edvuaz_3));
          visitor.d3e(p0_0);
          break;
        case 2:
          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = this.k3e_1.f1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var p0_1 = Vector2D.l28(tmp_1, this.k3e_1.f1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = this.k3e_1.f1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var p1 = Vector2D.l28(tmp_2, this.k3e_1.f1(_unary__edvuaz_7));
          visitor.e3e(p0_1, p1);
          break;
        case 3:
          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = this.k3e_1.f1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var p0_2 = Vector2D.l28(tmp_3, this.k3e_1.f1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = this.k3e_1.f1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var p1_0 = Vector2D.l28(tmp_4, this.k3e_1.f1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = this.k3e_1.f1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var p2 = Vector2D.l28(tmp_5, this.k3e_1.f1(_unary__edvuaz_13));
          visitor.g3e(p0_2, p1_0, p2);
          break;
        case 4:
          visitor.y5();
          break;
      }
    }
  }
  y2() {
    this.j3e_1.y2();
    this.k3e_1.y2();
    this.p3e_1 = Vector2D.w28();
    this.o3e_1 = 0;
    this.l3o().c3k_1 = this.o3e_1 - 1 | 0;
  }
  c3e() {
    return this.p3e_1;
  }
  b3e(p) {
    if (this.j3e_1.m28() && this.j3e_1.k2k() === 0) {
      if (this.p3e_1.equals(p))
        return Unit_instance;
    }
    this.j3e_1.d2k(0);
    this.k3e_1.w2k(p.c26_1, p.d26_1);
    this.p3e_1 = p;
    this.q3e_1 = p;
    this.o3e_1 = this.o3e_1 + 1 | 0;
  }
  d3e(p) {
    if (ensureMoveTo(this, p) && this.m3e_1)
      return Unit_instance;
    if (p.equals(this.p3e_1) && this.m3e_1)
      return Unit_instance;
    this.j3e_1.d2k(1);
    this.k3e_1.w2k(p.c26_1, p.d26_1);
    this.p3e_1 = p;
    this.o3e_1 = this.o3e_1 + 1 | 0;
  }
  e3e(c, a) {
    ensureMoveTo(this, c);
    this.j3e_1.d2k(2);
    this.k3e_1.x2k(c.c26_1, c.d26_1, a.c26_1, a.d26_1);
    this.p3e_1 = a;
    this.o3e_1 = this.o3e_1 + 1 | 0;
  }
  g3e(c1, c2, a) {
    ensureMoveTo(this, c1);
    this.j3e_1.d2k(3);
    this.k3e_1.y2k(c1.c26_1, c1.d26_1, c2.c26_1, c2.d26_1, a.c26_1, a.d26_1);
    this.p3e_1 = a;
    this.o3e_1 = this.o3e_1 + 1 | 0;
  }
  y5() {
    this.j3e_1.d2k(4);
    this.p3e_1 = this.q3e_1;
    this.o3e_1 = this.o3e_1 + 1 | 0;
  }
  m3n() {
    return this.k3e_1.d1() / 2 | 0;
  }
  s3a() {
    return _BoundsBuilder___get_bounds__impl__s1l1gx(plus(Companion_getInstance_4().c27(), this));
  }
  m3o(p) {
    return this.k3l(p.c26_1, p.d26_1, this.l3e_1);
  }
  l3o() {
    if (this.s3e_1 == null)
      this.s3e_1 = new PolygonScanline();
    var scanline = ensureNotNull(this.s3e_1);
    if (!(scanline.c3k_1 === this.o3e_1)) {
      scanline.d2q();
      scanline.e3l(this);
      scanline.c3k_1 = this.o3e_1;
    }
    return ensureNotNull(this.s3e_1);
  }
  k3l(x, y, winding) {
    return this.l3o().k3l(x, y, winding);
  }
  n3o(path, transform) {
    this.j3e_1.f2k(path.j3e_1);
    if (transform.f2a()) {
      this.k3e_1.a2l(path.k3e_1);
      this.p3e_1 = path.p3e_1;
    } else {
      var progression = step(until(0, path.k3e_1.d1()), 2);
      var inductionVariable = progression.y1_1;
      var last = progression.z1_1;
      var step_0 = progression.a2_1;
      if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + step_0 | 0;
          var tmp$ret$0;
          $l$block: {
            // Inline function 'korlibs.math.geom.Matrix.transform' call
            var p = Vector2D.l28(path.k3e_1.f1(n + 0 | 0), path.k3e_1.f1(n + 1 | 0));
            if (transform.r26()) {
              tmp$ret$0 = p;
              break $l$block;
            }
            tmp$ret$0 = Vector2D.l28(transform.i2a(p.c26_1, p.d26_1), transform.l2a(p.c26_1, p.d26_1));
          }
          var p_0 = tmp$ret$0;
          this.k3e_1.w2k(p_0.c26_1, p_0.d26_1);
        }
         while (!(n === last));
      var tmp = this;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_1 = path.p3e_1;
        if (transform.r26()) {
          tmp$ret$1 = p_1;
          break $l$block_0;
        }
        tmp$ret$1 = Vector2D.l28(transform.i2a(p_1.c26_1, p_1.d26_1), transform.l2a(p_1.c26_1, p_1.d26_1));
      }
      tmp.p3e_1 = tmp$ret$1;
    }
    this.o3e_1 = this.o3e_1 + 1 | 0;
  }
  o3o(path, transform, $super) {
    transform = transform === VOID ? Companion_getInstance_2().n29_1 : transform;
    var tmp;
    if ($super === VOID) {
      this.n3o(path, transform);
      tmp = Unit_instance;
    } else {
      tmp = $super.n3o.call(this, path, transform);
    }
    return tmp;
  }
  p3o() {
    // Inline function 'kotlin.text.trimEnd' call
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.j3e_1;
    var n_0 = 0;
    while (n_0 < this_1.d1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_1.s1i(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = this.k3e_1.f1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.l28(tmp, this.k3e_1.f1(_unary__edvuaz_1));
          var x = destruct.bl();
          var y = destruct.cl();
          this_0.nb('M' + get_niceStr(x) + ',' + get_niceStr(y) + ' ');
          break;
        case 1:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = this.k3e_1.f1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.l28(tmp_0, this.k3e_1.f1(_unary__edvuaz_3));
          var x_0 = destruct_0.bl();
          var y_0 = destruct_0.cl();
          this_0.nb('L' + get_niceStr(x_0) + ',' + get_niceStr(y_0) + ' ');
          break;
        case 2:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = this.k3e_1.f1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.l28(tmp_1, this.k3e_1.f1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = this.k3e_1.f1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.l28(tmp_2, this.k3e_1.f1(_unary__edvuaz_7));
          var x1 = destruct_1.bl();
          var y1 = destruct_1.cl();
          var x2 = destruct_2.bl();
          var y2 = destruct_2.cl();
          this_0.nb('Q' + get_niceStr(x1) + ',' + get_niceStr(y1) + ',' + get_niceStr(x2) + ',' + get_niceStr(y2) + ' ');
          break;
        case 3:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = this.k3e_1.f1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.l28(tmp_3, this.k3e_1.f1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = this.k3e_1.f1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.l28(tmp_4, this.k3e_1.f1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = this.k3e_1.f1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.l28(tmp_5, this.k3e_1.f1(_unary__edvuaz_13));
          var x1_0 = destruct_3.bl();
          var y1_0 = destruct_3.cl();
          var x2_0 = destruct_4.bl();
          var y2_0 = destruct_4.cl();
          var x3 = destruct_5.bl();
          var y3 = destruct_5.cl();
          this_0.nb('C' + get_niceStr(x1_0) + ',' + get_niceStr(y1_0) + ',' + get_niceStr(x2_0) + ',' + get_niceStr(y2_0) + ',' + get_niceStr(x3) + ',' + get_niceStr(y3) + ' ');
          break;
        case 4:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          this_0.nb('Z ');
          break;
      }
    }
    var this_2 = this_0.toString();
    return toString(trimEnd(isCharSequence(this_2) ? this_2 : THROW_CCE()));
  }
  toString() {
    return 'VectorPath(' + this.p3o() + ')';
  }
  q3o(sx, sy) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.transformPoints' call
    var progression = step(until(0, this.k3e_1.d1()), 2);
    var inductionVariable = progression.y1_1;
    var last = progression.z1_1;
    var step_0 = progression.a2_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        // Inline function 'korlibs.math.geom.vector.VectorPath.scale.<anonymous>' call
        var it = Vector2D.l28(this.k3e_1.f1(n + 0 | 0), this.k3e_1.f1(n + 1 | 0));
        var p = Vector2D.l28(it.c26_1 * sx, it.d26_1 * sy);
        this.k3e_1.d2l(n + 0 | 0, p.c26_1);
        this.k3e_1.d2l(n + 1 | 0, p.d26_1);
      }
       while (!(n === last));
    this.o3e_1 = this.o3e_1 + 1 | 0;
    return this;
  }
}
class with$1 {
  constructor($bb) {
    this.r3o_1 = $bb;
  }
  b3e(p) {
    this.r3o_1._v = new BoundsBuilder(BoundsBuilder__plus_impl_cz7f7x(this.r3o_1._v.p27_1, p));
  }
}
class Companion_9 {
  j3o() {
    return Winding_NON_ZERO_getInstance();
  }
}
class Winding extends Enum {
  constructor(name, ordinal, str) {
    super(name, ordinal);
    this.u3o_1 = str;
  }
}
class Companion_10 {
  v3o(str) {
    var tmp;
    // Inline function 'kotlin.text.isNullOrEmpty' call
    // Inline function 'kotlin.contracts.contract' call
    if (str == null || charSequenceLength(str) === 0) {
      tmp = LineJoin_MITER_getInstance();
    } else {
      var tmp61_subject = uppercaseChar(charSequenceGet(str, 0));
      tmp = tmp61_subject === _Char___init__impl__6a9atx(77) ? LineJoin_MITER_getInstance() : tmp61_subject === _Char___init__impl__6a9atx(66) ? LineJoin_BEVEL_getInstance() : tmp61_subject === _Char___init__impl__6a9atx(83) ? LineJoin_BEVEL_getInstance() : tmp61_subject === _Char___init__impl__6a9atx(82) ? LineJoin_ROUND_getInstance() : LineJoin_MITER_getInstance();
    }
    return tmp;
  }
}
class LineJoin extends Enum {}
class Companion_11 {
  v3o(str) {
    var tmp;
    // Inline function 'kotlin.text.isNullOrEmpty' call
    // Inline function 'kotlin.contracts.contract' call
    if (str == null || charSequenceLength(str) === 0) {
      tmp = LineCap_BUTT_getInstance();
    } else {
      var tmp60_subject = uppercaseChar(charSequenceGet(str, 0));
      tmp = tmp60_subject === _Char___init__impl__6a9atx(66) ? LineCap_BUTT_getInstance() : tmp60_subject === _Char___init__impl__6a9atx(83) ? LineCap_SQUARE_getInstance() : tmp60_subject === _Char___init__impl__6a9atx(82) ? LineCap_ROUND_getInstance() : LineCap_BUTT_getInstance();
    }
    return tmp;
  }
}
class LineCap extends Enum {}
class LineScaleMode extends Enum {
  constructor(name, ordinal, hScale, vScale) {
    super(name, ordinal);
    this.y3o_1 = hScale;
    this.z3o_1 = vScale;
    this.a3p_1 = this.y3o_1 || this.z3o_1;
    this.b3p_1 = (this.y3o_1 && this.z3o_1);
  }
}
class Companion_12 {}
class StrokeInfo {
  constructor(thickness, pixelHinting, scaleMode, startCap, endCap, join, miterLimit, dash, dashOffset) {
    thickness = thickness === VOID ? 1.0 : thickness;
    pixelHinting = pixelHinting === VOID ? false : pixelHinting;
    scaleMode = scaleMode === VOID ? LineScaleMode_NORMAL_getInstance() : scaleMode;
    startCap = startCap === VOID ? LineCap_BUTT_getInstance() : startCap;
    endCap = endCap === VOID ? LineCap_BUTT_getInstance() : endCap;
    join = join === VOID ? LineJoin_MITER_getInstance() : join;
    miterLimit = miterLimit === VOID ? 20.0 : miterLimit;
    dash = dash === VOID ? null : dash;
    dashOffset = dashOffset === VOID ? 0.0 : dashOffset;
    this.k38_1 = thickness;
    this.l38_1 = pixelHinting;
    this.m38_1 = scaleMode;
    this.n38_1 = startCap;
    this.o38_1 = endCap;
    this.p38_1 = join;
    this.q38_1 = miterLimit;
    this.r38_1 = dash;
    this.s38_1 = dashOffset;
  }
  toString() {
    return 'StrokeInfo(thickness=' + this.k38_1 + ', pixelHinting=' + this.l38_1 + ', scaleMode=' + this.m38_1.toString() + ', startCap=' + this.n38_1.toString() + ', endCap=' + this.o38_1.toString() + ', join=' + this.p38_1.toString() + ', miterLimit=' + this.q38_1 + ', dash=' + toString_0(this.r38_1) + ', dashOffset=' + this.s38_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.k38_1);
    result = imul(result, 31) + getBooleanHashCode(this.l38_1) | 0;
    result = imul(result, 31) + this.m38_1.hashCode() | 0;
    result = imul(result, 31) + this.n38_1.hashCode() | 0;
    result = imul(result, 31) + this.o38_1.hashCode() | 0;
    result = imul(result, 31) + this.p38_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.q38_1) | 0;
    result = imul(result, 31) + (this.r38_1 == null ? 0 : hashCode(this.r38_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s38_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StrokeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof StrokeInfo ? other : THROW_CCE();
    if (!equals(this.k38_1, tmp0_other_with_cast.k38_1))
      return false;
    if (!(this.l38_1 === tmp0_other_with_cast.l38_1))
      return false;
    if (!this.m38_1.equals(tmp0_other_with_cast.m38_1))
      return false;
    if (!this.n38_1.equals(tmp0_other_with_cast.n38_1))
      return false;
    if (!this.o38_1.equals(tmp0_other_with_cast.o38_1))
      return false;
    if (!this.p38_1.equals(tmp0_other_with_cast.p38_1))
      return false;
    if (!equals(this.q38_1, tmp0_other_with_cast.q38_1))
      return false;
    if (!equals(this.r38_1, tmp0_other_with_cast.r38_1))
      return false;
    if (!equals(this.s38_1, tmp0_other_with_cast.s38_1))
      return false;
    return true;
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_13 = this;
    var tmp = this;
    var tmp_0 = MPoint$Companion$POOL$lambda;
    tmp.y3m_1 = ConcurrentPool.x2p(tmp_0, VOID, MPoint$Companion$POOL$lambda_0);
    this.z3m_1 = new MPoint(0.0, 0.0);
    this.a3n_1 = new MPoint(1.0, 1.0);
    this.b3n_1 = new MPoint(0.0, -1.0);
    this.c3n_1 = new MPoint(0.0, +1.0);
    this.d3n_1 = new MPoint(-1.0, 0.0);
    this.e3n_1 = new MPoint(+1.0, 0.0);
  }
  q29() {
    return new MPoint(0.0, 0.0);
  }
  f3p(lx, ly, rx, ry) {
    var ret = compareTo(ly, ry);
    return ret === 0 ? compareTo(lx, rx) : ret;
  }
  q2f(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  l2h(x1, y1, x2, y2) {
    return this.q2f(x1, y1, x2, y2);
  }
  g3p(aX, aY, bX, bY) {
    return aX * bX + aY * bY;
  }
}
class MPoint {
  constructor(x, y) {
    Companion_getInstance_22();
    this.c3p_1 = x;
    this.d3p_1 = y;
  }
  h3p(other, epsilon) {
    return isAlmostEquals_0(this.c3p_1, other.c3p_1, epsilon) && isAlmostEquals_0(this.d3p_1, other.d3p_1, epsilon);
  }
  c1i(other, epsilon) {
    return this.h3p(other instanceof MPoint ? other : THROW_CCE(), epsilon);
  }
  e3p(x, y) {
    this.c3p_1 = x;
    this.d3p_1 = y;
    return this;
  }
  i3p(other) {
    return Companion_getInstance_22().f3p(this.c3p_1, this.d3p_1, other.c3p_1, other.d3p_1);
  }
  d(other) {
    return this.i3p(other instanceof MPoint ? other : THROW_CCE());
  }
  toString() {
    return '(' + get_niceStr(this.c3p_1) + ', ' + get_niceStr(this.d3p_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.c3p_1);
    result = imul(result, 31) + getNumberHashCode(this.d3p_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MPoint))
      return false;
    var tmp0_other_with_cast = other instanceof MPoint ? other : THROW_CCE();
    if (!equals(this.c3p_1, tmp0_other_with_cast.c3p_1))
      return false;
    if (!equals(this.d3p_1, tmp0_other_with_cast.d3p_1))
      return false;
    return true;
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_14 = this;
    var tmp = this;
    var tmp_0 = MMatrix$Companion$POOL$lambda;
    tmp.q3p_1 = ConcurrentPool.x2p(tmp_0, VOID, MMatrix$Companion$POOL$lambda_0);
  }
}
class MMatrix {
  constructor(a, b, c, d, tx, ty) {
    Companion_getInstance_23();
    a = a === VOID ? 1.0 : a;
    b = b === VOID ? 0.0 : b;
    c = c === VOID ? 0.0 : c;
    d = d === VOID ? 1.0 : d;
    tx = tx === VOID ? 0.0 : tx;
    ty = ty === VOID ? 0.0 : ty;
    this.j3p_1 = a;
    this.k3p_1 = b;
    this.l3p_1 = c;
    this.m3p_1 = d;
    this.n3p_1 = tx;
    this.o3p_1 = ty;
  }
  r3p() {
    return new Matrix(this.j3p_1, this.k3p_1, this.l3p_1, this.m3p_1, this.n3p_1, this.o3p_1);
  }
  s3p(a, b, c, d, tx, ty) {
    this.j3p_1 = a;
    this.k3p_1 = b;
    this.l3p_1 = c;
    this.m3p_1 = d;
    this.n3p_1 = tx;
    this.o3p_1 = ty;
    return this;
  }
  t3p(that) {
    return this.s3p(that.s29_1, that.t29_1, that.u29_1, that.v29_1, that.w29_1, that.x29_1);
  }
  u3p(dx, dy) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.MMatrix.pretranslate.<anonymous>' call
    this.n3p_1 = this.n3p_1 + (this.j3p_1 * dx + this.l3p_1 * dy);
    this.o3p_1 = this.o3p_1 + (this.k3p_1 * dx + this.m3p_1 * dy);
    return this;
  }
  p3p() {
    return this.s3p(1.0, 0.0, 0.0, 1.0, 0.0, 0.0);
  }
  toString() {
    return 'Matrix(a=' + this.j3p_1 + ', b=' + this.k3p_1 + ', c=' + this.l3p_1 + ', d=' + this.m3p_1 + ', tx=' + this.n3p_1 + ', ty=' + this.o3p_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.j3p_1);
    result = imul(result, 31) + getNumberHashCode(this.k3p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.l3p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.m3p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n3p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o3p_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MMatrix))
      return false;
    var tmp0_other_with_cast = other instanceof MMatrix ? other : THROW_CCE();
    if (!equals(this.j3p_1, tmp0_other_with_cast.j3p_1))
      return false;
    if (!equals(this.k3p_1, tmp0_other_with_cast.k3p_1))
      return false;
    if (!equals(this.l3p_1, tmp0_other_with_cast.l3p_1))
      return false;
    if (!equals(this.m3p_1, tmp0_other_with_cast.m3p_1))
      return false;
    if (!equals(this.n3p_1, tmp0_other_with_cast.n3p_1))
      return false;
    if (!equals(this.o3p_1, tmp0_other_with_cast.o3p_1))
      return false;
    return true;
  }
}
class Companion_15 {
  v3p(point, direction, scale, out) {
    return out.w3p(point.c26_1, point.d26_1, point.c26_1 + direction.c26_1 * scale, point.d26_1 + direction.d26_1 * scale);
  }
  l39(point, direction, scale, out, $super) {
    scale = scale === VOID ? 1.0 : scale;
    out = out === VOID ? MLine.x3p() : out;
    return $super === VOID ? this.v3p(point, direction, scale, out) : $super.v3p.call(this, point, direction, scale, out);
  }
  u3l(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy) {
    var a1 = By - Ay;
    var b1 = Ax - Bx;
    var c1 = a1 * Ax + b1 * Ay;
    var a2 = Dy - Cy;
    var b2 = Cx - Dx;
    var c2 = a2 * Cx + b2 * Cy;
    var determinant = a1 * b2 - a2 * b1;
    if (isAlmostZero(determinant))
      return null;
    var x = (b2 * c1 - b1 * c2) / determinant;
    var y = (a1 * c2 - a2 * c1) / determinant;
    return Vector2D.l28(x, y);
  }
}
class MLine {
  static y3p(a, b) {
    var $this = createThis(this);
    $this.m39_1 = a;
    $this.n39_1 = b;
    return $this;
  }
  u1i() {
    return MLine.y3p(this.m39_1, this.n39_1);
  }
  w3p(x0, y0, x1, y1) {
    this.m39_1 = Vector2D.l28(x0, y0);
    this.n39_1 = Vector2D.l28(x1, y1);
    return this;
  }
  o39(scale) {
    var tmp = this;
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var this_0 = this.m39_1;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_1 = this.z3p();
    var that = Vector2D.l28(this_1.c26_1 * scale, this_1.d26_1 * scale);
    tmp.m39_1 = Vector2D.l28(this_0.c26_1 - that.c26_1, this_0.d26_1 - that.d26_1);
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var this_2 = this.n39_1;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_3 = this.z3p();
    var that_0 = Vector2D.l28(this_3.c26_1 * scale, this_3.d26_1 * scale);
    tmp_0.n39_1 = Vector2D.l28(this_2.c26_1 - that_0.c26_1, this_2.d26_1 - that_0.d26_1);
    return this;
  }
  static x3p() {
    return this.y3p(Vector2D.w28(), Vector2D.w28());
  }
  z28() {
    return this.m39_1.c26_1;
  }
  a29() {
    return this.m39_1.d26_1;
  }
  b29() {
    return this.n39_1.c26_1;
  }
  c29() {
    return this.n39_1.d26_1;
  }
  z3p() {
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var this_0 = this.n39_1;
    var that = this.m39_1;
    return Vector2D.l28(this_0.c26_1 - that.c26_1, this_0.d26_1 - that.d26_1);
  }
  toString() {
    return 'Line(' + this.m39_1.toString() + ', ' + this.n39_1.toString() + ')';
  }
  a3q(line) {
    return Companion_instance_15.u3l(this.z28(), this.a29(), this.b29(), this.c29(), line.z28(), line.a29(), line.b29(), line.c29());
  }
  hashCode() {
    var result = this.m39_1.hashCode();
    result = imul(result, 31) + this.n39_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MLine))
      return false;
    var tmp0_other_with_cast = other instanceof MLine ? other : THROW_CCE();
    if (!this.m39_1.equals(tmp0_other_with_cast.m39_1))
      return false;
    if (!this.n39_1.equals(tmp0_other_with_cast.n39_1))
      return false;
    return true;
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_16 = this;
    var tmp = this;
    var tmp_0 = MRectangle$Companion$POOL$lambda;
    tmp.f3q_1 = ConcurrentPool.x2p(tmp_0, VOID, MRectangle$Companion$POOL$lambda_0);
  }
  q29() {
    return new MRectangle(0.0, 0.0, 0.0, 0.0);
  }
}
class MRectangle {
  constructor(x, y, width, height) {
    Companion_getInstance_25();
    this.b3q_1 = x;
    this.c3q_1 = y;
    this.d3q_1 = width;
    this.e3q_1 = height;
  }
  g3q(other, epsilon) {
    return isAlmostEquals_0(this.b3q_1, other.b3q_1, epsilon) && isAlmostEquals_0(this.c3q_1, other.c3q_1, epsilon) && isAlmostEquals_0(this.d3q_1, other.d3q_1, epsilon) && isAlmostEquals_0(this.e3q_1, other.e3q_1, epsilon);
  }
  c1i(other, epsilon) {
    return this.g3q(other instanceof MRectangle ? other : THROW_CCE(), epsilon);
  }
  t26() {
    return this.b3q_1;
  }
  v26() {
    return this.c3q_1;
  }
  u26() {
    return this.b3q_1 + this.d3q_1;
  }
  w26() {
    return this.c3q_1 + this.e3q_1;
  }
  w3p(x, y, width, height) {
    this.b3q_1 = x;
    this.c3q_1 = y;
    this.d3q_1 = width;
    this.e3q_1 = height;
    return this;
  }
  h3q(left, top, right, bottom) {
    return this.w3p(left, top, right - left, bottom - top);
  }
  i3q(left, top, right, bottom) {
    return this.h3q(this.t26() - left, this.v26() - top, this.u26() + right, this.w26() + bottom);
  }
  j3q(left, top, right, bottom, $super) {
    top = top === VOID ? left : top;
    right = right === VOID ? left : right;
    bottom = bottom === VOID ? top : bottom;
    return $super === VOID ? this.i3q(left, top, right, bottom) : $super.i3q.call(this, left, top, right, bottom);
  }
  xg() {
    return this.w3p(0.0, 0.0, 0.0, 0.0);
  }
  toString() {
    return 'Rectangle(x=' + get_niceStr(this.b3q_1) + ', y=' + get_niceStr(this.c3q_1) + ', width=' + get_niceStr(this.d3q_1) + ', height=' + get_niceStr(this.e3q_1) + ')';
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof MRectangle) {
      tmp_2 = isAlmostEquals_0(this.b3q_1, other.b3q_1);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = isAlmostEquals_0(this.c3q_1, other.c3q_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = isAlmostEquals_0(this.d3q_1, other.d3q_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = isAlmostEquals_0(this.e3q_1, other.e3q_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  r3p() {
    return new Rectangle(this.b3q_1, this.c3q_1, this.d3q_1, this.e3q_1);
  }
  hashCode() {
    var result = getNumberHashCode(this.b3q_1);
    result = imul(result, 31) + getNumberHashCode(this.c3q_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d3q_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e3q_1) | 0;
    return result;
  }
}
class Easings extends Enum {
  toString() {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    return replace(super.toString(), _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45)).toLowerCase();
  }
}
class Easings$SMOOTH extends Easings {
  constructor() {
    super('SMOOTH', 0);
    Easings_SMOOTH_instance = this;
  }
  f1i(it) {
    return it * it * (3 - 2 * it);
  }
}
class Easings$EASE_IN_ELASTIC extends Easings {
  constructor() {
    super('EASE_IN_ELASTIC', 1);
    Easings_EASE_IN_ELASTIC_instance = this;
  }
  f1i(it) {
    var tmp;
    switch (it) {
      case 0.0:
      case 1.0:
        tmp = it;
        break;
      default:
        var p = 0.3;
        var s = p / 4.0;
        var inv = it - 1;
        var tmp_0 = -1.0;
        // Inline function 'kotlin.math.pow' call

        var x = 10.0 * inv;
        var tmp_1 = tmp_0 * Math.pow(2.0, x);
        // Inline function 'kotlin.math.sin' call

        var x_0 = (inv - s) * (2.0 * 3.141592653589793) / p;
        tmp = tmp_1 * Math.sin(x_0);
        break;
    }
    return tmp;
  }
}
class Easings$EASE_OUT_ELASTIC extends Easings {
  constructor() {
    super('EASE_OUT_ELASTIC', 2);
    Easings_EASE_OUT_ELASTIC_instance = this;
  }
  f1i(it) {
    var tmp;
    switch (it) {
      case 0.0:
      case 1.0:
        tmp = it;
        break;
      default:
        var p = 0.3;
        var s = p / 4.0;
        // Inline function 'kotlin.math.pow' call

        var x = -10.0 * it;
        var tmp_0 = Math.pow(2.0, x);
        // Inline function 'kotlin.math.sin' call

        var x_0 = (it - s) * (2.0 * 3.141592653589793) / p;
        tmp = tmp_0 * Math.sin(x_0) + 1;
        break;
    }
    return tmp;
  }
}
class Easings$EASE_OUT_BOUNCE extends Easings {
  constructor() {
    super('EASE_OUT_BOUNCE', 3);
    Easings_EASE_OUT_BOUNCE_instance = this;
  }
  f1i(it) {
    var s = 7.5625;
    var p = 2.75;
    var tmp;
    if (it < 1.0 / p) {
      // Inline function 'kotlin.math.pow' call
      tmp = s * Math.pow(it, 2.0);
    } else if (it < 2.0 / p) {
      // Inline function 'kotlin.math.pow' call
      var this_0 = it - 1.5 / p;
      tmp = s * Math.pow(this_0, 2.0) + 0.75;
    } else if (it < 2.5 / p) {
      // Inline function 'kotlin.math.pow' call
      var this_1 = it - 2.25 / p;
      tmp = s * Math.pow(this_1, 2.0) + 0.9375;
    } else {
      // Inline function 'kotlin.math.pow' call
      var this_2 = it - 2.625 / p;
      tmp = s * Math.pow(this_2, 2.0) + 0.984375;
    }
    return tmp;
  }
}
class Easings$LINEAR extends Easings {
  constructor() {
    super('LINEAR', 4);
    Easings_LINEAR_instance = this;
  }
  f1i(it) {
    return it;
  }
}
class Easings$EASE extends Easings {
  constructor() {
    super('EASE', 5);
    Easings_EASE_instance = this;
    this.w3q_1 = EasingCubic.d3r(0.25, 0.1, 0.25, 1.0, 'ease');
  }
  f1i(it) {
    return this.w3q_1.f1i(it);
  }
}
class Easings$EASE_IN extends Easings {
  constructor() {
    super('EASE_IN', 6);
    Easings_EASE_IN_instance = this;
    this.g3r_1 = EasingCubic.d3r(0.42, 0.0, 1.0, 1.0, 'ease-in');
  }
  f1i(it) {
    return this.g3r_1.f1i(it);
  }
}
class Easings$EASE_OUT extends Easings {
  constructor() {
    super('EASE_OUT', 7);
    Easings_EASE_OUT_instance = this;
    this.j3r_1 = EasingCubic.d3r(0.0, 0.0, 0.58, 1.0, 'ease-out');
  }
  f1i(it) {
    return this.j3r_1.f1i(it);
  }
}
class Easings$EASE_IN_OUT extends Easings {
  constructor() {
    super('EASE_IN_OUT', 8);
    Easings_EASE_IN_OUT_instance = this;
    this.m3r_1 = EasingCubic.d3r(0.42, 0.0, 0.58, 1.0, 'ease-in-out');
  }
  f1i(it) {
    return this.m3r_1.f1i(it);
  }
}
class Easings$EASE_IN_OLD extends Easings {
  constructor() {
    super('EASE_IN_OLD', 9);
    Easings_EASE_IN_OLD_instance = this;
  }
  f1i(it) {
    return it * it * it;
  }
}
class Easings$EASE_OUT_OLD extends Easings {
  constructor() {
    super('EASE_OUT_OLD', 10);
    Easings_EASE_OUT_OLD_instance = this;
  }
  f1i(it) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.interpolation.EASE_OUT_OLD.invoke.<anonymous>' call
    var inv = it - 1.0;
    return inv * inv * inv + 1;
  }
}
class Easings$EASE_IN_OUT_OLD extends Easings {
  constructor() {
    super('EASE_IN_OUT_OLD', 11);
    Easings_EASE_IN_OUT_OLD_instance = this;
  }
  f1i(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_IN_OLD_getInstance();
    var end = Easings_EASE_OUT_OLD_getInstance();
    return it < 0.5 ? 0.5 * start.f1i(it * 2.0) : 0.5 * end.f1i((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_OLD extends Easings {
  constructor() {
    super('EASE_OUT_IN_OLD', 12);
    Easings_EASE_OUT_IN_OLD_instance = this;
  }
  f1i(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_OUT_OLD_getInstance();
    var end = Easings_EASE_IN_OLD_getInstance();
    return it < 0.5 ? 0.5 * start.f1i(it * 2.0) : 0.5 * end.f1i((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_BACK extends Easings {
  constructor() {
    super('EASE_IN_BACK', 13);
    Easings_EASE_IN_BACK_instance = this;
  }
  f1i(it) {
    // Inline function 'kotlin.math.pow' call
    return Math.pow(it, 2.0) * ((1.70158 + 1.0) * it - 1.70158);
  }
}
class Easings$EASE_OUT_BACK extends Easings {
  constructor() {
    super('EASE_OUT_BACK', 14);
    Easings_EASE_OUT_BACK_instance = this;
  }
  f1i(it) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.interpolation.EASE_OUT_BACK.invoke.<anonymous>' call
    var inv = it - 1.0;
    // Inline function 'kotlin.math.pow' call
    return Math.pow(inv, 2.0) * ((1.70158 + 1.0) * inv + 1.70158) + 1.0;
  }
}
class Easings$EASE_IN_OUT_BACK extends Easings {
  constructor() {
    super('EASE_IN_OUT_BACK', 15);
    Easings_EASE_IN_OUT_BACK_instance = this;
  }
  f1i(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_IN_BACK_getInstance();
    var end = Easings_EASE_OUT_BACK_getInstance();
    return it < 0.5 ? 0.5 * start.f1i(it * 2.0) : 0.5 * end.f1i((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_BACK extends Easings {
  constructor() {
    super('EASE_OUT_IN_BACK', 16);
    Easings_EASE_OUT_IN_BACK_instance = this;
  }
  f1i(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_OUT_BACK_getInstance();
    var end = Easings_EASE_IN_BACK_getInstance();
    return it < 0.5 ? 0.5 * start.f1i(it * 2.0) : 0.5 * end.f1i((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_OUT_ELASTIC extends Easings {
  constructor() {
    super('EASE_IN_OUT_ELASTIC', 17);
    Easings_EASE_IN_OUT_ELASTIC_instance = this;
  }
  f1i(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_IN_ELASTIC_getInstance();
    var end = Easings_EASE_OUT_ELASTIC_getInstance();
    return it < 0.5 ? 0.5 * start.f1i(it * 2.0) : 0.5 * end.f1i((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_ELASTIC extends Easings {
  constructor() {
    super('EASE_OUT_IN_ELASTIC', 18);
    Easings_EASE_OUT_IN_ELASTIC_instance = this;
  }
  f1i(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_OUT_ELASTIC_getInstance();
    var end = Easings_EASE_IN_ELASTIC_getInstance();
    return it < 0.5 ? 0.5 * start.f1i(it * 2.0) : 0.5 * end.f1i((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_BOUNCE extends Easings {
  constructor() {
    super('EASE_IN_BOUNCE', 19);
    Easings_EASE_IN_BOUNCE_instance = this;
  }
  f1i(it) {
    return 1.0 - Easings_EASE_OUT_BOUNCE_getInstance().f1i(1.0 - it);
  }
}
class Easings$EASE_IN_OUT_BOUNCE extends Easings {
  constructor() {
    super('EASE_IN_OUT_BOUNCE', 20);
    Easings_EASE_IN_OUT_BOUNCE_instance = this;
  }
  f1i(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_IN_BOUNCE_getInstance();
    var end = Easings_EASE_OUT_BOUNCE_getInstance();
    return it < 0.5 ? 0.5 * start.f1i(it * 2.0) : 0.5 * end.f1i((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_BOUNCE extends Easings {
  constructor() {
    super('EASE_OUT_IN_BOUNCE', 21);
    Easings_EASE_OUT_IN_BOUNCE_instance = this;
  }
  f1i(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_OUT_BOUNCE_getInstance();
    var end = Easings_EASE_IN_BOUNCE_getInstance();
    return it < 0.5 ? 0.5 * start.f1i(it * 2.0) : 0.5 * end.f1i((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_QUAD extends Easings {
  constructor() {
    super('EASE_IN_QUAD', 22);
    Easings_EASE_IN_QUAD_instance = this;
  }
  f1i(it) {
    return 1.0 * it * it;
  }
}
class Easings$EASE_OUT_QUAD extends Easings {
  constructor() {
    super('EASE_OUT_QUAD', 23);
    Easings_EASE_OUT_QUAD_instance = this;
  }
  f1i(it) {
    return -1.0 * it * (it - 2);
  }
}
class Easings$EASE_IN_OUT_QUAD extends Easings {
  constructor() {
    super('EASE_IN_OUT_QUAD', 24);
    Easings_EASE_IN_OUT_QUAD_instance = this;
  }
  f1i(it) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.interpolation.EASE_IN_OUT_QUAD.invoke.<anonymous>' call
    var t = it * 2.0;
    var tmp;
    if (t < 1) {
      tmp = +1.0 / 2 * t * t;
    } else {
      tmp = -1.0 / 2 * ((t - 1) * (t - 1 - 2) - 1);
    }
    return tmp;
  }
}
class Easings$EASE_SINE extends Easings {
  constructor() {
    super('EASE_SINE', 25);
    Easings_EASE_SINE_instance = this;
  }
  f1i(it) {
    // Inline function 'kotlin.math.sin' call
    var x = it * 1.5707964;
    return Math.sin(x);
  }
}
class Easings$EASE_CLAMP_START extends Easings {
  constructor() {
    super('EASE_CLAMP_START', 26);
    Easings_EASE_CLAMP_START_instance = this;
  }
  f1i(it) {
    return it <= 0.0 ? 0.0 : 1.0;
  }
}
class Easings$EASE_CLAMP_END extends Easings {
  constructor() {
    super('EASE_CLAMP_END', 27);
    Easings_EASE_CLAMP_END_instance = this;
  }
  f1i(it) {
    return it < 1.0 ? 0.0 : 1.0;
  }
}
class Easings$EASE_CLAMP_MIDDLE extends Easings {
  constructor() {
    super('EASE_CLAMP_MIDDLE', 28);
    Easings_EASE_CLAMP_MIDDLE_instance = this;
  }
  f1i(it) {
    return it < 0.5 ? 0.0 : 1.0;
  }
}
class P {
  static d3t(x, y) {
    var $this = createThis(this);
    $this.b3t_1 = x;
    $this.c3t_1 = y;
    return $this;
  }
  static e3t(x, y) {
    return this.d3t(x, y);
  }
  v2e(that) {
    return P.d3t(this.b3t_1 * that, this.c3t_1 * that);
  }
  f3t(that) {
    return P.d3t(this.b3t_1 + that.b3t_1, this.c3t_1 + that.c3t_1);
  }
  toString() {
    return 'P(x=' + this.b3t_1 + ', y=' + this.c3t_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.b3t_1);
    result = imul(result, 31) + getNumberHashCode(this.c3t_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof P))
      return false;
    var tmp0_other_with_cast = other instanceof P ? other : THROW_CCE();
    if (!equals(this.b3t_1, tmp0_other_with_cast.b3t_1))
      return false;
    if (!equals(this.c3t_1, tmp0_other_with_cast.c3t_1))
      return false;
    return true;
  }
}
class EasingCubic {
  static d3r(x1, y1, x2, y2, name) {
    name = name === VOID ? null : name;
    var $this = createThis(this);
    $this.x3q_1 = x1;
    $this.y3q_1 = y1;
    $this.z3q_1 = x2;
    $this.a3r_1 = y2;
    $this.b3r_1 = name;
    var tmp = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c3r_1 = [P.e3t(0.0, 0.0), P.e3t(clamp_1($this.x3q_1, 0.0, 1.0), $this.y3q_1), P.e3t(clamp_1($this.z3q_1, 0.0, 1.0), $this.a3r_1), P.e3t(1.0, 1.0)];
    return $this;
  }
  static g3t(x1, y1, x2, y2, name) {
    name = name === VOID ? null : name;
    return this.d3r(x1, y1, x2, y2, name);
  }
  toString() {
    var tmp0_elvis_lhs = this.b3r_1;
    return tmp0_elvis_lhs == null ? 'cubic-bezier(' + this.x3q_1 + ', ' + this.y3q_1 + ', ' + this.z3q_1 + ', ' + this.a3r_1 + ')' : tmp0_elvis_lhs;
  }
  f1i(it) {
    var pivotLeft = it < 0.0 ? it * 10.0 : 0.0;
    var pivotRight = it > 1.0 ? it * 10.0 : 1.0;
    var pivot = it;
    var lastX = 0.0;
    var lastY = 0.0;
    var steps = 0;
    var inductionVariable = 0;
    if (inductionVariable < 50)
      $l$loop_0: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        steps = steps + 1 | 0;
        var res = calc(this, pivot);
        lastX = res.b3t_1;
        lastY = res.c3t_1;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = lastX - it;
        if (Math.abs(this_0) < 0.001)
          break $l$loop_0;
        if (it < lastX) {
          pivotRight = pivot;
          pivot = (pivotLeft + pivot) * 0.5;
        } else if (it > lastX) {
          pivotLeft = pivot;
          pivot = (pivotRight + pivot) * 0.5;
        } else {
          break $l$loop_0;
        }
      }
       while (inductionVariable < 50);
    return lastY;
  }
}
//endregion
function get(_this__u8e3s4, min, max) {
  return min + _this__u8e3s4.ko(max - min | 0) | 0;
}
function insertAt($this, n, min, max) {
  $this.a38_1.l2k(n, min);
  $this.b38_1.l2k(n, max);
}
function removeAt($this, n, count) {
  $this.a38_1.n2k(n, count);
  $this.b38_1.n2k(n, count);
}
function toVectorPath(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.shape.buildVectorPath' call
  // Inline function 'kotlin.apply' call
  var this_0 = new VectorPath();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.math.geom.toVectorPath.<anonymous>' call
  this_0.j38(_this__u8e3s4.q27_1, _this__u8e3s4.r27_1);
  return this_0;
}
function toStrokePointsList(_this__u8e3s4, info, mode, generateDebug, forceClosed) {
  mode = mode === VOID ? StrokePointsMode_NON_SCALABLE_POS_getInstance() : mode;
  generateDebug = generateDebug === VOID ? false : generateDebug;
  forceClosed = forceClosed === VOID ? null : forceClosed;
  return toStrokePointsList_0(_this__u8e3s4, info.k38_1, info.p38_1, info.n38_1, info.o38_1, info.q38_1, mode, info.r38_1, info.s38_1, generateDebug, forceClosed);
}
var StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_instance;
var StrokePointsMode_NON_SCALABLE_POS_instance;
var StrokePointsMode_entriesInitialized;
function StrokePointsMode_initEntries() {
  if (StrokePointsMode_entriesInitialized)
    return Unit_instance;
  StrokePointsMode_entriesInitialized = true;
  StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_instance = new StrokePointsMode('SCALABLE_POS_NORMAL_WIDTH', 0);
  StrokePointsMode_NON_SCALABLE_POS_instance = new StrokePointsMode('NON_SCALABLE_POS', 1);
}
function toStrokePointsList_0(_this__u8e3s4, width, join, startCap, endCap, miterLimit, mode, lineDash, lineDashOffset, generateDebug, forceClosed) {
  join = join === VOID ? LineJoin_MITER_getInstance() : join;
  startCap = startCap === VOID ? LineCap_BUTT_getInstance() : startCap;
  endCap = endCap === VOID ? LineCap_BUTT_getInstance() : endCap;
  miterLimit = miterLimit === VOID ? 10.0 : miterLimit;
  mode = mode === VOID ? StrokePointsMode_NON_SCALABLE_POS_getInstance() : mode;
  lineDash = lineDash === VOID ? null : lineDash;
  lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
  generateDebug = generateDebug === VOID ? false : generateDebug;
  forceClosed = forceClosed === VOID ? null : forceClosed;
  var tmp;
  if (!(lineDash == null)) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList.i1();
    var tmp0_iterator = _this__u8e3s4.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.math.geom.bezier.toStrokePointsList.<anonymous>' call
      var list = toDashes(element, lineDash.t1i(), lineDashOffset);
      addAll(destination, list);
    }
    tmp = destination;
  } else {
    tmp = _this__u8e3s4;
  }
  var curvesList = tmp;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.w(collectionSizeOrDefault(curvesList, 10));
  var tmp0_iterator_0 = curvesList.a1();
  while (tmp0_iterator_0.b1()) {
    var item = tmp0_iterator_0.c1();
    // Inline function 'korlibs.math.geom.bezier.toStrokePointsList.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_0 = new StrokePointsBuilder(width / 2.0, mode, generateDebug);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.bezier.toStrokePointsList.<anonymous>.<anonymous>' call
    this_0.a39(item, join, startCap, endCap, miterLimit, forceClosed);
    destination_0.h(this_0);
  }
  return destination_0;
}
function StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance() {
  StrokePointsMode_initEntries();
  return StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_instance;
}
function StrokePointsMode_NON_SCALABLE_POS_getInstance() {
  StrokePointsMode_initEntries();
  return StrokePointsMode_NON_SCALABLE_POS_instance;
}
function get_isConvex(_this__u8e3s4) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = isConvex$delegate;
    var property = isConvex$factory();
    var tmp0_elvis_lhs = this_0.c1j_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d1j_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c1j_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var isConvex$delegate;
function Curves$contiguous$delegate$lambda(this$0) {
  return function () {
    var inductionVariable = 1;
    var last = this$0.v39_1.d1();
    var tmp;
    if (inductionVariable < last) {
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var curr = this$0.v39_1.f1(n - 1 | 0);
        var next = this$0.v39_1.f1(n);
        if (!curr.b3a_1.x2l().d1i(next.b3a_1.w2l()))
          return false;
      }
       while (inductionVariable < last);
      tmp = Unit_instance;
    }
    return true;
  };
}
function Curves$infos$delegate$lambda(this$0) {
  return function () {
    var pos = 0.0;
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_0 = this$0.v39_1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var index = 0;
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.math.geom.bezier.Curves.infos$delegate.<anonymous>.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var index_0 = checkIndexOverflow(tmp1);
      var start = pos;
      pos = pos + item.a();
      var tmp$ret$0 = new CurveInfo(index_0, item, start, pos, item.s3a());
      destination.h(tmp$ret$0);
    }
    return destination;
  };
}
function Curves$length$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.datastructure.sumOfDouble' call
    var sum = 0.0;
    var _iterator__ex2g4s = this$0.t3a().a1();
    while (_iterator__ex2g4s.b1()) {
      var element = _iterator__ex2g4s.c1();
      var tmp = sum;
      // Inline function 'korlibs.math.geom.bezier.Curves.length$delegate.<anonymous>.<anonymous>' call
      sum = tmp + element.a();
    }
    return sum;
  };
}
function Curves$findInfo$lambda($pos) {
  return function (it) {
    return it.v1i($pos) ? 0 : it.q3a_1 < $pos ? -1 : 1;
  };
}
function Curves$ratioFromLength$lambda($length) {
  return function (it) {
    return it.q3a_1 < $length ? -1 : it.p3a_1 > $length ? 1 : 0;
  };
}
function Bezier$Extrema$allt$delegate$lambda(this$0) {
  return function () {
    return combineSmallDistinctSorted(Companion_getInstance_8(), this$0.g3b_1, this$0.h3b_1);
  };
}
function Bezier$Extrema$xt01$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.doubleArrayOf' call
    return primitiveArrayConcat([new Float64Array([0.0]), this$0.g3b_1, new Float64Array([1.0])]);
  };
}
function Bezier$Extrema$yt01$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.doubleArrayOf' call
    return primitiveArrayConcat([new Float64Array([0.0]), this$0.h3b_1, new Float64Array([1.0])]);
  };
}
function map($this, v, ds, de, ts, te) {
  return convertRange(v, ds, de, ts, te);
}
function angle($this, o, v1, v2) {
  var dx1 = v1.c26_1 - o.c26_1;
  var dy1 = v1.d26_1 - o.d26_1;
  var dx2 = v2.c26_1 - o.c26_1;
  var dy2 = v2.d26_1 - o.d26_1;
  var cross = dx1 * dy2 - dy1 * dx2;
  var dot = dx1 * dx2 + dy1 * dy2;
  // Inline function 'kotlin.math.atan2' call
  return Math.atan2(cross, dot);
}
function compute($this, t, points) {
  var p = points;
  var order = p.d1() - 1 | 0;
  if (equals(t, Companion_getInstance_6().m1i_1))
    return p.f1(0);
  if (equals(t, Companion_getInstance_6().p1i_1))
    return p.f1(order);
  if (order === 0)
    return p.f1(0);
  var mt = Ratio__toDouble_impl_o7epze(Ratio__minus_impl_s1uwyg(Companion_getInstance_6().p1i_1, t));
  var mt2 = mt * mt;
  var t2 = Ratio__toDouble_impl_o7epze(Ratio__times_impl_ucdh7y_0(t, t));
  var tmp;
  switch (order) {
    case 1:
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_0 = p.f1(0);
      var this_1 = Vector2D.l28(this_0.c26_1 * mt, this_0.d26_1 * mt);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_2 = p.f1(1);
      var scale = Ratio__toDouble_impl_o7epze(t);
      var that = Vector2D.l28(this_2.c26_1 * scale, this_2.d26_1 * scale);
      tmp = Vector2D.l28(this_1.c26_1 + that.c26_1, this_1.d26_1 + that.d26_1);
      break;
    case 2:
      var a = mt2;
      // Inline function 'korlibs.math.interpolation.times' call

      var b = mt * _Ratio___get_value__impl__57cli6(t) * 2;
      var c = t2;
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_3 = p.f1(0);
      var this_4 = Vector2D.l28(this_3.c26_1 * a, this_3.d26_1 * a);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_5 = p.f1(1);
      var that_0 = Vector2D.l28(this_5.c26_1 * b, this_5.d26_1 * b);
      var this_6 = Vector2D.l28(this_4.c26_1 + that_0.c26_1, this_4.d26_1 + that_0.d26_1);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_7 = p.f1(2);
      var that_1 = Vector2D.l28(this_7.c26_1 * c, this_7.d26_1 * c);
      tmp = Vector2D.l28(this_6.c26_1 + that_1.c26_1, this_6.d26_1 + that_1.d26_1);
      break;
    case 3:
      var a_0 = mt2 * mt;
      // Inline function 'korlibs.math.interpolation.times' call

      var b_0 = mt2 * _Ratio___get_value__impl__57cli6(t) * 3;
      var c_0 = mt * t2 * 3;
      var d = Ratio__times_impl_ucdh7y(t, t2);
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_8 = p.f1(0);
      var this_9 = Vector2D.l28(this_8.c26_1 * a_0, this_8.d26_1 * a_0);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_10 = p.f1(1);
      var that_2 = Vector2D.l28(this_10.c26_1 * b_0, this_10.d26_1 * b_0);
      var this_11 = Vector2D.l28(this_9.c26_1 + that_2.c26_1, this_9.d26_1 + that_2.d26_1);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_12 = p.f1(2);
      var that_3 = Vector2D.l28(this_12.c26_1 * c_0, this_12.d26_1 * c_0);
      var this_13 = Vector2D.l28(this_11.c26_1 + that_3.c26_1, this_11.d26_1 + that_3.d26_1);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_14 = p.f1(3);
      var that_4 = Vector2D.l28(this_14.c26_1 * d, this_14.d26_1 * d);
      tmp = Vector2D.l28(this_13.c26_1 + that_4.c26_1, this_13.d26_1 + that_4.d26_1);
      break;
    default:
      var reason = 'higher order curves';
      throw NotImplementedError.nd('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function derive($this, points) {
  // Inline function 'kotlin.collections.arrayListOf' call
  var out = ArrayList.i1();
  var current = points;
  while (current.d1() >= 2) {
    var new_0 = new PointArrayList(current.d1() - 1 | 0);
    var c = current.d1() - 1 | 0;
    var inductionVariable = 0;
    var last = current.d1() - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.geom.Vector2D.times' call
        // Inline function 'korlibs.math.geom.Vector2D.minus' call
        var this_0 = current.f1(n + 1 | 0);
        var that = current.f1(n);
        var this_1 = Vector2D.l28(this_0.c26_1 - that.c26_1, this_0.d26_1 - that.d26_1);
        var tmp$ret$2 = Vector2D.l28(this_1.c26_1 * c, this_1.d26_1 * c);
        new_0.j2r(tmp$ret$2);
      }
       while (inductionVariable < last);
    out.h(new_0);
    current = new_0;
  }
  return out;
}
function align($this, points, line, out) {
  var p1 = line.s28_1;
  var p2 = line.t28_1;
  var tx = p1.c26_1;
  var ty = p1.d26_1;
  // Inline function 'kotlin.math.atan2' call
  var y = p2.d26_1 - ty;
  var x = p2.c26_1 - tx;
  var a = -Math.atan2(y, x);
  // Inline function 'korlibs.math.geom.fastForEach' call
  var inductionVariable = 0;
  var last = points.d1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.math.geom.bezier.Companion.align.<anonymous>' call
      var destruct = points.f1(n);
      var x_0 = destruct.bl();
      var y_0 = destruct.cl();
      var tmp = x_0 - tx;
      // Inline function 'kotlin.math.cos' call
      var tmp_0 = tmp * Math.cos(a);
      var tmp_1 = y_0 - ty;
      // Inline function 'kotlin.math.sin' call
      var tmp_2 = tmp_0 - tmp_1 * Math.sin(a);
      var tmp_3 = x_0 - tx;
      // Inline function 'kotlin.math.sin' call
      var tmp_4 = tmp_3 * Math.sin(a);
      var tmp_5 = y_0 - ty;
      // Inline function 'kotlin.math.cos' call
      var tmp$ret$4 = Math.cos(a);
      out.i2r(tmp_2, tmp_4 + tmp_5 * tmp$ret$4);
    }
     while (inductionVariable < last);
  return out;
}
function align$default($this, points, line, out, $super) {
  out = out === VOID ? new PointArrayList() : out;
  return align($this, points, line, out);
}
function droots($this, p) {
  switch (p.length) {
    case 3:
      var a = p[0];
      var b = p[1];
      var c = p[2];
      var d = a - 2 * b + c;
      if (!(d === 0.0)) {
        // Inline function 'kotlin.math.sqrt' call
        var x = b * b - a * c;
        var m1 = -Math.sqrt(x);
        var m2 = -a + b;
        var v1 = -(m1 + m2) / d;
        var v2 = -(-m1 + m2) / d;
        return doubleArrayOfValid01$default($this, v1, v2);
      } else if (!(b === c) && d === 0.0) {
        return doubleArrayOfValid01$default($this, (2.0 * b - c) / (2.0 * (b - c)));
      }

      break;
    case 2:
      var a_0 = p[0];
      var b_0 = p[1];
      if (!(a_0 === b_0))
        return doubleArrayOfValid01$default($this, a_0 / (a_0 - b_0));
      break;
    default:
      break;
  }
  return doubleArrayOfValid01$default($this);
}
function doubleArrayOfValid01($this, v1, v2, v3) {
  var v1Valid = 0.0 <= v1 ? v1 <= 1.0 : false;
  var v2Valid = 0.0 <= v2 ? v2 <= 1.0 : false;
  var v3Valid = 0.0 <= v3 ? v3 <= 1.0 : false;
  var validCount = 0;
  if (v1Valid) {
    validCount = validCount + 1 | 0;
  }
  if (v2Valid) {
    validCount = validCount + 1 | 0;
  }
  if (v3Valid) {
    validCount = validCount + 1 | 0;
  }
  if (validCount === 0)
    return $this.p3b_1;
  var index = 0;
  var out = new Float64Array(validCount);
  if (v1Valid) {
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    out[_unary__edvuaz] = normalizeZero(v1);
  }
  if (v2Valid) {
    var _unary__edvuaz_0 = index;
    index = _unary__edvuaz_0 + 1 | 0;
    out[_unary__edvuaz_0] = normalizeZero(v2);
  }
  if (v3Valid) {
    var _unary__edvuaz_1 = index;
    index = _unary__edvuaz_1 + 1 | 0;
    out[_unary__edvuaz_1] = normalizeZero(v3);
  }
  return out;
}
function doubleArrayOfValid01$default($this, v1, v2, v3, $super) {
  v1 = v1 === VOID ? NaN : v1;
  v2 = v2 === VOID ? NaN : v2;
  v3 = v3 === VOID ? NaN : v3;
  return doubleArrayOfValid01($this, v1, v2, v3);
}
function combineSmallDistinctSorted($this, a, b) {
  var out = DoubleArrayList.r2k(a.length + b.length | 0);
  out.v2k(a);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < b.length) {
    // Inline function 'korlibs.math.geom.bezier.Companion.combineSmallDistinctSorted.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = b[_unary__edvuaz];
    if (!out.v1i(it)) {
      out.t1k(it);
    }
  }
  sort(out);
  return out.t1i();
}
function _get_aligned__7fjidv($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.c3a_1;
  aligned$factory();
  return this_0.o1();
}
function _getBoundingBox($this, m) {
  var xmin = 0.0;
  var ymin = 0.0;
  var xmax = 0.0;
  var ymax = 0.0;
  var inductionVariable = 0;
  if (inductionVariable <= 1)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ext = $this.q3b().r3b(n);
      var min = Infinity;
      var max = -Infinity;
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n_0 = 0;
      while (n_0 < ext.length) {
        // Inline function 'korlibs.math.geom.bezier.Bezier._getBoundingBox.<anonymous>' call
        var _unary__edvuaz = n_0;
        n_0 = _unary__edvuaz + 1 | 0;
        var t = ext[_unary__edvuaz];
        var p = $this.s3b(_Ratio___init__impl__9mwvn2(t));
        var value = n === 0 ? transformX(p, m) : transformY(p, m);
        // Inline function 'kotlin.math.min' call
        var a = min;
        min = Math.min(a, value);
        // Inline function 'kotlin.math.max' call
        var a_0 = max;
        max = Math.max(a_0, value);
      }
      if (n === 0) {
        xmin = min;
        xmax = max;
      } else {
        ymin = min;
        ymax = max;
      }
    }
     while (inductionVariable <= 1);
  return Companion_getInstance_1().p2e(xmin, ymin, xmax, ymax);
}
function findNearestLine($this, pX, pY, aX, aY, bX, bY, out) {
  out.w3b_1 = $this;
  var atobX = bX - aX;
  var atobY = bY - aY;
  var atopX = pX - aX;
  var atopY = pY - aY;
  var len = atobX * atobX + atobY * atobY;
  var dot = atopX * atobX + atopY * atobY;
  // Inline function 'kotlin.math.min' call
  // Inline function 'kotlin.math.max' call
  var b = dot / len;
  var b_0 = Math.max(0.0, b);
  var tmp$ret$1 = Math.min(1.0, b_0);
  var t = toRatio_0(tmp$ret$1);
  var tmp = out;
  // Inline function 'korlibs.math.interpolation.times' call
  var tmp_0 = aX + atobX * _Ratio___get_value__impl__57cli6(t);
  // Inline function 'korlibs.math.interpolation.times' call
  var tmp$ret$3 = atobY * _Ratio___get_value__impl__57cli6(t);
  tmp.t3b_1 = Vector2D.l28(tmp_0, aY + tmp$ret$3);
  out.u3b_1 = t;
  out.v3b_1 = Companion_getInstance().n2h(out.t3b_1.c26_1, out.t3b_1.d26_1, pX, pY);
  return out;
}
var Companion_instance;
function Companion_getInstance_8() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function Bezier$aligned$delegate$lambda(this$0) {
  return function () {
    return align$default(Companion_getInstance_8(), this$0.b3a_1, Line2D.u28(this$0.b3a_1.w2l(), this$0.b3a_1.x2l()));
  };
}
function Bezier$dpoints$delegate$lambda(this$0) {
  return function () {
    return derive(Companion_getInstance_8(), this$0.b3a_1);
  };
}
function Bezier$direction$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var p0 = this$0.b3a_1.f1(0);
    var p1 = this$0.b3a_1.f1(this$0.m3a());
    var up = this$0.b3a_1.f1(1);
    // Inline function 'korlibs.math.geom.Companion.between' call
    var x0 = p0.c26_1;
    var y0 = p0.d26_1;
    var x1 = p1.c26_1;
    var y1 = p1.d26_1;
    var tmp$ret$1 = Angle_between(x0, y0, x1, y1, up);
    return new Angle(tmp$ret$1);
  };
}
function Bezier$extrema$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this$0.e3c());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.y1_1;
    var last = this_0.z1_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.geom.bezier.Bezier.extrema$delegate.<anonymous>.<anonymous>' call
        var dim = item;
        var tmp = Companion_getInstance_8();
        // Inline function 'korlibs.datastructure.mapDouble' call
        var this_1 = this$0.f3c().f1(0).b2r(dim);
        // Inline function 'kotlin.also' call
        var this_2 = new Float64Array(this_1.length);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.mapDouble.<anonymous>' call
        var inductionVariable_0 = 0;
        var last_0 = this_1.length;
        if (inductionVariable_0 < last_0)
          do {
            var n = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.math.geom.bezier.Bezier.extrema$delegate.<anonymous>.<anonymous>.<anonymous>' call
            this_2[n] = this_1[n];
          }
           while (inductionVariable_0 < last_0);
        var out = droots(tmp, this_2);
        if (this$0.m3a() === 3)
          out = combineSmallDistinctSorted(Companion_getInstance_8(), out, droots(Companion_getInstance_8(), this$0.f3c().f1(1).b2r(dim)));
        var tmp$ret$3 = out;
        destination.h(tmp$ret$3);
      }
       while (!(item === last));
    var out_0 = destination;
    return new Extrema(out_0.f1(0), out_0.f1(1));
  };
}
function Bezier$outerCircle$delegate$lambda(this$0) {
  return function () {
    return outerCircle(this$0.g3c());
  };
}
function Bezier$boundingBox$delegate$lambda(this$0) {
  return function () {
    return _getBoundingBox(this$0, Companion_getInstance_2().o29_1);
  };
}
function Bezier$length$delegate$lambda(this$0) {
  return function () {
    var z = 0.5;
    var sum = 0.0;
    var inductionVariable = 0;
    var last = Companion_getInstance_8().l3b_1.length - 1 | 0;
    var tmp;
    if (inductionVariable <= last) {
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var t = _Ratio___init__impl__9mwvn2(z * Companion_getInstance_8().l3b_1[i] + z);
        var temp = this$0.h3c(t);
        sum = sum + Companion_getInstance_8().m3b_1[i] * temp.a();
      }
       while (inductionVariable <= last);
      tmp = Unit_instance;
    }
    return z * sum;
  };
}
function Bezier$lut$delegate$lambda(this$0) {
  return function () {
    return this$0.i3c();
  };
}
function Bezier$isLinear$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var this_0 = this$0.b3a_1.f1(this$0.m3a());
    var that = this$0.b3a_1.f1(0);
    var baseLength = Vector2D.l28(this_0.c26_1 - that.c26_1, this_0.d26_1 - that.d26_1).a();
    // Inline function 'korlibs.datastructure.sumOfDouble' call
    var sum = 0.0;
    var progression = until(0, _get_aligned__7fjidv(this$0).d1());
    var inductionVariable = progression.y1_1;
    var last = progression.z1_1;
    if (inductionVariable <= last)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = sum;
        // Inline function 'korlibs.math.geom.bezier.Bezier.isLinear$delegate.<anonymous>.<anonymous>' call
        var it = element;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_1 = _get_aligned__7fjidv(this$0).k28(it);
        sum = tmp + Math.abs(this_1);
      }
       while (!(element === last));
    return sum < baseLength / 50.0;
  };
}
function Bezier$isSimple$delegate$lambda(this$0) {
  return function () {
    var tmp;
    if (this$0.m3a() === 3) {
      var a1 = angle(Companion_getInstance_8(), this$0.b3a_1.f1(0), this$0.b3a_1.f1(3), this$0.b3a_1.f1(1));
      var a2 = angle(Companion_getInstance_8(), this$0.b3a_1.f1(0), this$0.b3a_1.f1(3), this$0.b3a_1.f1(2));
      var tmp_0;
      if (a1 > 0.0 && a2 < 0.0 || (a1 < 0.0 && a2 > 0.0)) {
        return false;
      }
      tmp = tmp_0;
    }
    var n1 = this$0.k39(Companion_getInstance_6().m1i_1);
    var n2 = this$0.k39(Companion_getInstance_6().p1i_1);
    var s = n1.c26_1 * n2.c26_1 + n1.d26_1 * n2.d26_1;
    // Inline function 'kotlin.math.abs' call
    // Inline function 'kotlin.math.acos' call
    var x = Math.acos(s);
    return Math.abs(x) < 3.141592653589793 / 3.0;
  };
}
function BezierCurveFromIndices($this, indices, points) {
  var p = new PointArrayList(indices.length);
  var inductionVariable = 0;
  var last = indices.length;
  while (inductionVariable < last) {
    var index = indices[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    p.m2r(points, index);
  }
  return Bezier.o3c(p);
}
var Companion_instance_0;
function Companion_getInstance_9() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function _split($this, t, hull, left) {
  var rt = convertRange(t, Companion_getInstance_6().m1i_1, Companion_getInstance_6().p1i_1, $this.b3b_1, $this.c3b_1);
  var rt1 = left ? $this.b3b_1 : rt;
  var rt2 = left ? rt : $this.c3b_1;
  var tmp;
  if ($this.a3b_1.m3a() < 2) {
    var p1 = $this.i39(rt1);
    var p2 = $this.i39(rt2);
    tmp = Bezier.l3c(p1, p2);
  } else {
    var indices = left ? Companion_getInstance_9().s3d_1 : Companion_getInstance_9().t3d_1;
    tmp = BezierCurveFromIndices(Companion_getInstance_9(), ensureNotNull(indices.f1($this.a3b_1.m3a())), ensureNotNull(hull));
  }
  var curve = tmp;
  return SubBezier.p3d(curve, rt1, rt2, $this.d3b_1);
}
function _splitLeft($this, t, hull) {
  return _split($this, t, hull, true);
}
function _splitLeft$default($this, t, hull, $super) {
  hull = hull === VOID ? $this.a3b_1.o3d(t) : hull;
  return _splitLeft($this, t, hull);
}
function _splitRight($this, t, hull) {
  return _split($this, t, hull, false);
}
function _splitRight$default($this, t, hull, $super) {
  hull = hull === VOID ? $this.a3b_1.o3d(t) : hull;
  return _splitRight($this, t, hull);
}
function estimateAt($this, values, value, out) {
  var result = binarySearch_0(values, value);
  if (_BSearchResult___get_found__impl__om04iz(result))
    return $this.u3d(out, _BSearchResult___get_index__impl__b5kraz(result), 0.0);
  var index = _BSearchResult___get_nearIndex__impl__s8nq43(result);
  if (value <= 0.0)
    return $this.u3d(out, 0, 0.0);
  if (index >= (values.d1() - 1 | 0))
    return $this.u3d(out, $this.y3c_1.d1() - 1 | 0, 0.0);
  var ratio0 = values.f1(index);
  var ratio1 = values.f1(index + 1 | 0);
  var ratio = convertRange_0(value, ratio0, ratio1, 0.0, 1.0);
  return $this.u3d(out, index, ratio);
}
function CurveLUT$toString$lambda(this$0) {
  return function (it) {
    return '' + this$0.z3c_1.f1(it) + ',len=' + this$0.v3d().f1(it) + ': ' + this$0.y3c_1.f1(it).toString();
  };
}
function toCurves(_this__u8e3s4, closed) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return new Curves(_this__u8e3s4, closed);
}
function toNonCurveSimplePointList(_this__u8e3s4, out) {
  out = out === VOID ? new PointArrayList() : out;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  var curves = _this__u8e3s4;
  var beziers = curves.v39_1;
  var epsilon = 1.0E-5;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < beziers.d1()) {
    // Inline function 'korlibs.math.geom.bezier.toNonCurveSimplePointList.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var bezier = beziers.f1(_unary__edvuaz);
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(bezier.k3d().length === 0))
      return null;
    var points = bezier.b3a_1;
    // Inline function 'korlibs.math.geom.fastForEach' call
    var inductionVariable = 0;
    var last = points.d1();
    if (inductionVariable < last)
      do {
        var n_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.geom.bezier.toNonCurveSimplePointList.<anonymous>.<anonymous>' call
        var p = points.f1(n_0);
        if (out.g1() || !out.x2l().x2h(p, epsilon)) {
          out.j2r(p);
        }
      }
       while (inductionVariable < last);
  }
  if (out.x2l().x2h(out.w2l(), epsilon)) {
    out.n2r(out.d1() - 1 | 0);
  }
  return out;
}
var Arc_instance;
function Arc_getInstance() {
  return Arc_instance;
}
function toVectorPath_0(_this__u8e3s4, out) {
  out = out === VOID ? new VectorPath() : out;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  var first = {_v: true};
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < _this__u8e3s4.d1()) {
    // Inline function 'korlibs.math.geom.bezier.toVectorPath.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var curves = _this__u8e3s4.f1(_unary__edvuaz);
    if (curves instanceof Curves) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = curves.v39_1;
      var n_0 = 0;
      while (n_0 < this_0.d1()) {
        // Inline function 'korlibs.math.geom.bezier.toVectorPath.<anonymous>.<anonymous>' call
        var _unary__edvuaz_0 = n_0;
        n_0 = _unary__edvuaz_0 + 1 | 0;
        var it = this_0.f1(_unary__edvuaz_0);
        toVectorPath$bezier(first, out, it);
      }
      if (curves.w39_1) {
        out.y5();
      }
    } else {
      if (curves instanceof Bezier) {
        toVectorPath$bezier(first, out, curves);
      } else {
        throw NotImplementedError.nd();
      }
    }
  }
  return out;
}
function toVectorPath_1(_this__u8e3s4, out) {
  out = out === VOID ? new VectorPath() : out;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return toVectorPath_0(listOf(_this__u8e3s4), out);
}
function toBezier(_this__u8e3s4) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return Bezier.l3c(Vector2D.l28(_this__u8e3s4.z28(), _this__u8e3s4.a29()), Vector2D.l28(_this__u8e3s4.b29(), _this__u8e3s4.c29()));
}
function toDashes(_this__u8e3s4, pattern, offset) {
  offset = offset === VOID ? 0.0 : offset;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  if (pattern == null)
    return listOf(_this__u8e3s4);
  // Inline function 'kotlin.check' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.all' call
    var inductionVariable = 0;
    var last = pattern.length;
    while (inductionVariable < last) {
      var element = pattern[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.math.geom.bezier.toDashes.<anonymous>' call
      if (!(element <= 0.0)) {
        tmp$ret$1 = false;
        break $l$block;
      }
    }
    tmp$ret$1 = true;
  }
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.check' call
  // Inline function 'kotlin.contracts.contract' call
  if (!!tmp$ret$1) {
    // Inline function 'kotlin.check.<anonymous>' call
    var message = 'Check failed.';
    throw IllegalStateException.s4(toString(message));
  }
  var length = _this__u8e3s4.a();
  var current = offset;
  var dashNow = true;
  var index = 0;
  // Inline function 'kotlin.collections.arrayListOf' call
  var out = ArrayList.i1();
  while (current < length) {
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var len = getCyclic_0(pattern, _unary__edvuaz);
    if (dashNow) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element_0 = _this__u8e3s4.y3a(current, current + len);
      out.h(element_0);
    }
    current = current + len;
    dashNow = !dashNow;
  }
  return out;
}
function toVectorPath$bezier(first, $out, bezier) {
  var points = bezier.b3a_1;
  if (first._v) {
    $out.b3e(points.w2l());
    first._v = false;
  }
  switch (bezier.m3a()) {
    case 1:
      $out.d3e(points.f1(1));
      break;
    case 2:
      $out.e3e(points.f1(1), points.f1(2));
      break;
    case 3:
      $out.g3e(points.f1(1), points.f1(2), points.f1(3));
      break;
    default:
      // Inline function 'kotlin.TODO' call

      throw NotImplementedError.nd();
  }
}
function isConvex$delegate$lambda($this$extraPropertyThis) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return $this$extraPropertyThis.x39_1 || Convex_instance.t3e($this$extraPropertyThis);
}
function isConvex$delegate$lambda_0(_this__u8e3s4, it) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return it;
}
function isConvex$factory() {
  return getPropertyCallableRef('isConvex', 1, KProperty1, function (receiver) {
    return get_isConvex(receiver);
  }, null);
}
function infos$factory() {
  return getPropertyCallableRef('infos', 1, KProperty1, function (receiver) {
    return receiver.t3a();
  }, null);
}
function length$factory() {
  return getPropertyCallableRef('length', 1, KProperty1, function (receiver) {
    return receiver.a();
  }, null);
}
function aligned$factory() {
  return getPropertyCallableRef('aligned', 1, KProperty1, function (receiver) {
    return _get_aligned__7fjidv(receiver);
  }, null);
}
function dpoints$factory() {
  return getPropertyCallableRef('dpoints', 1, KProperty1, function (receiver) {
    return receiver.f3c();
  }, null);
}
function extrema$factory() {
  return getPropertyCallableRef('extrema', 1, KProperty1, function (receiver) {
    return receiver.q3b();
  }, null);
}
function outerCircle$factory() {
  return getPropertyCallableRef('outerCircle', 1, KProperty1, function (receiver) {
    return receiver.s3c();
  }, null);
}
function boundingBox$factory() {
  return getPropertyCallableRef('boundingBox', 1, KProperty1, function (receiver) {
    return receiver.g3c();
  }, null);
}
function length$factory_0() {
  return getPropertyCallableRef('length', 1, KProperty1, function (receiver) {
    return receiver.a();
  }, null);
}
function lut$factory() {
  return getPropertyCallableRef('lut', 1, KProperty1, function (receiver) {
    return receiver.t3c();
  }, null);
}
function xt01$factory() {
  return getPropertyCallableRef('xt01', 1, KProperty1, function (receiver) {
    return receiver.y3b();
  }, null);
}
function yt01$factory() {
  return getPropertyCallableRef('yt01', 1, KProperty1, function (receiver) {
    return receiver.z3b();
  }, null);
}
var properties_initialized__MathGeom_bezier_kt_sxrpnw;
function _init_properties__MathGeom_bezier_kt__br5r2i() {
  if (!properties_initialized__MathGeom_bezier_kt_sxrpnw) {
    properties_initialized__MathGeom_bezier_kt_sxrpnw = true;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var default_0 = isConvex$delegate$lambda;
    var transform = isConvex$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_0 = new PropertyThis(null, default_0);
    this_0.e1j_1 = transform;
    isConvex$delegate = this_0;
  }
}
var Companion_instance_1;
function Companion_getInstance_10() {
  return Companion_instance_1;
}
function quickFindPositionForNewNodeBestAreaFit($this, width, height) {
  var score = 1.7976931348623157E308;
  var areaFit;
  var bestNode = Companion_getInstance_1().q29();
  var _iterator__ex2g4s = $this.x3e_1.a1();
  while (_iterator__ex2g4s.b1()) {
    var r = _iterator__ex2g4s.c1();
    if (r.o26_1 >= width && r.p26_1 >= height) {
      areaFit = r.o26_1 * r.p26_1 - width * height;
      if (areaFit < score) {
        bestNode = new Rectangle(r.m26_1, r.n26_1, width, height);
        score = areaFit;
      }
    }
  }
  return bestNode;
}
function splitFreeNode($this, freeNode, usedNode) {
  var newNode;
  if (usedNode.t26() >= freeNode.u26() || usedNode.u26() <= freeNode.m26_1 || usedNode.v26() >= freeNode.w26() || usedNode.w26() <= freeNode.v26()) {
    return false;
  }
  if (usedNode.m26_1 < freeNode.u26() && usedNode.u26() > freeNode.m26_1) {
    if (usedNode.n26_1 > freeNode.n26_1 && usedNode.n26_1 < freeNode.w26()) {
      newNode = freeNode.m2f(VOID, VOID, VOID, usedNode.n26_1 - freeNode.n26_1);
      $this.x3e_1.h(newNode);
    }
    if (usedNode.w26() < freeNode.w26()) {
      newNode = freeNode.m2f(VOID, usedNode.w26(), VOID, freeNode.w26() - usedNode.w26());
      $this.x3e_1.h(newNode);
    }
  }
  if (usedNode.n26_1 < freeNode.w26() && usedNode.w26() > freeNode.n26_1) {
    if (usedNode.m26_1 > freeNode.m26_1 && usedNode.m26_1 < freeNode.u26()) {
      newNode = freeNode.m2f(VOID, VOID, usedNode.m26_1 - freeNode.m26_1);
      $this.x3e_1.h(newNode);
    }
    if (usedNode.u26() < freeNode.u26()) {
      newNode = freeNode.m2f(usedNode.u26(), VOID, freeNode.u26() - usedNode.u26());
      $this.x3e_1.h(newNode);
    }
  }
  return true;
}
function pruneFreeList($this) {
  var len = $this.x3e_1.d1();
  var i = 0;
  while (i < len) {
    var j = i + 1 | 0;
    var tmpRect = $this.x3e_1.f1(i);
    $l$loop: while (j < len) {
      var tmpRect2 = $this.x3e_1.f1(j);
      if (Companion_getInstance_1().r2e(tmpRect, tmpRect2)) {
        $this.x3e_1.a3(i);
        i = i - 1 | 0;
        len = len - 1 | 0;
        break $l$loop;
      }
      if (Companion_getInstance_1().r2e(tmpRect2, tmpRect)) {
        $this.x3e_1.a3(j);
        len = len - 1 | 0;
        j = j - 1 | 0;
      }
      j = j + 1 | 0;
    }
    i = i + 1 | 0;
  }
}
var HitTestDirection_ANY_instance;
var HitTestDirection_UP_instance;
var HitTestDirection_RIGHT_instance;
var HitTestDirection_DOWN_instance;
var HitTestDirection_LEFT_instance;
var Companion_instance_2;
function Companion_getInstance_11() {
  return Companion_instance_2;
}
var HitTestDirection_entriesInitialized;
function HitTestDirection_initEntries() {
  if (HitTestDirection_entriesInitialized)
    return Unit_instance;
  HitTestDirection_entriesInitialized = true;
  HitTestDirection_ANY_instance = new HitTestDirection('ANY', 0);
  HitTestDirection_UP_instance = new HitTestDirection('UP', 1);
  HitTestDirection_RIGHT_instance = new HitTestDirection('RIGHT', 2);
  HitTestDirection_DOWN_instance = new HitTestDirection('DOWN', 3);
  HitTestDirection_LEFT_instance = new HitTestDirection('LEFT', 4);
}
function HitTestDirection_ANY_getInstance() {
  HitTestDirection_initEntries();
  return HitTestDirection_ANY_instance;
}
var Convex_instance;
function Convex_getInstance() {
  return Convex_instance;
}
function get_cachedPoints(_this__u8e3s4) {
  _init_properties__MathGeom_shape_kt__uqeev8();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = cachedPoints$delegate;
    var property = cachedPoints$factory();
    var tmp0_elvis_lhs = this_0.c1j_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.d1j_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.c1j_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var cachedPoints$delegate;
function getPoints2(_this__u8e3s4, out) {
  out = out === VOID ? new PointArrayList() : out;
  _init_properties__MathGeom_shape_kt__uqeev8();
  // Inline function 'korlibs.math.geom.shape.emitPoints2' call
  var i = Vector2D.w28();
  var l = Vector2D.w28();
  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = _this__u8e3s4.j3e_1;
  var n_0 = 0;
  while (n_0 < this_0.d1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.s1i(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.l28(tmp, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_1));
        i = it;
        // Inline function 'korlibs.math.geom.shape.getPoints2.<anonymous>' call

        out.j2r(it);
        l = it;
        break;
      case 1:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.l28(tmp_0, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_3));
        // Inline function 'korlibs.math.geom.shape.getPoints2.<anonymous>' call

        out.j2r(it_0);
        l = it_0;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 2:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var c = Vector2D.l28(tmp_1, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var a = Vector2D.l28(tmp_2, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_7));
        var sum = Companion_getInstance().m2h(l, c) + Companion_getInstance().m2h(c, a);
        // Inline function 'korlibs.math.geom.shape.approximateCurve' call

        // Inline function 'kotlin.math.max' call

        var a_0 = numberToInt(sum);
        var rcurveSteps = Math.max(a_0, 20);
        var dt = 1.0 / rcurveSteps;
        var lastPos = {_v: Vector2D.w28()};
        var prevPos = {_v: Vector2D.w28()};
        var emittedCount = {_v: 0};
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

        var ratio = Companion_getInstance_6().m1i_1;
        // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

        lastPos._v = Companion_getInstance_8().b3c(l, c, a, ratio);
        var nStart = false ? 0 : 1;
        var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
        var inductionVariable = nStart;
        if (inductionVariable <= nEnd)
          do {
            var n_1 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
            var it_1 = Companion_getInstance_8().b3c(l, c, a, ratio_0);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.getPoints2.<anonymous>' call
            out.j2r(it_1);
            emittedCount._v = emittedCount._v + 1 | 0;
            lastPos._v = prevPos._v;
            prevPos._v = it_1;
          }
           while (!(n_1 === nEnd));
        l = a;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 3:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var c0 = Vector2D.l28(tmp_3, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var c1 = Vector2D.l28(tmp_4, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var a_1 = Vector2D.l28(tmp_5, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_13));
        var sum_0 = Companion_getInstance().m2h(l, c0) + Companion_getInstance().m2h(c0, c1) + Companion_getInstance().m2h(c1, a_1);
        // Inline function 'korlibs.math.geom.shape.approximateCurve' call

        // Inline function 'kotlin.math.max' call

        var a_2 = numberToInt(sum_0);
        var rcurveSteps_0 = Math.max(a_2, 20);
        var dt_0 = 1.0 / rcurveSteps_0;
        var lastPos_0 = {_v: Vector2D.w28()};
        var prevPos_0 = {_v: Vector2D.w28()};
        var emittedCount_0 = {_v: 0};
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

        var ratio_1 = Companion_getInstance_6().m1i_1;
        // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

        lastPos_0._v = Companion_getInstance_8().a3c(l, c0, c1, a_1, ratio_1);
        var nStart_0 = false ? 0 : 1;
        var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
        var inductionVariable_0 = nStart_0;
        if (inductionVariable_0 <= nEnd_0)
          do {
            var n_2 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
            var it_2 = Companion_getInstance_8().a3c(l, c0, c1, a_1, ratio_2);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.getPoints2.<anonymous>' call
            out.j2r(it_2);
            emittedCount_0._v = emittedCount_0._v + 1 | 0;
            lastPos_0._v = prevPos_0._v;
            prevPos_0._v = it_2;
          }
           while (!(n_2 === nEnd_0));
        l = a_1;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 4:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        // Inline function 'korlibs.math.geom.shape.getPoints2.<anonymous>' call

        var p = i;
        out.j2r(p);
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
    }
  }
  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  return out;
}
function CircleShape2D$_init_$lambda_c1uoso(it) {
  return toVectorPath(it);
}
function BaseShape2D$cachedPath$delegate$lambda(this$0) {
  return function () {
    return this$0.r3f_1(this$0.q3f_1);
  };
}
function getPoints2List(_this__u8e3s4) {
  _init_properties__MathGeom_shape_kt__uqeev8();
  // Inline function 'kotlin.collections.arrayListOf' call
  var out = ArrayList.i1();
  var current = {_v: new PointArrayList()};
  // Inline function 'korlibs.math.geom.shape.emitPoints2' call
  var i = Vector2D.w28();
  var l = Vector2D.w28();
  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = _this__u8e3s4.j3e_1;
  var n_0 = 0;
  while (n_0 < this_0.d1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.s1i(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.l28(tmp, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_1));
        i = it;
        // Inline function 'korlibs.math.geom.shape.getPoints2List.<anonymous>' call

        if (true) {
          getPoints2List$flush(current, out);
        }

        current._v.j2r(it);
        l = it;
        break;
      case 1:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.l28(tmp_0, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_3));
        // Inline function 'korlibs.math.geom.shape.getPoints2List.<anonymous>' call

        if (false) {
          getPoints2List$flush(current, out);
        }

        current._v.j2r(it_0);
        l = it_0;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 2:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var c = Vector2D.l28(tmp_1, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var a = Vector2D.l28(tmp_2, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_7));
        var sum = Companion_getInstance().m2h(l, c) + Companion_getInstance().m2h(c, a);
        // Inline function 'korlibs.math.geom.shape.approximateCurve' call

        // Inline function 'kotlin.math.max' call

        var a_0 = numberToInt(sum);
        var rcurveSteps = Math.max(a_0, 20);
        var dt = 1.0 / rcurveSteps;
        var lastPos = {_v: Vector2D.w28()};
        var prevPos = {_v: Vector2D.w28()};
        var emittedCount = {_v: 0};
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

        var ratio = Companion_getInstance_6().m1i_1;
        // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

        lastPos._v = Companion_getInstance_8().b3c(l, c, a, ratio);
        var nStart = false ? 0 : 1;
        var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
        var inductionVariable = nStart;
        if (inductionVariable <= nEnd)
          do {
            var n_1 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
            var it_1 = Companion_getInstance_8().b3c(l, c, a, ratio_0);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.getPoints2List.<anonymous>' call
            if (false) {
              getPoints2List$flush(current, out);
            }
            current._v.j2r(it_1);
            emittedCount._v = emittedCount._v + 1 | 0;
            lastPos._v = prevPos._v;
            prevPos._v = it_1;
          }
           while (!(n_1 === nEnd));
        l = a;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 3:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var c0 = Vector2D.l28(tmp_3, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var c1 = Vector2D.l28(tmp_4, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var a_1 = Vector2D.l28(tmp_5, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_13));
        var sum_0 = Companion_getInstance().m2h(l, c0) + Companion_getInstance().m2h(c0, c1) + Companion_getInstance().m2h(c1, a_1);
        // Inline function 'korlibs.math.geom.shape.approximateCurve' call

        // Inline function 'kotlin.math.max' call

        var a_2 = numberToInt(sum_0);
        var rcurveSteps_0 = Math.max(a_2, 20);
        var dt_0 = 1.0 / rcurveSteps_0;
        var lastPos_0 = {_v: Vector2D.w28()};
        var prevPos_0 = {_v: Vector2D.w28()};
        var emittedCount_0 = {_v: 0};
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

        var ratio_1 = Companion_getInstance_6().m1i_1;
        // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

        lastPos_0._v = Companion_getInstance_8().a3c(l, c0, c1, a_1, ratio_1);
        var nStart_0 = false ? 0 : 1;
        var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
        var inductionVariable_0 = nStart_0;
        if (inductionVariable_0 <= nEnd_0)
          do {
            var n_2 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
            var it_2 = Companion_getInstance_8().a3c(l, c0, c1, a_1, ratio_2);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.getPoints2List.<anonymous>' call
            if (false) {
              getPoints2List$flush(current, out);
            }
            current._v.j2r(it_2);
            emittedCount_0._v = emittedCount_0._v + 1 | 0;
            lastPos_0._v = prevPos_0._v;
            prevPos_0._v = it_2;
          }
           while (!(n_2 === nEnd_0));
        l = a_1;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 4:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        // Inline function 'korlibs.math.geom.shape.getPoints2List.<anonymous>' call

        var p = i;
        if (false) {
          getPoints2List$flush(current, out);
        }

        current._v.j2r(p);
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
    }
  }
  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  getPoints2List$flush(current, out);
  return out;
}
function toShape2D(_this__u8e3s4) {
  _init_properties__MathGeom_shape_kt__uqeev8();
  return new CircleShape2D(_this__u8e3s4);
}
function getPoints2List$flush(current, out) {
  if (!current._v.m28())
    return Unit_instance;
  out.h(current._v);
  current._v = new PointArrayList();
}
function cachedPoints$delegate$lambda($this$PropertyThis) {
  _init_properties__MathGeom_shape_kt__uqeev8();
  return getPoints2($this$PropertyThis);
}
function cachedPoints$factory() {
  return getPropertyCallableRef('cachedPoints', 1, KProperty1, function (receiver) {
    return get_cachedPoints(receiver);
  }, null);
}
var properties_initialized__MathGeom_shape_kt_lonmli;
function _init_properties__MathGeom_shape_kt__uqeev8() {
  if (!properties_initialized__MathGeom_shape_kt_lonmli) {
    properties_initialized__MathGeom_shape_kt_lonmli = true;
    cachedPoints$delegate = new PropertyThis(VOID, cachedPoints$delegate$lambda);
  }
}
var SliceRotation_R0_instance;
var SliceRotation_R90_instance;
var SliceRotation_R180_instance;
var SliceRotation_R270_instance;
var Companion_instance_3;
function Companion_getInstance_12() {
  SliceRotation_initEntries();
  if (Companion_instance_3 === VOID)
    new Companion_3();
  return Companion_instance_3;
}
function values() {
  return [SliceRotation_R0_getInstance(), SliceRotation_R90_getInstance(), SliceRotation_R180_getInstance(), SliceRotation_R270_getInstance()];
}
var SliceRotation_entriesInitialized;
function SliceRotation_initEntries() {
  if (SliceRotation_entriesInitialized)
    return Unit_instance;
  SliceRotation_entriesInitialized = true;
  SliceRotation_R0_instance = new SliceRotation('R0', 0);
  SliceRotation_R90_instance = new SliceRotation('R90', 1);
  SliceRotation_R180_instance = new SliceRotation('R180', 2);
  SliceRotation_R270_instance = new SliceRotation('R270', 3);
  Companion_getInstance_12();
}
function _SliceOrientation___init__impl__ewylib(raw) {
  return raw;
}
function _SliceOrientation___get_raw__impl__tj3u8w($this) {
  return $this;
}
function _SliceOrientation___get_rotation__impl__m65r0o($this) {
  return Companion_getInstance_12().f1(extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 2));
}
function _SliceOrientation___get_flipX__impl__lgb7bx($this) {
  return !(extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 2, 1) === 0);
}
function _SliceOrientation___init__impl__ewylib_0(rotation, flipX) {
  rotation = rotation === VOID ? SliceRotation_R0_getInstance() : rotation;
  flipX = flipX === VOID ? false : flipX;
  return _SliceOrientation___init__impl__ewylib(insert_0(insert(0, rotation.k3_1, 0, 2), flipX, 2));
}
function _SliceOrientation___get_indices__impl__km5on3($this) {
  return Companion_getInstance_13().x3f_1[extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 3)];
}
function _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq($this) {
  return _SliceOrientation___get_rotation__impl__m65r0o($this).equals(SliceRotation_R90_getInstance()) || _SliceOrientation___get_rotation__impl__m65r0o($this).equals(SliceRotation_R270_getInstance());
}
function SliceOrientation__toString_impl_tdph6r($this) {
  return Companion_getInstance_13().y3f_1[extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 3)];
}
var Companion_instance_4;
function Companion_getInstance_13() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
function SliceOrientation__hashCode_impl_7mjkdw($this) {
  return $this;
}
function SliceOrientation__equals_impl_h4gywg($this, other) {
  if (!(other instanceof SliceOrientation))
    return false;
  if (!($this === (other instanceof SliceOrientation ? other.i3g_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_5;
function Companion_getInstance_14() {
  return Companion_instance_5;
}
function transformed_1(_this__u8e3s4, orientation) {
  var i = _SliceOrientation___get_indices__impl__km5on3(orientation);
  return new RectCoords(_this__u8e3s4.n3i(i[0]), _this__u8e3s4.o3i(i[0]), _this__u8e3s4.n3i(i[1]), _this__u8e3s4.o3i(i[1]), _this__u8e3s4.n3i(i[2]), _this__u8e3s4.o3i(i[2]), _this__u8e3s4.n3i(i[3]), _this__u8e3s4.o3i(i[3]));
}
function SliceRotation_R0_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R0_instance;
}
function SliceRotation_R90_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R90_instance;
}
function SliceRotation_R180_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R180_instance;
}
function SliceRotation_R270_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R270_instance;
}
function PolygonScanline$AllBuckets$pool$lambda(it) {
  it.xg();
  return Unit_instance;
}
function PolygonScanline$AllBuckets$pool$lambda_0(it) {
  return new Bucket();
}
function addPoint($this, x, y) {
  $this.l3k_1.i2r(x, y);
}
function addEdge($this, ax, ay, bx, by) {
  if (ax === bx && ay === by)
    return Unit_instance;
  var isHorizontal = ay === by;
  var iax = $this.u3k(ax);
  var ibx = $this.u3k(bx);
  var iay = $this.u3k(ay);
  var iby = $this.u3k(by);
  var edge = ay < by ? $this.f3k_1.n2p().v3k(iax, iay, ibx, iby, 1) : $this.f3k_1.n2p().v3k(ibx, iby, iax, iay, -1);
  $this.i3k_1.h(edge);
  if (isHorizontal) {
    $this.h3k_1.h(edge);
  } else {
    $this.g3k_1.h(edge);
    $this.j3k_1.b3k(edge);
  }
  $this.e3k_1 = BoundsBuilder__plus_impl_cz7f7x($this.e3k_1, Vector2D.l28(ax, ay));
  $this.e3k_1 = BoundsBuilder__plus_impl_cz7f7x($this.e3k_1, Vector2D.l28(bx, by));
}
var IntArrayListSort_instance;
function IntArrayListSort_getInstance() {
  if (IntArrayListSort_instance === VOID)
    new IntArrayListSort();
  return IntArrayListSort_instance;
}
function PolygonScanline$edgesPool$lambda(it) {
  return new MEdge();
}
var Companion_instance_6;
function Companion_getInstance_15() {
  return Companion_instance_6;
}
var Companion_instance_7;
function Companion_getInstance_16() {
  return Companion_instance_7;
}
var EdgePoint_A_instance;
var EdgePoint_B_instance;
var EdgePoint_entriesInitialized;
function EdgePoint_initEntries() {
  if (EdgePoint_entriesInitialized)
    return Unit_instance;
  EdgePoint_entriesInitialized = true;
  EdgePoint_A_instance = new EdgePoint('A', 0, 0);
  EdgePoint_B_instance = new EdgePoint('B', 1, 1);
}
function _get_outFill__zcv64g($this) {
  var tmp = $this.z3l_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('outFill');
  }
}
function EdgePoint_A_getInstance() {
  EdgePoint_initEntries();
  return EdgePoint_A_instance;
}
function EdgePoint_B_getInstance() {
  EdgePoint_initEntries();
  return EdgePoint_B_instance;
}
function strokeToFill(_this__u8e3s4, lineWidth, joins, startCap, endCap, miterLimit, lineDash, lineDashOffset, temp, outFill) {
  joins = joins === VOID ? LineJoin_MITER_getInstance() : joins;
  startCap = startCap === VOID ? LineCap_BUTT_getInstance() : startCap;
  endCap = endCap === VOID ? startCap : endCap;
  miterLimit = miterLimit === VOID ? 4.0 : miterLimit;
  lineDash = lineDash === VOID ? null : lineDash;
  lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
  temp = temp === VOID ? new StrokeToFill() : temp;
  outFill = outFill === VOID ? new VectorPath(VOID, VOID, Winding_NON_ZERO_getInstance()) : outFill;
  var tmp;
  if (!(lineDash == null)) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = toCurvesList(_this__u8e3s4);
    var destination = ArrayList.i1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.math.geom.vector.strokeToFill.<anonymous>' call
      var list = toDashes(element, lineDash.t1i(), lineDashOffset);
      addAll(destination, list);
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator_0 = destination.a1();
    while (tmp0_iterator_0.b1()) {
      var item = tmp0_iterator_0.c1();
      // Inline function 'korlibs.math.geom.vector.strokeToFill.<anonymous>' call
      var tmp$ret$3 = toVectorPath_1(item);
      destination_0.h(tmp$ret$3);
    }
    tmp = destination_0;
  } else {
    tmp = listOf(_this__u8e3s4);
  }
  var strokePaths = tmp;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < strokePaths.d1()) {
    // Inline function 'korlibs.math.geom.vector.strokeToFill.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var strokePath = strokePaths.f1(_unary__edvuaz);
    temp.h3n(strokePath, lineWidth, joins, startCap, endCap, miterLimit, outFill);
  }
  return outFill;
}
function strokeToFill_0(_this__u8e3s4, info, temp, outFill) {
  temp = temp === VOID ? new StrokeToFill() : temp;
  outFill = outFill === VOID ? new VectorPath(VOID, VOID, Winding_NON_ZERO_getInstance()) : outFill;
  return strokeToFill(_this__u8e3s4, info.k38_1, info.p38_1, info.n38_1, info.o38_1, info.q38_1, info.r38_1, info.s38_1, temp, outFill);
}
function t($this, p) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var this_0 = $this.l3n_1;
    if (this_0.r26()) {
      tmp$ret$0 = p;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.l28(this_0.i2a(p.c26_1, p.d26_1), this_0.l2a(p.c26_1, p.d26_1));
  }
  return tmp$ret$0;
}
var _bvhCurvesCacheVersion$delegate;
var _bvhCurvesCache$delegate;
function set__curvesCacheVersion(_this__u8e3s4, _set____db54di) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var this_0 = _curvesCacheVersion$delegate;
  var property = _curvesCacheVersion$factory();
  var tmp0_elvis_lhs = this_0.a1j_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__curvesCacheVersion(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _curvesCacheVersion$delegate;
    var property = _curvesCacheVersion$factory_0();
    var tmp = _this__u8e3s4.z1i();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a1j_1;
      tmp_0 = tmp0_safe_receiver.d3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b1j_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a1j_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a1j_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _curvesCacheVersion$delegate;
function set__curvesCache(_this__u8e3s4, _set____db54di) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var this_0 = _curvesCache$delegate;
  var property = _curvesCache$factory();
  var tmp0_elvis_lhs = this_0.a1j_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__curvesCache(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _curvesCache$delegate;
    var property = _curvesCache$factory_0();
    var tmp = _this__u8e3s4.z1i();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.a1j_1;
      tmp_0 = tmp0_safe_receiver.d3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.b1j_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.a1j_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.a1j_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _curvesCache$delegate;
var Companion_instance_8;
function Companion_getInstance_17() {
  return Companion_instance_8;
}
function ensureMoveTo($this, p) {
  if ($this.m28())
    return false;
  $this.b3e(p);
  return true;
}
function getCurvesList(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  if (!(get__curvesCacheVersion(_this__u8e3s4) === _this__u8e3s4.o3e_1)) {
    set__curvesCacheVersion(_this__u8e3s4, _this__u8e3s4.o3e_1);
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.arrayListOf' call
    var this_0 = ArrayList.i1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>' call
    var currentClosed = {_v: false};
    // Inline function 'kotlin.collections.arrayListOf' call
    var current = {_v: ArrayList.i1()};
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges' call
    var m = Vector2D.w28();
    var l = Vector2D.w28();
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = _this__u8e3s4.j3e_1;
    var n_0 = 0;
    while (n_0 < this_1.d1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_1.s1i(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.l28(tmp, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_1));
          m = it;
          l = it;
          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          getCurvesList$_anonymous_$flush_1e57i7(current, this_0, currentClosed, _this__u8e3s4);
          break;
        case 1:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.l28(tmp_0, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_3));
          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          var p1 = l;
          // Inline function 'kotlin.collections.plusAssign' call

          var this_2 = current._v;
          var element = Bezier.l3c(p1, it_0);
          this_2.h(element);
          l = it_0;
          break;
        case 2:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var p1_0 = Vector2D.l28(tmp_1, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var p2 = Vector2D.l28(tmp_2, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_7));
          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          var p1_1 = l;
          // Inline function 'kotlin.collections.plusAssign' call

          var this_3 = current._v;
          var element_0 = Bezier.m3c(p1_1, p1_0, p2);
          this_3.h(element_0);
          l = p2;
          break;
        case 3:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var p1_2 = Vector2D.l28(tmp_3, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var p2_0 = Vector2D.l28(tmp_4, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = _this__u8e3s4.k3e_1.f1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var p3 = Vector2D.l28(tmp_5, _this__u8e3s4.k3e_1.f1(_unary__edvuaz_13));
          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          var p1_3 = l;
          // Inline function 'kotlin.collections.plusAssign' call

          var this_4 = current._v;
          var element_1 = Bezier.n3c(p1_3, p1_2, p2_0, p3);
          this_4.h(element_1);
          l = p3;
          break;
        case 4:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var equal = true ? l.d1i(m) : l.equals(m);
          if (!equal) {
            // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call
            var p1_4 = l;
            var p2_1 = m;
            // Inline function 'kotlin.collections.plusAssign' call
            var this_5 = current._v;
            var element_2 = Bezier.l3c(p1_4, p2_1);
            this_5.h(element_2);
          }

          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          currentClosed._v = true;
          getCurvesList$_anonymous_$flush_1e57i7(current, this_0, currentClosed, _this__u8e3s4);
          break;
      }
    }
    getCurvesList$_anonymous_$flush_1e57i7(current, this_0, currentClosed, _this__u8e3s4);
    set__curvesCache(_this__u8e3s4, this_0);
  }
  return ensureNotNull(get__curvesCache(_this__u8e3s4));
}
function plus(_this__u8e3s4, path) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return with_0(_this__u8e3s4, path);
}
function with_0(_this__u8e3s4, path, transform) {
  transform = transform === VOID ? Companion_getInstance_2().o29_1 : transform;
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var bb = {_v: new BoundsBuilder(_this__u8e3s4)};
  var curvesList = getCurvesList(path);
  if (curvesList.g1() && path.m28()) {
    path.k3o(new with$1(bb));
  }
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < curvesList.d1()) {
    // Inline function 'korlibs.math.geom.vector.with.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = curvesList.f1(_unary__edvuaz).v39_1;
    var n_0 = 0;
    while (n_0 < this_0.d1()) {
      // Inline function 'korlibs.math.geom.vector.with.<anonymous>.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var bezier = this_0.f1(_unary__edvuaz_0);
      bb._v = new BoundsBuilder(BoundsBuilder__plus_impl_cz7f7x_0(bb._v.p27_1, bezier.r3c(transform)));
    }
  }
  return bb._v.p27_1;
}
function write(_this__u8e3s4, path) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = path.j3e_1;
  var n_0 = 0;
  while (n_0 < this_0.d1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.s1i(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = path.k3e_1.f1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.l28(tmp, path.k3e_1.f1(_unary__edvuaz_1));
        _this__u8e3s4.b3e(it);
        break;
      case 1:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = path.k3e_1.f1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.l28(tmp_0, path.k3e_1.f1(_unary__edvuaz_3));
        _this__u8e3s4.d3e(it_0);
        break;
      case 2:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = path.k3e_1.f1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var p1 = Vector2D.l28(tmp_1, path.k3e_1.f1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = path.k3e_1.f1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var p2 = Vector2D.l28(tmp_2, path.k3e_1.f1(_unary__edvuaz_7));
        _this__u8e3s4.e3e(p1, p2);
        break;
      case 3:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = path.k3e_1.f1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var p1_0 = Vector2D.l28(tmp_3, path.k3e_1.f1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = path.k3e_1.f1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var p2_0 = Vector2D.l28(tmp_4, path.k3e_1.f1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = path.k3e_1.f1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var p3 = Vector2D.l28(tmp_5, path.k3e_1.f1(_unary__edvuaz_13));
        _this__u8e3s4.g3e(p1_0, p2_0, p3);
        break;
      case 4:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        _this__u8e3s4.y5();
        break;
    }
  }
}
function getCurves(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var curvesList = getCurvesList(_this__u8e3s4);
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList.i1();
  var tmp0_iterator = curvesList.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'korlibs.math.geom.vector.getCurves.<anonymous>' call
    var list = element.v39_1;
    addAll(destination, list);
  }
  var tmp = destination;
  var tmp59_safe_receiver = lastOrNull(curvesList);
  var tmp0_elvis_lhs = tmp59_safe_receiver == null ? null : tmp59_safe_receiver.w39_1;
  return toCurves(tmp, tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs);
}
function toCurvesList(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return getCurvesList(_this__u8e3s4);
}
function applyTransform(_this__u8e3s4, m) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var tmp;
  if (m.s26()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.transformPoints' call
    var progression = step(until(0, _this__u8e3s4.k3e_1.d1()), 2);
    var inductionVariable = progression.y1_1;
    var last = progression.z1_1;
    var step_0 = progression.a2_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        // Inline function 'korlibs.math.geom.vector.applyTransform.<anonymous>' call
        var it = Vector2D.l28(_this__u8e3s4.k3e_1.f1(n + 0 | 0), _this__u8e3s4.k3e_1.f1(n + 1 | 0));
        var tmp$ret$0;
        $l$block: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          if (m.r26()) {
            tmp$ret$0 = it;
            break $l$block;
          }
          tmp$ret$0 = Vector2D.l28(m.i2a(it.c26_1, it.d26_1), m.l2a(it.c26_1, it.d26_1));
        }
        var p = tmp$ret$0;
        _this__u8e3s4.k3e_1.d2l(n + 0 | 0, p.c26_1);
        _this__u8e3s4.k3e_1.d2l(n + 1 | 0, p.d26_1);
      }
       while (!(n === last));
    _this__u8e3s4.o3e_1 = _this__u8e3s4.o3e_1 + 1 | 0;
    tmp = _this__u8e3s4;
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function getCurvesList$_anonymous_$flush_1e57i7(current, $out, currentClosed, $this_getCurvesList) {
  if (current._v.g1())
    return Unit_instance;
  // Inline function 'kotlin.also' call
  var this_0 = new Curves(current._v, currentClosed._v);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>$flush.<anonymous>' call
  this_0.x39_1 = $this_getCurvesList.n3e_1;
  $out.h(this_0);
  currentClosed._v = false;
  // Inline function 'kotlin.collections.arrayListOf' call
  current._v = ArrayList.i1();
}
function _bvhCurvesCacheVersion$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return -1;
}
function _bvhCurvesCache$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return null;
}
function _curvesCacheVersion$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return -1;
}
function _curvesCache$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return null;
}
function _curvesCacheVersion$factory() {
  return getPropertyCallableRef('_curvesCacheVersion', 1, KMutableProperty1, function (receiver) {
    return get__curvesCacheVersion(receiver);
  }, function (receiver, value) {
    return set__curvesCacheVersion(receiver, value);
  });
}
function _curvesCacheVersion$factory_0() {
  return getPropertyCallableRef('_curvesCacheVersion', 1, KMutableProperty1, function (receiver) {
    return get__curvesCacheVersion(receiver);
  }, function (receiver, value) {
    return set__curvesCacheVersion(receiver, value);
  });
}
function _curvesCache$factory() {
  return getPropertyCallableRef('_curvesCache', 1, KMutableProperty1, function (receiver) {
    return get__curvesCache(receiver);
  }, function (receiver, value) {
    return set__curvesCache(receiver, value);
  });
}
function _curvesCache$factory_0() {
  return getPropertyCallableRef('_curvesCache', 1, KMutableProperty1, function (receiver) {
    return get__curvesCache(receiver);
  }, function (receiver, value) {
    return set__curvesCache(receiver, value);
  });
}
var properties_initialized__MathGeom_vector_VectorPath_kt_i91mdk;
function _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe() {
  if (!properties_initialized__MathGeom_vector_VectorPath_kt_i91mdk) {
    properties_initialized__MathGeom_vector_VectorPath_kt_i91mdk = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _bvhCurvesCacheVersion$delegate$lambda;
    _bvhCurvesCacheVersion$delegate = new Property(null, default_0);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_1 = _bvhCurvesCache$delegate$lambda;
    _bvhCurvesCache$delegate = new Property(null, default_1);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_2 = _curvesCacheVersion$delegate$lambda;
    _curvesCacheVersion$delegate = new Property(null, default_2);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_3 = _curvesCache$delegate$lambda;
    _curvesCache$delegate = new Property(null, default_3);
  }
}
var Winding_EVEN_ODD_instance;
var Winding_NON_ZERO_instance;
var Companion_instance_9;
function Companion_getInstance_18() {
  return Companion_instance_9;
}
var Winding_entriesInitialized;
function Winding_initEntries() {
  if (Winding_entriesInitialized)
    return Unit_instance;
  Winding_entriesInitialized = true;
  Winding_EVEN_ODD_instance = new Winding('EVEN_ODD', 0, 'evenOdd');
  Winding_NON_ZERO_instance = new Winding('NON_ZERO', 1, 'nonZero');
}
var LineJoin_BEVEL_instance;
var LineJoin_ROUND_instance;
var LineJoin_MITER_instance;
var Companion_instance_10;
function Companion_getInstance_19() {
  return Companion_instance_10;
}
var LineJoin_entriesInitialized;
function LineJoin_initEntries() {
  if (LineJoin_entriesInitialized)
    return Unit_instance;
  LineJoin_entriesInitialized = true;
  LineJoin_BEVEL_instance = new LineJoin('BEVEL', 0);
  LineJoin_ROUND_instance = new LineJoin('ROUND', 1);
  LineJoin_MITER_instance = new LineJoin('MITER', 2);
}
var LineCap_BUTT_instance;
var LineCap_SQUARE_instance;
var LineCap_ROUND_instance;
var Companion_instance_11;
function Companion_getInstance_20() {
  return Companion_instance_11;
}
var LineCap_entriesInitialized;
function LineCap_initEntries() {
  if (LineCap_entriesInitialized)
    return Unit_instance;
  LineCap_entriesInitialized = true;
  LineCap_BUTT_instance = new LineCap('BUTT', 0);
  LineCap_SQUARE_instance = new LineCap('SQUARE', 1);
  LineCap_ROUND_instance = new LineCap('ROUND', 2);
}
var LineScaleMode_NONE_instance;
var LineScaleMode_HORIZONTAL_instance;
var LineScaleMode_VERTICAL_instance;
var LineScaleMode_NORMAL_instance;
var LineScaleMode_entriesInitialized;
function LineScaleMode_initEntries() {
  if (LineScaleMode_entriesInitialized)
    return Unit_instance;
  LineScaleMode_entriesInitialized = true;
  LineScaleMode_NONE_instance = new LineScaleMode('NONE', 0, false, false);
  LineScaleMode_HORIZONTAL_instance = new LineScaleMode('HORIZONTAL', 1, true, false);
  LineScaleMode_VERTICAL_instance = new LineScaleMode('VERTICAL', 2, false, true);
  LineScaleMode_NORMAL_instance = new LineScaleMode('NORMAL', 3, true, true);
}
var Companion_instance_12;
function Companion_getInstance_21() {
  return Companion_instance_12;
}
function Winding_EVEN_ODD_getInstance() {
  Winding_initEntries();
  return Winding_EVEN_ODD_instance;
}
function Winding_NON_ZERO_getInstance() {
  Winding_initEntries();
  return Winding_NON_ZERO_instance;
}
function LineJoin_BEVEL_getInstance() {
  LineJoin_initEntries();
  return LineJoin_BEVEL_instance;
}
function LineJoin_ROUND_getInstance() {
  LineJoin_initEntries();
  return LineJoin_ROUND_instance;
}
function LineJoin_MITER_getInstance() {
  LineJoin_initEntries();
  return LineJoin_MITER_instance;
}
function LineCap_BUTT_getInstance() {
  LineCap_initEntries();
  return LineCap_BUTT_instance;
}
function LineCap_SQUARE_getInstance() {
  LineCap_initEntries();
  return LineCap_SQUARE_instance;
}
function LineCap_ROUND_getInstance() {
  LineCap_initEntries();
  return LineCap_ROUND_instance;
}
function LineScaleMode_NONE_getInstance() {
  LineScaleMode_initEntries();
  return LineScaleMode_NONE_instance;
}
function LineScaleMode_NORMAL_getInstance() {
  LineScaleMode_initEntries();
  return LineScaleMode_NORMAL_instance;
}
function MPoint$Companion$POOL$lambda(it) {
  it.e3p(0.0, 0.0);
  return Unit_instance;
}
function MPoint$Companion$POOL$lambda_0(it) {
  return Companion_getInstance_22().q29();
}
var Companion_instance_13;
function Companion_getInstance_22() {
  if (Companion_instance_13 === VOID)
    new Companion_13();
  return Companion_instance_13;
}
function MMatrix$Companion$POOL$lambda(it) {
  it.p3p();
  return Unit_instance;
}
function MMatrix$Companion$POOL$lambda_0(it) {
  return new MMatrix();
}
var Companion_instance_14;
function Companion_getInstance_23() {
  if (Companion_instance_14 === VOID)
    new Companion_14();
  return Companion_instance_14;
}
var Companion_instance_15;
function Companion_getInstance_24() {
  return Companion_instance_15;
}
function MRectangle$Companion$POOL$lambda(it) {
  it.xg();
  return Unit_instance;
}
function MRectangle$Companion$POOL$lambda_0(it) {
  return Companion_getInstance_25().q29();
}
var Companion_instance_16;
function Companion_getInstance_25() {
  if (Companion_instance_16 === VOID)
    new Companion_16();
  return Companion_instance_16;
}
function get_immutable(_this__u8e3s4) {
  return _this__u8e3s4;
}
function get_mutable(_this__u8e3s4) {
  return new MRectangle(_this__u8e3s4.m26_1, _this__u8e3s4.n26_1, _this__u8e3s4.o26_1, _this__u8e3s4.p26_1);
}
function toMatrix4(_this__u8e3s4) {
  if (_this__u8e3s4.r26())
    return Companion_getInstance_5().w2c_1;
  return Companion_getInstance_5().z2c(_this__u8e3s4.s29_1, _this__u8e3s4.u29_1, 0.0, _this__u8e3s4.w29_1, _this__u8e3s4.t29_1, _this__u8e3s4.v29_1, 0.0, _this__u8e3s4.x29_1, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
}
function lineIntersectionPoint(_this__u8e3s4, l1, l2) {
  return l1.a3q(l2);
}
function projectedPoint(_this__u8e3s4, point) {
  return projectedPoint_0(Companion_instance_15, _this__u8e3s4.m39_1, _this__u8e3s4.n39_1, point);
}
function projectedPoint_0(_this__u8e3s4, v1, v2, point) {
  return projectedPoint_1(_this__u8e3s4, v1.c26_1, v1.d26_1, v2.c26_1, v2.d26_1, point.c26_1, point.d26_1);
}
function projectedPoint_1(_this__u8e3s4, v1x, v1y, v2x, v2y, px, py) {
  var e1x = v2x - v1x;
  var e1y = v2y - v1y;
  var e2x = px - v1x;
  var e2y = py - v1y;
  var valDp = Companion_getInstance_22().g3p(e1x, e1y, e2x, e2y);
  // Inline function 'kotlin.math.hypot' call
  var lenLineE1 = hypot(e1x, e1y);
  // Inline function 'kotlin.math.hypot' call
  var lenLineE2 = hypot(e2x, e2y);
  if (lenLineE1 === 0.0 || lenLineE2 === 0.0) {
    return Vector2D.l28(px, py);
  }
  var cos = valDp / (lenLineE1 * lenLineE2);
  var projLenOfLine = cos * lenLineE2;
  return Vector2D.l28(v1x + projLenOfLine * e1x / lenLineE1, v1y + projLenOfLine * e1y / lenLineE1);
}
function floorCeil(v) {
  var tmp;
  if (v < 0.0) {
    // Inline function 'kotlin.math.ceil' call
    tmp = Math.ceil(v);
  } else {
    // Inline function 'kotlin.math.floor' call
    tmp = Math.floor(v);
  }
  return tmp;
}
function get__ALL_LIST() {
  _init_properties_Easings_kt__swvzhy();
  // Inline function 'kotlin.getValue' call
  var this_0 = _ALL_LIST$delegate;
  _ALL_LIST$factory();
  return this_0.o1();
}
var _ALL_LIST$delegate;
var _ALL$delegate;
var Easings_SMOOTH_instance;
var Easings_EASE_IN_ELASTIC_instance;
var Easings_EASE_OUT_ELASTIC_instance;
var Easings_EASE_OUT_BOUNCE_instance;
var Easings_LINEAR_instance;
var Easings_EASE_instance;
var Easings_EASE_IN_instance;
var Easings_EASE_OUT_instance;
var Easings_EASE_IN_OUT_instance;
var Easings_EASE_IN_OLD_instance;
var Easings_EASE_OUT_OLD_instance;
var Easings_EASE_IN_OUT_OLD_instance;
var Easings_EASE_OUT_IN_OLD_instance;
var Easings_EASE_IN_BACK_instance;
var Easings_EASE_OUT_BACK_instance;
var Easings_EASE_IN_OUT_BACK_instance;
var Easings_EASE_OUT_IN_BACK_instance;
var Easings_EASE_IN_OUT_ELASTIC_instance;
var Easings_EASE_OUT_IN_ELASTIC_instance;
var Easings_EASE_IN_BOUNCE_instance;
var Easings_EASE_IN_OUT_BOUNCE_instance;
var Easings_EASE_OUT_IN_BOUNCE_instance;
var Easings_EASE_IN_QUAD_instance;
var Easings_EASE_OUT_QUAD_instance;
var Easings_EASE_IN_OUT_QUAD_instance;
var Easings_EASE_SINE_instance;
var Easings_EASE_CLAMP_START_instance;
var Easings_EASE_CLAMP_END_instance;
var Easings_EASE_CLAMP_MIDDLE_instance;
function values_0() {
  return [Easings_SMOOTH_getInstance(), Easings_EASE_IN_ELASTIC_getInstance(), Easings_EASE_OUT_ELASTIC_getInstance(), Easings_EASE_OUT_BOUNCE_getInstance(), Easings_LINEAR_getInstance(), Easings_EASE_getInstance(), Easings_EASE_IN_getInstance(), Easings_EASE_OUT_getInstance(), Easings_EASE_IN_OUT_getInstance(), Easings_EASE_IN_OLD_getInstance(), Easings_EASE_OUT_OLD_getInstance(), Easings_EASE_IN_OUT_OLD_getInstance(), Easings_EASE_OUT_IN_OLD_getInstance(), Easings_EASE_IN_BACK_getInstance(), Easings_EASE_OUT_BACK_getInstance(), Easings_EASE_IN_OUT_BACK_getInstance(), Easings_EASE_OUT_IN_BACK_getInstance(), Easings_EASE_IN_OUT_ELASTIC_getInstance(), Easings_EASE_OUT_IN_ELASTIC_getInstance(), Easings_EASE_IN_BOUNCE_getInstance(), Easings_EASE_IN_OUT_BOUNCE_getInstance(), Easings_EASE_OUT_IN_BOUNCE_getInstance(), Easings_EASE_IN_QUAD_getInstance(), Easings_EASE_OUT_QUAD_getInstance(), Easings_EASE_IN_OUT_QUAD_getInstance(), Easings_EASE_SINE_getInstance(), Easings_EASE_CLAMP_START_getInstance(), Easings_EASE_CLAMP_END_getInstance(), Easings_EASE_CLAMP_MIDDLE_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values_0());
  return $ENTRIES;
}
var Easings_entriesInitialized;
function Easings_initEntries() {
  if (Easings_entriesInitialized)
    return Unit_instance;
  Easings_entriesInitialized = true;
  Easings_SMOOTH_instance = new Easings$SMOOTH();
  Easings_EASE_IN_ELASTIC_instance = new Easings$EASE_IN_ELASTIC();
  Easings_EASE_OUT_ELASTIC_instance = new Easings$EASE_OUT_ELASTIC();
  Easings_EASE_OUT_BOUNCE_instance = new Easings$EASE_OUT_BOUNCE();
  Easings_LINEAR_instance = new Easings$LINEAR();
  Easings_EASE_instance = new Easings$EASE();
  Easings_EASE_IN_instance = new Easings$EASE_IN();
  Easings_EASE_OUT_instance = new Easings$EASE_OUT();
  Easings_EASE_IN_OUT_instance = new Easings$EASE_IN_OUT();
  Easings_EASE_IN_OLD_instance = new Easings$EASE_IN_OLD();
  Easings_EASE_OUT_OLD_instance = new Easings$EASE_OUT_OLD();
  Easings_EASE_IN_OUT_OLD_instance = new Easings$EASE_IN_OUT_OLD();
  Easings_EASE_OUT_IN_OLD_instance = new Easings$EASE_OUT_IN_OLD();
  Easings_EASE_IN_BACK_instance = new Easings$EASE_IN_BACK();
  Easings_EASE_OUT_BACK_instance = new Easings$EASE_OUT_BACK();
  Easings_EASE_IN_OUT_BACK_instance = new Easings$EASE_IN_OUT_BACK();
  Easings_EASE_OUT_IN_BACK_instance = new Easings$EASE_OUT_IN_BACK();
  Easings_EASE_IN_OUT_ELASTIC_instance = new Easings$EASE_IN_OUT_ELASTIC();
  Easings_EASE_OUT_IN_ELASTIC_instance = new Easings$EASE_OUT_IN_ELASTIC();
  Easings_EASE_IN_BOUNCE_instance = new Easings$EASE_IN_BOUNCE();
  Easings_EASE_IN_OUT_BOUNCE_instance = new Easings$EASE_IN_OUT_BOUNCE();
  Easings_EASE_OUT_IN_BOUNCE_instance = new Easings$EASE_OUT_IN_BOUNCE();
  Easings_EASE_IN_QUAD_instance = new Easings$EASE_IN_QUAD();
  Easings_EASE_OUT_QUAD_instance = new Easings$EASE_OUT_QUAD();
  Easings_EASE_IN_OUT_QUAD_instance = new Easings$EASE_IN_OUT_QUAD();
  Easings_EASE_SINE_instance = new Easings$EASE_SINE();
  Easings_EASE_CLAMP_START_instance = new Easings$EASE_CLAMP_START();
  Easings_EASE_CLAMP_END_instance = new Easings$EASE_CLAMP_END();
  Easings_EASE_CLAMP_MIDDLE_instance = new Easings$EASE_CLAMP_MIDDLE();
}
var $ENTRIES;
function calc($this, it) {
  var t = toRatio_1(it);
  var p = $this.c3r_1;
  var order = p.length - 1 | 0;
  if (equals(t, Companion_getInstance_6().m1i_1))
    return p[0];
  if (equals(t, Companion_getInstance_6().p1i_1))
    return p[order];
  if (order === 0)
    return p[0];
  var mt = Ratio__toDouble_impl_o7epze(Ratio__minus_impl_s1uwyg(Companion_getInstance_6().p1i_1, t));
  var mt2 = mt * mt;
  var t2 = Ratio__toDouble_impl_o7epze(Ratio__times_impl_ucdh7y_0(t, t));
  var a = mt2 * mt;
  // Inline function 'korlibs.math.interpolation.times' call
  var b = mt2 * _Ratio___get_value__impl__57cli6(t) * 3;
  var c = mt * t2 * 3;
  var d = Ratio__times_impl_ucdh7y(t, t2);
  return p[0].v2e(a).f3t(p[1].v2e(b)).f3t(p[2].v2e(c)).f3t(p[3].v2e(d));
}
function cubic(_this__u8e3s4, x1, y1, x2, y2, name) {
  name = name === VOID ? null : name;
  _init_properties_Easings_kt__swvzhy();
  return EasingCubic.g3t(x1, y1, x2, y2, name);
}
function get_EASE_CLAMP_START(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_CLAMP_START_getInstance();
}
function get_EASE_CLAMP_END(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_CLAMP_END_getInstance();
}
function get_EASE_IN_OUT_QUAD(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_IN_OUT_QUAD_getInstance();
}
function _ALL_LIST$delegate$lambda() {
  _init_properties_Easings_kt__swvzhy();
  return get_entries();
}
function _ALL$delegate$lambda() {
  _init_properties_Easings_kt__swvzhy();
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = get__ALL_LIST();
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.bc(capacity);
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'korlibs.math.interpolation._ALL$delegate.<anonymous>.<anonymous>' call
    var tmp$ret$0 = element.j3_1;
    destination.f3(tmp$ret$0, element);
  }
  return destination;
}
function Easings_SMOOTH_getInstance() {
  Easings_initEntries();
  return Easings_SMOOTH_instance;
}
function Easings_EASE_IN_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_ELASTIC_instance;
}
function Easings_EASE_OUT_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_ELASTIC_instance;
}
function Easings_EASE_OUT_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_BOUNCE_instance;
}
function Easings_LINEAR_getInstance() {
  Easings_initEntries();
  return Easings_LINEAR_instance;
}
function Easings_EASE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_instance;
}
function Easings_EASE_IN_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_instance;
}
function Easings_EASE_OUT_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_instance;
}
function Easings_EASE_IN_OUT_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_instance;
}
function Easings_EASE_IN_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OLD_instance;
}
function Easings_EASE_OUT_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_OLD_instance;
}
function Easings_EASE_IN_OUT_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_OLD_instance;
}
function Easings_EASE_OUT_IN_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_OLD_instance;
}
function Easings_EASE_IN_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_BACK_instance;
}
function Easings_EASE_OUT_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_BACK_instance;
}
function Easings_EASE_IN_OUT_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_BACK_instance;
}
function Easings_EASE_OUT_IN_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_BACK_instance;
}
function Easings_EASE_IN_OUT_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_ELASTIC_instance;
}
function Easings_EASE_OUT_IN_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_ELASTIC_instance;
}
function Easings_EASE_IN_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_BOUNCE_instance;
}
function Easings_EASE_IN_OUT_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_BOUNCE_instance;
}
function Easings_EASE_OUT_IN_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_BOUNCE_instance;
}
function Easings_EASE_IN_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_QUAD_instance;
}
function Easings_EASE_OUT_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_QUAD_instance;
}
function Easings_EASE_IN_OUT_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_QUAD_instance;
}
function Easings_EASE_SINE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_SINE_instance;
}
function Easings_EASE_CLAMP_START_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_START_instance;
}
function Easings_EASE_CLAMP_END_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_END_instance;
}
function Easings_EASE_CLAMP_MIDDLE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_MIDDLE_instance;
}
function _ALL_LIST$factory() {
  return getPropertyCallableRef('_ALL_LIST', 0, KProperty0, function () {
    return get__ALL_LIST();
  }, null);
}
var properties_initialized_Easings_kt_w5y1uw;
function _init_properties_Easings_kt__swvzhy() {
  if (!properties_initialized_Easings_kt_w5y1uw) {
    properties_initialized_Easings_kt_w5y1uw = true;
    var tmp = LazyThreadSafetyMode_PUBLICATION_getInstance();
    _ALL_LIST$delegate = lazy_0(tmp, _ALL_LIST$delegate$lambda);
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    _ALL$delegate = lazy_0(tmp_0, _ALL$delegate$lambda);
  }
}
function get_niceStr_0(_this__u8e3s4) {
  return get_niceStr(Ratio__toDouble_impl_o7epze(_this__u8e3s4));
}
function interpolate_2(_this__u8e3s4, l, r) {
  return Companion_getInstance_2().d2a(l, r, _this__u8e3s4);
}
//region block: post-declaration
initMetadataForClass(IntSegmentSet, 'IntSegmentSet', IntSegmentSet);
initMetadataForClass(StrokePointsMode, 'StrokePointsMode');
initMetadataForClass(StrokePointsBuilder, 'StrokePointsBuilder');
initMetadataForClass(CurveInfo, 'CurveInfo');
initMetadataForClass(Curves, 'Curves');
protoOf(ProjectedPoint).d1i = isAlmostEquals$default;
initMetadataForClass(ProjectedPoint, 'ProjectedPoint', ProjectedPoint, VOID, [IsAlmostEquals]);
initMetadataForClass(Extrema, 'Extrema');
initMetadataForCompanion(Companion);
protoOf(Bezier).d1i = isAlmostEquals$default;
initMetadataForClass(Bezier, 'Bezier', Bezier.k3c, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(SubBezier, 'SubBezier');
initMetadataForClass(ClosestResult, 'ClosestResult');
initMetadataForClass(Estimation, 'Estimation', Estimation);
initMetadataForClass(CurveLUT, 'CurveLUT');
initMetadataForObject(Arc, 'Arc');
initMetadataForCompanion(Companion_1);
initMetadataForClass(ImageDoNotFitException, 'ImageDoNotFitException');
initMetadataForClass(BinPacker, 'BinPacker');
initMetadataForClass(MaxRects, 'MaxRects');
initMetadataForCompanion(Companion_2);
initMetadataForClass(HitTestDirection, 'HitTestDirection');
initMetadataForObject(Convex, 'Convex');
initMetadataForClass(AbstractShape2D, 'AbstractShape2D');
initMetadataForClass(BaseShape2D, 'BaseShape2D');
initMetadataForClass(CircleShape2D, 'CircleShape2D');
initMetadataForCompanion(Companion_3);
initMetadataForClass(SliceRotation, 'SliceRotation');
initMetadataForCompanion(Companion_4);
initMetadataForClass(SliceOrientation, 'SliceOrientation');
initMetadataForInterface(SliceCoords, 'SliceCoords');
initMetadataForInterface(SliceCoordsWithBase, 'SliceCoordsWithBase', VOID, VOID, [SliceCoords]);
initMetadataForInterface(SliceCoordsWithBaseAndRect, 'SliceCoordsWithBaseAndRect', VOID, VOID, [SliceCoordsWithBase]);
protoOf(RectSlice).t26 = get_left;
protoOf(RectSlice).v26 = get_top;
protoOf(RectSlice).u26 = get_right;
protoOf(RectSlice).w26 = get_bottom;
protoOf(RectSlice).y2f = get_area;
protoOf(RectSlice).l3i = get_frameOffsetX;
protoOf(RectSlice).m3i = get_frameOffsetY;
protoOf(RectSlice).n3i = x;
protoOf(RectSlice).o3i = y;
initMetadataForClass(RectSlice, 'RectSlice', VOID, VOID, [SliceCoordsWithBaseAndRect]);
initMetadataForCompanion(Companion_5);
protoOf(SliceCoordsImpl).l3i = get_frameOffsetX;
protoOf(SliceCoordsImpl).m3i = get_frameOffsetY;
protoOf(SliceCoordsImpl).n3i = x;
protoOf(SliceCoordsImpl).o3i = y;
initMetadataForClass(SliceCoordsImpl, 'SliceCoordsImpl', VOID, VOID, [SliceCoordsWithBase]);
protoOf(RectCoords).n3i = x;
protoOf(RectCoords).o3i = y;
initMetadataForClass(RectCoords, 'RectCoords', VOID, VOID, [SliceCoords]);
initMetadataForClass(Bucket, 'Bucket', Bucket);
initMetadataForClass(Buckets, 'Buckets');
initMetadataForClass(AllBuckets, 'AllBuckets', AllBuckets);
initMetadataForClass(XWithWind, 'XWithWind', XWithWind);
initMetadataForObject(IntArrayListSort, 'IntArrayListSort');
initMetadataForClass(RastScale, 'RastScale', RastScale);
initMetadataForClass(PolygonScanline, 'PolygonScanline', PolygonScanline);
initMetadataForCompanion(Companion_6);
initMetadataForCompanion(Companion_7);
initMetadataForClass(MEdge, 'MEdge', MEdge);
initMetadataForClass(EdgePoint, 'EdgePoint');
initMetadataForClass(StrokeToFill, 'StrokeToFill', StrokeToFill);
initMetadataForInterface(VectorBuilder, 'VectorBuilder');
protoOf(VectorBuilder$transformed$1).n3n = line;
protoOf(VectorBuilder$transformed$1).o3n = arcTo;
protoOf(VectorBuilder$transformed$1).g1 = isEmpty;
protoOf(VectorBuilder$transformed$1).p3n = rect;
protoOf(VectorBuilder$transformed$1).q3n = rect_0;
protoOf(VectorBuilder$transformed$1).r3n = rect_1;
protoOf(VectorBuilder$transformed$1).s3n = roundRect;
protoOf(VectorBuilder$transformed$1).t3n = arc;
protoOf(VectorBuilder$transformed$1).u3n = arc$default;
protoOf(VectorBuilder$transformed$1).j38 = circle;
protoOf(VectorBuilder$transformed$1).v3n = lineToH;
protoOf(VectorBuilder$transformed$1).w3n = lineToV;
protoOf(VectorBuilder$transformed$1).x3n = rLineToH;
protoOf(VectorBuilder$transformed$1).y3n = rLineToV;
protoOf(VectorBuilder$transformed$1).z3n = rMoveTo;
protoOf(VectorBuilder$transformed$1).a3o = rLineTo;
protoOf(VectorBuilder$transformed$1).n2f = transformed;
initMetadataForClass(VectorBuilder$transformed$1, VOID, VOID, VOID, [VectorBuilder]);
initMetadataForCompanion(Companion_8);
initMetadataForInterface(Visitor, 'Visitor');
protoOf(VectorPath).n3n = line;
protoOf(VectorPath).o3n = arcTo;
protoOf(VectorPath).g1 = isEmpty;
protoOf(VectorPath).m28 = isNotEmpty;
protoOf(VectorPath).p3n = rect;
protoOf(VectorPath).q3n = rect_0;
protoOf(VectorPath).r3n = rect_1;
protoOf(VectorPath).s3n = roundRect;
protoOf(VectorPath).b3o = roundRect_0;
protoOf(VectorPath).t3n = arc;
protoOf(VectorPath).u3n = arc$default;
protoOf(VectorPath).j38 = circle;
protoOf(VectorPath).v3n = lineToH;
protoOf(VectorPath).w3n = lineToV;
protoOf(VectorPath).x3n = rLineToH;
protoOf(VectorPath).g3o = rLineToH_0;
protoOf(VectorPath).y3n = rLineToV;
protoOf(VectorPath).h3o = rLineToV_0;
protoOf(VectorPath).z3n = rMoveTo;
protoOf(VectorPath).f3o = rMoveTo_0;
protoOf(VectorPath).a3o = rLineTo;
protoOf(VectorPath).e3o = rLineTo_0;
protoOf(VectorPath).n2f = transformed;
protoOf(VectorPath).i3o = transformed_0;
initMetadataForClass(VectorPath, 'VectorPath', VectorPath, VOID, [AbstractShape2D, VectorBuilder]);
protoOf(with$1).y5 = close;
protoOf(with$1).d3e = lineTo;
protoOf(with$1).e3e = quadTo_0;
protoOf(with$1).g3e = cubicTo;
initMetadataForClass(with$1, VOID, VOID, VOID, [Visitor]);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Winding, 'Winding');
initMetadataForCompanion(Companion_10);
initMetadataForClass(LineJoin, 'LineJoin');
initMetadataForCompanion(Companion_11);
initMetadataForClass(LineCap, 'LineCap');
initMetadataForClass(LineScaleMode, 'LineScaleMode');
initMetadataForCompanion(Companion_12);
initMetadataForClass(StrokeInfo, 'StrokeInfo', StrokeInfo);
initMetadataForCompanion(Companion_13);
protoOf(MPoint).d1i = isAlmostEquals$default;
initMetadataForClass(MPoint, 'MPoint', VOID, VOID, [Comparable, IsAlmostEquals]);
initMetadataForCompanion(Companion_14);
initMetadataForClass(MMatrix, 'MMatrix', MMatrix);
initMetadataForCompanion(Companion_15);
initMetadataForClass(MLine, 'MLine', MLine.x3p);
initMetadataForCompanion(Companion_16);
protoOf(MRectangle).d1i = isAlmostEquals$default;
initMetadataForClass(MRectangle, 'MRectangle', VOID, VOID, [IsAlmostEquals]);
protoOf(Easings).g1i = invoke;
protoOf(Easings).h1i = invoke_0;
initMetadataForClass(Easings, 'Easings', VOID, VOID, [Easing, Enum]);
initMetadataForClass(Easings$SMOOTH, 'SMOOTH');
initMetadataForClass(Easings$EASE_IN_ELASTIC, 'EASE_IN_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_ELASTIC, 'EASE_OUT_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_BOUNCE, 'EASE_OUT_BOUNCE');
initMetadataForClass(Easings$LINEAR, 'LINEAR');
initMetadataForClass(Easings$EASE, 'EASE');
initMetadataForClass(Easings$EASE_IN, 'EASE_IN');
initMetadataForClass(Easings$EASE_OUT, 'EASE_OUT');
initMetadataForClass(Easings$EASE_IN_OUT, 'EASE_IN_OUT');
initMetadataForClass(Easings$EASE_IN_OLD, 'EASE_IN_OLD');
initMetadataForClass(Easings$EASE_OUT_OLD, 'EASE_OUT_OLD');
initMetadataForClass(Easings$EASE_IN_OUT_OLD, 'EASE_IN_OUT_OLD');
initMetadataForClass(Easings$EASE_OUT_IN_OLD, 'EASE_OUT_IN_OLD');
initMetadataForClass(Easings$EASE_IN_BACK, 'EASE_IN_BACK');
initMetadataForClass(Easings$EASE_OUT_BACK, 'EASE_OUT_BACK');
initMetadataForClass(Easings$EASE_IN_OUT_BACK, 'EASE_IN_OUT_BACK');
initMetadataForClass(Easings$EASE_OUT_IN_BACK, 'EASE_OUT_IN_BACK');
initMetadataForClass(Easings$EASE_IN_OUT_ELASTIC, 'EASE_IN_OUT_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_IN_ELASTIC, 'EASE_OUT_IN_ELASTIC');
initMetadataForClass(Easings$EASE_IN_BOUNCE, 'EASE_IN_BOUNCE');
initMetadataForClass(Easings$EASE_IN_OUT_BOUNCE, 'EASE_IN_OUT_BOUNCE');
initMetadataForClass(Easings$EASE_OUT_IN_BOUNCE, 'EASE_OUT_IN_BOUNCE');
initMetadataForClass(Easings$EASE_IN_QUAD, 'EASE_IN_QUAD');
initMetadataForClass(Easings$EASE_OUT_QUAD, 'EASE_OUT_QUAD');
initMetadataForClass(Easings$EASE_IN_OUT_QUAD, 'EASE_IN_OUT_QUAD');
initMetadataForClass(Easings$EASE_SINE, 'EASE_SINE');
initMetadataForClass(Easings$EASE_CLAMP_START, 'EASE_CLAMP_START');
initMetadataForClass(Easings$EASE_CLAMP_END, 'EASE_CLAMP_END');
initMetadataForClass(Easings$EASE_CLAMP_MIDDLE, 'EASE_CLAMP_MIDDLE');
initMetadataForClass(P, 'P');
protoOf(EasingCubic).g1i = invoke;
protoOf(EasingCubic).h1i = invoke_0;
initMetadataForClass(EasingCubic, 'EasingCubic', VOID, VOID, [Easing]);
//endregion
//region block: init
Arc_instance = new Arc();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Convex_instance = new Convex();
Companion_instance_5 = new Companion_5();
Companion_instance_6 = new Companion_6();
Companion_instance_7 = new Companion_7();
Companion_instance_8 = new Companion_8();
Companion_instance_9 = new Companion_9();
Companion_instance_10 = new Companion_10();
Companion_instance_11 = new Companion_11();
Companion_instance_12 = new Companion_12();
Companion_instance_15 = new Companion_15();
//endregion
//region block: exports
export {
  StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance as StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance3u9930f4wm838,
  HitTestDirection_ANY_getInstance as HitTestDirection_ANY_getInstance1hlnrhgqmsigf,
  LineCap_BUTT_getInstance as LineCap_BUTT_getInstancetv7srcehoz43,
  LineJoin_MITER_getInstance as LineJoin_MITER_getInstance35lw9h64apo2h,
  LineScaleMode_NONE_getInstance as LineScaleMode_NONE_getInstance2mlqkio15xcm4,
  LineScaleMode_NORMAL_getInstance as LineScaleMode_NORMAL_getInstance1wxue9rdh6hry,
  Winding_EVEN_ODD_getInstance as Winding_EVEN_ODD_getInstancemyc10vdu2m52,
  Winding_NON_ZERO_getInstance as Winding_NON_ZERO_getInstance38kh1ikwl48ly,
  arc$default as arc$default4sjbw0e0mkug,
  _SliceOrientation___get_flipX__impl__lgb7bx as _SliceOrientation___get_flipX__impl__lgb7bx2vjjbyotgryi3,
  _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq as _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq2n27zigfr3r41,
  _SliceOrientation___get_rotation__impl__m65r0o as _SliceOrientation___get_rotation__impl__m65r0o2xos42p9chv89,
  Companion_getInstance_8 as Companion_getInstance154uzbkgf0e3s,
  Companion_instance_1 as Companion_instanceeeaudfwfrq87,
  Companion_instance_5 as Companion_instance2i0t7ux7bzoqc,
  Companion_getInstance_13 as Companion_getInstance2kfoysd3on6as,
  Companion_instance_11 as Companion_instance2kecexmga2w0q,
  Companion_instance_10 as Companion_instance1b5ldp3f3peqe,
  Companion_getInstance_22 as Companion_getInstance3d17rumlj92i7,
  ProjectedPoint as ProjectedPoint37gr1oedqap6n,
  get_isConvex as get_isConvex3nm4n5empqw0n,
  toBezier as toBezier1cphbqwqpx0d3,
  toStrokePointsList as toStrokePointsList2dojuc3rfktd4,
  ImageDoNotFitException as ImageDoNotFitException2gm4q4wt4lh58,
  get_cachedPoints as get_cachedPoints16ehjcv6uuio1,
  getPoints2List as getPoints2List1zux0vi6zk0wt,
  toShape2D as toShape2D2vgft60vvvqgq,
  RectSlice as RectSlicec5msorw5q4el,
  SliceOrientation as SliceOrientation5szkqzxt7oev,
  PolygonScanline as PolygonScanline1ccjpk6mqxyxd,
  RastScale as RastScale3rcmuinujik1d,
  StrokeInfo as StrokeInfo1cunqczl43ffk,
  StrokeToFill as StrokeToFill127v8ehrppf9e,
  arcTo as arcTo1g4ivunekrrtg,
  arc as arc1vjl2w7wqv39k,
  circle as circle1t8rrxfrm1ku9,
  ellipse as ellipse2rxvxxfaddo1k,
  isEmpty as isEmpty3b7xkdp0by4c8,
  lineToH as lineToHqj5ppmwlqa9l,
  lineToV as lineToV2af0qnj7t3mk2,
  line as line3u2mk0n2uhnlh,
  rLineToH as rLineToH2txnr065wfrbz,
  rLineToV as rLineToV3iwt0xj4dbrft,
  rLineTo as rLineTo1671hm1vy9pme,
  rMoveTo as rMoveTo38ittbd8h3wn5,
  rect as rect1tyihxx4629c2,
  rect_0 as rect31bppuugx2wch,
  rect_1 as rect3nqbmqh4a4l2a,
  roundRect as roundRect2sqmspzw5002d,
  roundRect_1 as roundRect3456nlcytya47,
  transformed as transformed2t6vo3srmaaf9,
  VectorBuilder as VectorBuilder2g8a28qau4ty9,
  VectorPath as VectorPath1chx1oqdw6sb9,
  applyTransform as applyTransform1vhqlmleb4dce,
  getCurves as getCurves2yjahbp68cxj3,
  plus as plus1r33v70e4ipd7,
  strokeToFill_0 as strokeToFill34bvxzbc34djp,
  strokeToFill as strokeToFill2j5wye7yyxd99,
  toCurvesList as toCurvesList2ibv2opnrpohn,
  write as write11msa0gyjblqp,
  MMatrix as MMatrix1y71lv7vv6y8t,
  get_immutable as get_immutablepxpdoj6e54ll,
  get_mutable as get_mutableqzgwrema46rx,
  toMatrix4 as toMatrix42ci5k1es0x1v1,
  get_EASE_CLAMP_END as get_EASE_CLAMP_END2i469hpc6wipw,
  get_EASE_CLAMP_START as get_EASE_CLAMP_START3mw7sc31t8amo,
  get_EASE_IN_OUT_QUAD as get_EASE_IN_OUT_QUAD21w3u6e1aoexb,
  cubic as cubic3uw6rftl1cilc,
  interpolate_2 as interpolate2729pk90l3f88,
  get as getusdytp2za0u2,
  IntSegmentSet as IntSegmentSet3br6yjcm9q2bd,
};
//endregion
